(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["antaro-anywhere-departures"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var CH = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    function flip(container, delay) {
      if (!container || reduce.matches) return;
      var target = (container.dataset.awFlaps || '').split('');
      var cells = Array.prototype.slice.call(container.children);
      var tick = 0;
      var start = Math.round((delay || 0) / 45);
      var timer = setInterval(function () {
        tick++;
        var done = true;
        cells.forEach(function (cell, i) {
          var settle = start + 6 + i * 2;
          var finalChar = target[i] && target[i] !== ' ' ? target[i] : ' ';
          if (tick >= settle) {
            if (cell.textContent !== finalChar) cell.textContent = finalChar;
            cell.classList.remove('is-moving');
          } else {
            done = false;
            if (tick >= start) {
              cell.textContent = CH.charAt((tick * 7 + i * 13) % CH.length);
              cell.classList.add('is-moving');
            }
          }
        });
        if (done) clearInterval(timer);
      }, 45);
    }

    function init(root) {
      if (root.dataset.awReady) return;
      root.dataset.awReady = '1';

      var rows = Array.prototype.slice.call(root.querySelectorAll('[data-aw-row]'));
      var body = root.querySelector('[data-aw-pass-body]');
      var stamp = root.querySelector('[data-aw-stamp]');
      var pass = root.querySelector('.aw-dep__pass');
      var scroller = root.querySelector('[data-aw-scroll]');
      var scrim = root.querySelector('[data-aw-scrim]');
      var jumps = Array.prototype.slice.call(root.querySelectorAll('[data-aw-jump]'));
      var countEl = root.querySelector('[data-aw-count]');
      var prevName = root.querySelector('[data-aw-prev-name]');
      var nextName = root.querySelector('[data-aw-next-name]');
      var stubFlight = root.querySelector('[data-aw-stub-flight]');
      var stubGate = root.querySelector('[data-aw-stub-gate]');
      var cartLine = root.querySelector('[data-aw-cartline]');
      var cartText = root.querySelector('[data-aw-cart-text]');
      var currency = (pass && pass.dataset.currency) || 'GBP';
      var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
      var sheetMq = window.matchMedia('(max-width: 989px)');
      var cur = 0;
      var cartState = null;
      var lastFocus = null;
      if (!rows.length || !body) return;
      var n = rows.length;

      function money(cents) {
        try { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: currency }).format(cents / 100); }
        catch (e) { return '£' + (cents / 100).toFixed(2); }
      }

      /* ---------- sheet (phones and tablets) ---------- */
      function isOpen() { return root.classList.contains('is-open'); }
      function openSheet() {
        if (!sheetMq.matches || isOpen()) return;
        lastFocus = document.activeElement;
        if (scrim) scrim.hidden = false;
        // force a layout so the slide-up transition runs from the closed position
        void pass.offsetWidth;
        root.classList.add('is-open');
        document.documentElement.style.overflow = 'hidden';
        pass.setAttribute('role', 'dialog');
        pass.setAttribute('aria-modal', 'true');
        if (scroller) scroller.scrollTop = 0;
        var c = root.querySelector('[data-aw-close]');
        setTimeout(function () { if (c) c.focus({ preventScroll: true }); }, 60);
      }
      function closeSheet() {
        if (!isOpen()) return;
        root.classList.remove('is-open');
        document.documentElement.style.overflow = '';
        pass.removeAttribute('role');
        pass.removeAttribute('aria-modal');
        setTimeout(function () { if (scrim && !isOpen()) scrim.hidden = true; }, 320);
        var back = rows[cur] || lastFocus;
        if (back && back.focus) back.focus({ preventScroll: true });
      }
      if (scrim) scrim.addEventListener('click', closeSheet);
      var closeBtn = root.querySelector('[data-aw-close]');
      if (closeBtn) closeBtn.addEventListener('click', closeSheet);
      var onMq = function () { if (!sheetMq.matches && isOpen()) closeSheet(); };
      if (sheetMq.addEventListener) sheetMq.addEventListener('change', onMq); else if (sheetMq.addListener) sheetMq.addListener(onMq);

      /* ---------- selecting a tin ---------- */
      function select(i, animate, fromTap) {
        cur = (i + n) % n;
        rows.forEach(function (r, k) {
          var on = k === cur;
          r.classList.toggle('is-selected', on);
          r.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        jumps.forEach(function (b, k) { b.setAttribute('aria-pressed', k === cur ? 'true' : 'false'); });
        var tpl = root.querySelector('template[data-aw-pass="' + cur + '"]');
        if (!tpl) return;
        body.innerHTML = '';
        body.appendChild(tpl.content.cloneNode(true));
        if (stamp) stamp.classList.remove('is-on');
        if (animate) flip(body.querySelector('[data-aw-flaps]'), 0);
        var r = rows[cur];
        if (countEl) countEl.textContent = (cur + 1) + ' of ' + n;
        if (prevName) prevName.textContent = rows[(cur - 1 + n) % n].dataset.awName || '';
        if (nextName) nextName.textContent = rows[(cur + 1) % n].dataset.awName || '';
        if (stubFlight) stubFlight.textContent = r.dataset.awFlight || '';
        if (stubGate) stubGate.textContent = r.dataset.awGate || '';
        var activeJump = jumps[cur];
        if (activeJump && activeJump.scrollIntoView && isOpen()) {
          try { activeJump.scrollIntoView({ block: 'nearest', inline: 'center', behavior: reduce.matches ? 'auto' : 'smooth' }); } catch (e) {}
        }
        bindBuy();
        renderBuy();
        if (window.antaroLiveFill) window.antaroLiveFill(body);
        if (scroller && isOpen()) scroller.scrollTop = 0;
        if (fromTap) openSheet();
      }
      function step(d) { select(cur + d, true, false); }

      root.querySelectorAll('[data-aw-step]').forEach(function (b) {
        b.addEventListener('click', function () { step(Number(b.dataset.awStep)); });
      });
      jumps.forEach(function (b) {
        b.addEventListener('click', function () { select(Number(b.dataset.awJump), true, false); });
      });

      /* ---------- add to cart, − / + counter ---------- */
      function lineFor(variantId) {
        if (!cartState || !cartState.items) return null;
        for (var k = 0; k < cartState.items.length; k++) {
          if (String(cartState.items[k].variant_id) === String(variantId)) return cartState.items[k];
        }
        return null;
      }
      function renderBuy() {
        var btn = body.querySelector('[data-aw-add]');
        var stepper = body.querySelector('[data-aw-stepper]');
        if (!btn || !stepper) return;
        var line = lineFor(stepper.dataset.variantId);
        var q = line ? line.quantity : 0;
        btn.hidden = q > 0;
        stepper.hidden = q === 0;
        var txt = stepper.querySelector('[data-aw-qty-text]');
        if (txt) txt.textContent = q + ' in your cart';
        var max = Number(stepper.dataset.max || 0);
        var plus = stepper.querySelector('[data-aw-qty="1"]');
        if (plus) plus.disabled = max > 0 && q >= max;
      }
      function announce(cart, variantId) {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, sourceId: 'aw-departures', data: { source: 'aw-departures', itemCount: cart.item_count, variantId: variantId } }
        }));
      }
      function getCart() {
        return fetch(routeRoot + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (res) { return res.json(); });
      }
      function showError(msg) {
        var error = body.querySelector('[data-aw-error]');
        if (error) { error.textContent = msg || 'Something went wrong. Please try again.'; error.hidden = false; }
      }
      function bindBuy() {
        var btn = body.querySelector('[data-aw-add]');
        if (btn) {
          btn.addEventListener('click', function () {
            var error = body.querySelector('[data-aw-error]');
            btn.classList.add('is-loading');
            if (error) error.hidden = true;
            fetch(routeRoot + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: Number(btn.dataset.awAdd), quantity: 1 }] })
            })
              .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
              .then(function (r) {
                btn.classList.remove('is-loading');
                if (!r.ok) throw new Error((r.data && (r.data.description || r.data.message)) || 'Could not add to cart.');
                if (stamp) stamp.classList.add('is-on');
                return getCart().then(function (cart) { markCart(cart); announce(cart, btn.dataset.awAdd); });
              })
              .catch(function (err) { btn.classList.remove('is-loading'); showError(err.message || 'Could not add to cart. Please try again.'); });
          });
        }
        var stepper = body.querySelector('[data-aw-stepper]');
        if (stepper) {
          stepper.querySelectorAll('[data-aw-qty]').forEach(function (b) {
            b.addEventListener('click', function () {
              var line = lineFor(stepper.dataset.variantId);
              if (!line) return;
              var q = Math.max(0, line.quantity + Number(b.dataset.awQty));
              stepper.classList.add('is-loading');
              fetch(routeRoot + 'cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ id: line.key, quantity: q })
              })
                .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
                .then(function (r) {
                  stepper.classList.remove('is-loading');
                  if (!r.ok) throw new Error((r.data && (r.data.description || r.data.message)) || 'Could not update your cart.');
                  if (q === 0 && stamp) stamp.classList.remove('is-on');
                  markCart(r.data); announce(r.data, stepper.dataset.variantId);
                })
                .catch(function (err) { stepper.classList.remove('is-loading'); showError(err.message); });
            });
          });
        }
      }

      /* ---------- "In your cart" ticks, counter and total, kept in step with the live cart ---------- */
      function markCart(cart) {
        if (!cart || !cart.items) return;
        cartState = cart;
        var ids = cart.items.map(function (it) { return String(it.product_id); });
        rows.forEach(function (r, k) {
          if (!r.dataset.productId) return;
          var inCart = ids.indexOf(r.dataset.productId) !== -1;
          r.classList.toggle('is-in-cart', inCart);
          if (jumps[k]) jumps[k].classList.toggle('is-in-cart', inCart);
        });
        if (cartLine && cartText) {
          if (cart.item_count > 0) {
            cartText.textContent = cart.item_count + ' in cart · ' + money(cart.total_price);
            cartLine.hidden = false;
          } else {
            cartLine.hidden = true;
          }
        }
        renderBuy();
      }
      function refreshCart() {
        if (!window.fetch) return;
        getCart().then(markCart).catch(function () {});
      }
      document.addEventListener('cart:update', function (e) {
        var d = e.detail || {};
        if (d.sourceId === 'aw-departures') return;
        if (d.resource && d.resource.items) markCart(d.resource); else refreshCart();
      });
      window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(); });

      /* ---------- board rows, arrow keys, swipe ---------- */
      rows.forEach(function (r) {
        r.addEventListener('click', function () { select(Number(r.dataset.awRow), true, true); });
      });
      root.addEventListener('keydown', function (e) {
        var tag = (e.target && e.target.tagName) || '';
        if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return;
        if (e.key === 'Escape' && isOpen()) { closeSheet(); return; }
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          if (!pass.contains(e.target) && !e.target.closest('.aw-dep__board')) return;
          e.preventDefault();
          step(e.key === 'ArrowRight' ? 1 : -1);
          if (!isOpen() && rows[cur] && e.target.closest('.aw-dep__board')) rows[cur].focus({ preventScroll: true });
        }
      });
      if (scroller && 'ontouchstart' in window) {
        var sx = 0, sy = 0, tracking = false, fromGrab = false;
        scroller.addEventListener('touchstart', function (e) {
          if (e.touches.length !== 1) { tracking = false; return; }
          tracking = true; sx = e.touches[0].clientX; sy = e.touches[0].clientY;
          fromGrab = !!(e.target.closest('[data-aw-grab]') || e.target.closest('.aw-dep__pass-top'));
        }, { passive: true });
        scroller.addEventListener('touchend', function (e) {
          if (!tracking || !isOpen()) return;
          tracking = false;
          var t = e.changedTouches[0];
          var dx = t.clientX - sx, dy = t.clientY - sy;
          if (e.target.closest('.aw-dep__jump')) return;
          if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) { step(dx < 0 ? 1 : -1); return; }
          if (dy > 70 && Math.abs(dy) > Math.abs(dx) * 1.5 && (fromGrab || scroller.scrollTop <= 0)) closeSheet();
        }, { passive: true });
      }

      // Arriving from a candle page (#reset): select that tin and bring its row into view.
      var start = Number(root.dataset.default || 0);
      var hash = '';
      try { hash = decodeURIComponent(location.hash.replace('#', '')); } catch (e) {}
      var hashRow = null;
      if (hash) {
        rows.forEach(function (r) {
          var li = r.closest('[data-handle]');
          if (li && li.dataset.handle === hash) { hashRow = r; start = Number(r.dataset.awRow); }
        });
      }
      select(start, false, false);
      refreshCart();
      if (hashRow) {
        setTimeout(function () { hashRow.scrollIntoView({ behavior: reduce.matches ? 'auto' : 'smooth', block: 'center' }); }, 250);
      }

      // Flip the board when it comes into view
      var board = root.querySelector('.aw-dep__board');
      if (!reduce.matches && 'IntersectionObserver' in window && board) {
        var io = new IntersectionObserver(function (entries) {
          if (!entries[0].isIntersecting) return;
          io.disconnect();
          root.querySelectorAll('.aw-dep__rows [data-aw-flaps]').forEach(function (el, k) {
            flip(el, Math.floor(k / 2) * 300 + (k % 2) * 450);
          });
          flip(body.querySelector('[data-aw-flaps]'), 1500);
        }, { threshold: 0.25 });
        io.observe(board);
      }

      // London clock
      var clock = root.querySelector('[data-aw-clock]');
      if (clock) {
        var setTime = function () {
          try { clock.textContent = new Date().toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', timeZone: 'Europe/London' }); } catch (e) {}
        };
        setTime();
        setInterval(setTime, 15000);
      }
    }

    function boot() { document.querySelectorAll('[data-aw-dep]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["antaro-anywhere-discover"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function boot() {
      document.querySelectorAll('.aw-discover').forEach(function (root) {
        if (root.dataset.awReady) return;
        root.dataset.awReady = '1';
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
        root.classList.add('aw-js');
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry, i) {
            if (!entry.isIntersecting) return;
            var el = entry.target;
            setTimeout(function () { el.classList.add('is-in'); }, (i % 6) * 70);
            io.unobserve(el);
          });
        }, { rootMargin: '0px 0px -6% 0px', threshold: 0.1 });
        root.querySelectorAll('[data-aw-reveal]').forEach(function (el) { io.observe(el); });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["antaro-anywhere-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    function initVideo(root) {
      var wrap = root.querySelector('[data-aw-video]');
      if (!wrap) return;
      var video = wrap.querySelector('video');
      if (!video) return;
      function apply() {
        if (reduce.matches) {
          video.pause();
          wrap.hidden = true;
          return;
        }
        video.muted = true;
        var p = video.play();
        if (p && p.then) {
          p.then(function () { wrap.hidden = false; }).catch(function () { wrap.hidden = true; });
        } else {
          wrap.hidden = false;
        }
      }
      if (reduce.addEventListener) reduce.addEventListener('change', apply);
      apply();
    }

    function initScroll(root) {
      root.querySelectorAll('[data-aw-scroll]').forEach(function (link) {
        link.addEventListener('click', function (event) {
          var hash = link.getAttribute('href');
          if (!hash || hash.charAt(0) !== '#') return;
          var target = document.querySelector(hash);
          if (!target) return;
          event.preventDefault();
          target.scrollIntoView({ behavior: reduce.matches ? 'auto' : 'smooth', block: 'start' });
          if (history.replaceState) history.replaceState(null, '', hash);
          var focusable = target.querySelector('[data-aw-focus]') || target;
          focusable.setAttribute('tabindex', '-1');
          focusable.focus({ preventScroll: true });
        });
      });
    }

    function initDepth(root) {
      if (reduce.matches) return;
      var ticking = false;
      var visible = true;
      function update() {
        ticking = false;
        var rect = root.getBoundingClientRect();
        var p = rect.height ? Math.min(Math.max(-rect.top / rect.height, 0), 1) : 0;
        root.style.setProperty('--aw-p', p.toFixed(3));
      }
      function onScroll() {
        if (!visible || ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          visible = entries[0].isIntersecting;
          if (visible) onScroll();
        }).observe(root);
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      update();
    }

    function init() {
      document.querySelectorAll('.antaro-anywhere-hero').forEach(function (root) {
        if (root.dataset.awReady) return;
        root.dataset.awReady = '1';
        initVideo(root);
        initScroll(root);
        initDepth(root);
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["antaro-anywhere-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.awReady) return;
      root.dataset.awReady = '1';

      // Gallery: thumbnails, arrows, swipe, tap to enlarge
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-aw-slide]'));
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-aw-thumb]'));
      var count = root.querySelector('[data-aw-count]');
      var current = 0;
      function show(i) {
        if (!slides.length) return;
        current = (i + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === current); });
        thumbs.forEach(function (t, k) {
          t.classList.toggle('is-active', k === current);
          t.setAttribute('aria-selected', k === current ? 'true' : 'false');
        });
        if (count) count.textContent = (current + 1) + ' / ' + slides.length;
      }
      thumbs.forEach(function (thumb, k) { thumb.addEventListener('click', function () { show(k); }); });
      var prev = root.querySelector('[data-aw-prev]');
      var next = root.querySelector('[data-aw-next]');
      if (prev) prev.addEventListener('click', function () { show(current - 1); });
      if (next) next.addEventListener('click', function () { show(current + 1); });

      function swipe(el, onLeft, onRight) {
        var x0 = null, y0 = null;
        el.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
        el.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0;
          var dy = e.changedTouches[0].clientY - y0;
          x0 = null;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) {
            el.dataset.awSwiped = '1';
            setTimeout(function () { delete el.dataset.awSwiped; }, 350);
            if (dx < 0) onLeft(); else onRight();
          }
        }, { passive: true });
      }
      var gallery = root.querySelector('[data-aw-gallery]');
      if (gallery && slides.length > 1) swipe(gallery, function () { show(current + 1); }, function () { show(current - 1); });

      var lb = root.querySelector('[data-aw-lightbox]');
      if (lb && typeof lb.showModal === 'function') {
        var lbImg = lb.querySelector('[data-aw-lb-img]');
        var lbCount = lb.querySelector('[data-aw-lb-count]');
        var lbShow = function (i) {
          show(i);
          var s = slides[current];
          lbImg.src = s.dataset.awFull;
          lbImg.alt = s.dataset.awAlt || '';
          if (lbCount) lbCount.textContent = (current + 1) + ' / ' + slides.length;
        };
        root.querySelectorAll('[data-aw-zoom]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            if (gallery && gallery.dataset.awSwiped) return;
            lbShow(current);
            lb.showModal();
          });
        });
        lb.querySelector('[data-aw-lb-close]').addEventListener('click', function () { lb.close(); });
        var lp = lb.querySelector('[data-aw-lb-prev]');
        var ln = lb.querySelector('[data-aw-lb-next]');
        if (lp) lp.addEventListener('click', function () { lbShow(current - 1); });
        if (ln) ln.addEventListener('click', function () { lbShow(current + 1); });
        lb.addEventListener('keydown', function (e) {
          if (slides.length < 2) return;
          if (e.key === 'ArrowLeft') { e.preventDefault(); lbShow(current - 1); }
          if (e.key === 'ArrowRight') { e.preventDefault(); lbShow(current + 1); }
        });
        lb.addEventListener('click', function (e) { if (e.target === lb) lb.close(); });
        if (slides.length > 1) swipe(lb, function () { lbShow(current + 1); }, function () { lbShow(current - 1); });
      }

      // Quantity stepper, clamped to available stock
      var input = root.querySelector('.aw-pdp__qty-input');
      var minus = root.querySelector('[data-aw-step="-1"]');
      var plus = root.querySelector('[data-aw-step="1"]');
      function clamp() {
        if (!input) return;
        var max = parseInt(input.max, 10);
        var v = parseInt(input.value, 10);
        if (isNaN(v) || v < 1) v = 1;
        if (!isNaN(max) && v > max) v = max;
        input.value = v;
        if (minus) minus.disabled = input.disabled || v <= 1;
        if (plus) plus.disabled = input.disabled || (!isNaN(max) && v >= max);
      }
      root.querySelectorAll('[data-aw-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          input.value = (parseInt(input.value, 10) || 1) + parseInt(btn.dataset.awStep, 10);
          clamp();
        });
      });
      if (input) { input.addEventListener('change', clamp); clamp(); }

      // Variant select (multi-variant products)
      var select = root.querySelector('[data-aw-variant]');
      if (select) {
        select.addEventListener('change', function () {
          var opt = select.options[select.selectedIndex];
          var price = root.querySelector('[data-aw-price]');
          if (price) price.textContent = opt.dataset.price;
          if (input) { if (opt.dataset.max) input.max = opt.dataset.max; else input.removeAttribute('max'); }
          clamp();
        });
      }

      // Add to cart stays on the page (cart AJAX, like Core): confirmation plus the next departure.
      // Without fetch the form posts to /cart/add as before.
      var form = root.querySelector('#aw-pdp-form');
      var done = root.querySelector('[data-aw-done]');
      var errorEl = root.querySelector('[data-aw-add-error]');
      var tins = null;
      try { tins = JSON.parse((root.querySelector('[data-aw-tins]') || {}).textContent || 'null'); } catch (e) { tins = null; }
      var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';

      function render(cart, justAdded) {
        if (!done || !cart || !cart.items) return;
        var ids = cart.items.map(function (it) { return it.product_id; });
        var inCart = tins ? ids.indexOf(tins.current) !== -1 : justAdded;
        var c = done.querySelector('[data-aw-cart-count]');
        if (c) c.textContent = cart.item_count;
        if (tins && tins.tins) {
          var list = tins.tins, at = -1, next = null;
          for (var k = 0; k < list.length; k++) { if (list[k].id === tins.current) at = k; }
          for (var n = 1; n <= list.length; n++) {
            var t = list[(at + n + list.length) % list.length];
            if (!t || t.id === tins.current || !t.available || ids.indexOf(t.id) !== -1) continue;
            next = t; break;
          }
          var a = done.querySelector('[data-aw-next-link]');
          var txt = done.querySelector('[data-aw-next-text]');
          if (a && txt) {
            if (next) { a.href = next.url; txt.textContent = a.dataset.nextPrefix + ': ' + next.name; }
            else { a.href = a.dataset.returnHref; txt.textContent = a.dataset.returnText; }
          }
        }
        var wasHidden = done.hidden;
        done.hidden = !inCart;
        if (justAdded && wasHidden && inCart) {
          var r = done.getBoundingClientRect();
          if (r.top < 0 || r.bottom > window.innerHeight) {
            done.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
          }
        }
      }
      function refresh() {
        if (!window.fetch) return;
        fetch(cartRoot + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (res) { return res.json(); })
          .then(function (cart) { render(cart, false); })
          .catch(function () {});
      }

      if (form) {
        form.addEventListener('submit', function (e) {
          var buttons = root.querySelectorAll('[data-aw-add], .aw-pdp__add--compact');
          buttons.forEach(function (b) { b.classList.add('is-loading'); });
          if (!window.fetch || !window.FormData) return;
          e.preventDefault();
          if (errorEl) errorEl.hidden = true;
          fetch(cartRoot + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
            .then(function (res) {
              return res.json().catch(function () { return {}; }).then(function (data) {
                if (!res.ok) { var err = new Error((data && (data.description || data.message)) || ''); err.shown = res.status === 422; throw err; }
                return fetch(cartRoot + 'cart.js', { headers: { Accept: 'application/json' } });
              });
            })
            .then(function (res) { return res.json(); })
            .then(function (cart) {
              document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'aw-pdp', data: { source: 'aw-pdp', itemCount: cart.item_count } } }));
              render(cart, true);
              buttons.forEach(function (b) {
                b.classList.remove('is-loading');
                if (!b.dataset.label) b.dataset.label = b.textContent;
                b.textContent = done ? (done.dataset.added || b.dataset.label) : b.dataset.label;
              });
              setTimeout(function () { buttons.forEach(function (b) { b.textContent = b.dataset.label; }); }, 2400);
            })
            .catch(function (err) {
              buttons.forEach(function (b) { b.classList.remove('is-loading'); });
              if (err && err.shown && err.message && errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; return; }
              form.submit();
            });
        });
      }

      // Keep the in-cart state honest when the cart changes elsewhere (drawer) or the page is restored from history.
      document.addEventListener('cart:update', function (e) {
        var d = e.detail || {};
        if (d.sourceId === 'aw-pdp') return;
        if (d.resource && d.resource.items) render(d.resource, false); else refresh();
      });
      window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

      // Sticky Add to cart once the main button is out of view
      var sticky = root.querySelector('[data-aw-sticky]');
      var main = root.querySelector('[data-aw-add]');
      if (sticky && main && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          var show = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', show);
          if (show) { sticky.removeAttribute('inert'); sticky.setAttribute('aria-hidden', 'false'); }
          else { sticky.setAttribute('inert', ''); sticky.setAttribute('aria-hidden', 'true'); }
        }).observe(main);
      }
    }

    function boot() { document.querySelectorAll('.aw-pdp').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["antaro-anywhere-scents"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      document.querySelectorAll('.antaro-anywhere-scents').forEach(function (root) {
        if (root.dataset.awReady) return;
        root.dataset.awReady = '1';

        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (!reduce && 'IntersectionObserver' in window) {
          root.classList.add('aw-js');
          var reveal = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry, i) {
              if (!entry.isIntersecting) return;
              var el = entry.target;
              setTimeout(function () { el.classList.add('is-in'); }, (i % 3) * 120);
              reveal.unobserve(el);
            });
          }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
          root.querySelectorAll('[data-aw-reveal]').forEach(function (el) { reveal.observe(el); });
        }

        var links = Array.prototype.slice.call(root.querySelectorAll('[data-aw-index]'));
        links.forEach(function (link) {
          link.addEventListener('click', function (event) {
            var target = document.getElementById('aw-' + link.dataset.awIndex);
            if (!target) return;
            event.preventDefault();
            target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
          });
        });

        if ('IntersectionObserver' in window && links.length) {
          var spy = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              var id = entry.target.dataset.awCard;
              links.forEach(function (l) { l.classList.toggle('is-active', l.dataset.awIndex === id); });
            });
          }, { rootMargin: '-45% 0px -50% 0px' });
          root.querySelectorAll('[data-aw-card]').forEach(function (card) { spy.observe(card); });
        }
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["antaro-atelier-concierge"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function boot(root) {
      if (!root || root.dataset.acReady) return;
      root.dataset.acReady = '1';
      document.body.classList.add('at-page');

      var steps = root.querySelectorAll('[data-ac-step]');
      var picks = root.querySelectorAll('[data-ac-pick]');
      var restart = root.querySelector('[data-ac-restart]');
      var also = root.querySelector('[data-ac-also]');
      var alsoText = root.querySelector('[data-ac-also-text]');
      var alsoLink = root.querySelector('[data-ac-also-link]');
      var base = { lounge: root.dataset.lounge || '/pages/scents?view=atelier-lounge', suites: root.dataset.suites || '/pages/scents?view=atelier-suites' };
      var format = null;

      function step(n) { return root.querySelector('[data-ac-step="' + n + '"]'); }
      function show(n) {
        var s = step(n); if (!s) return;
        s.hidden = false; s.classList.add('is-on'); s.classList.remove('is-done');
        if (!(window.Shopify && Shopify.designMode)) {
          setTimeout(function () { s.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 80);
        }
      }
      function press(group, btn) {
        group.querySelectorAll('.ac-opt').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
      }
      function reset() {
        format = null;
        steps.forEach(function (s, i) { s.classList.remove('is-done'); if (i > 0) { s.hidden = true; s.classList.remove('is-on'); } });
        root.querySelectorAll('.ac-opt').forEach(function (b) { b.removeAttribute('aria-pressed'); });
        picks.forEach(function (p) { p.hidden = true; });
        if (also) also.hidden = true;
        if (restart) restart.hidden = true;
        var first = root.querySelector('[data-ac-format]'); if (first) first.focus({ preventScroll: true });
      }

      root.querySelectorAll('[data-ac-format]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          format = btn.dataset.acFormat;
          press(step(1), btn); step(1).classList.add('is-done');
          step(3).hidden = true; picks.forEach(function (p) { p.hidden = true; });
          root.querySelectorAll('[data-ac-scent]').forEach(function (b) { b.removeAttribute('aria-pressed'); });
          step(2).classList.remove('is-done');
          show(2);
          if (restart) restart.hidden = false;
        });
      });

      root.querySelectorAll('[data-ac-scent]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!format) return;
          var i = btn.dataset.acScent;
          press(step(2), btn); step(2).classList.add('is-done');
          var other = format === 'lounge' ? 'suites' : 'lounge';
          picks.forEach(function (p) {
            var on = p.dataset.acPick === i; p.hidden = !on;
            if (!on) return;
            var tag = p.querySelector('[data-ac-tag]'); if (tag) tag.textContent = tag.dataset[format];
            var go = p.querySelector('[data-ac-go]');
            if (go) { go.href = base[format] + '#' + p.dataset.handle; go.firstChild.nodeValue = go.dataset[format] + ' '; }
            if (also && alsoText && alsoLink && alsoText.dataset[other]) {
              alsoText.textContent = alsoText.dataset[other];
              alsoLink.href = base[other] + '#' + p.dataset.handle;
              alsoLink.textContent = p.querySelector('.ac-pick__name').textContent;
              also.hidden = false;
            }
          });
          show(3);
        });
      });

      if (restart) restart.addEventListener('click', reset);
    }
    function all() { document.querySelectorAll('.ac').forEach(boot); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
    document.addEventListener('shopify:section:load', function (e) { boot(e.target.querySelector('.ac')); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["antaro-atelier-list"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function boot(root) {
      if (!root || root.dataset.apReady) return;
      root.dataset.apReady = '1';
      document.body.classList.add('at-page');

      var form = root.querySelector('form');
      if (!form) return;
      var welcome = root.querySelector('[data-ap-welcome]');
      var done = root.querySelector('[data-ap-done]');
      var email = root.querySelector('[data-ap-email]');
      var nameEl = root.querySelector('[data-ap-name]');
      var tags = root.querySelector('[data-ap-tags]');
      var err = root.querySelector('[data-ap-error]');
      var btn = root.querySelector('[data-ap-submit]');
      var baseTag = tags ? tags.value : 'atelier-list';

      // Returning from Shopify's form post (it adds customer_posted=true)
      if (/[?&]customer_posted=true/.test(location.search) && welcome && done) {
        welcome.hidden = true; done.hidden = false; done.focus({ preventScroll: true });
      }

      function interest() {
        var r = root.querySelector('[data-ap-interest]:checked');
        return r ? r.value : 'both';
      }

      function toKlaviyo(addr, first, pick) {
        var company = root.dataset.kCompany, list = root.dataset.kList;
        if (!company || !list || !window.fetch) return Promise.resolve();
        var attrs = {
          email: addr,
          properties: { 'Atelier interest': pick, 'Atelier source': root.dataset.kSource || 'Atelier private list' },
          subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
        };
        if (first) attrs.first_name = first;
        var body = { data: { type: 'subscription', attributes: { custom_source: root.dataset.kSource || 'Atelier private list', profile: { data: { type: 'profile', attributes: attrs } } },
          relationships: { list: { data: { type: 'list', id: list } } } } };
        var req = fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' }, body: JSON.stringify(body), keepalive: true
        }).catch(function () {});
        var timeout = new Promise(function (res) { setTimeout(res, 3500); });
        return Promise.race([req, timeout]);
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var addr = (email.value || '').trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(addr)) {
          err.textContent = err.dataset.msg || 'Please enter a valid email address.';
          err.hidden = false; email.setAttribute('aria-invalid', 'true'); email.focus();
          return;
        }
        email.removeAttribute('aria-invalid'); err.hidden = true;
        var pick = interest();
        if (tags) tags.value = baseTag + (pick === 'travel' ? ', atelier-travel' : pick === 'home' ? ', atelier-home' : ', atelier-travel, atelier-home');
        if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
        if (window.Shopify && Shopify.designMode) { if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; } return; }
        toKlaviyo(addr, (nameEl && nameEl.value || '').trim(), pick).then(function () {
          HTMLFormElement.prototype.submit.call(form);
        });
      });
    }
    function all() { document.querySelectorAll('.ap').forEach(boot); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
    document.addEventListener('shopify:section:load', function (e) { boot(e.target.querySelector('.ap')); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["antaro-atelier-lounge"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function boot(root) {
      if (!root || root.dataset.alReady) return;
      root.dataset.alReady = '1';
      document.body.classList.add('al-page');
      var seats = Array.prototype.slice.call(root.querySelectorAll('[data-al-seat]'));
      var cards = root.querySelectorAll('[data-al-card]');
      function pick(i, focus) {
        seats.forEach(function (s, n) {
          var on = n === i;
          s.classList.toggle('is-on', on);
          s.setAttribute('aria-selected', on ? 'true' : 'false');
          s.tabIndex = on ? 0 : -1;
          if (cards[n]) cards[n].hidden = !on;
        });
        if (focus) seats[i].focus();
        if (!(window.Shopify && Shopify.designMode) && history.replaceState) history.replaceState(null, '', location.pathname + location.search + '#' + seats[i].dataset.handle);
      }
      seats.forEach(function (s, n) {
        s.addEventListener('click', function () { pick(n); });
        s.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { e.preventDefault(); pick(Math.min(seats.length - 1, n + 1), true); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); pick(Math.max(0, n - 1), true); }
        });
      });
      var h = location.hash.replace('#', '');
      var start = 0;
      seats.forEach(function (s, n) { if (h && s.dataset.handle === h) start = n; });
      if (seats.length) pick(start);

      root.querySelectorAll('[data-al-form]').forEach(function (f) {
        f.addEventListener('submit', function (e) {
          e.preventDefault();
          var btn = f.querySelector('[data-al-add]'); btn.disabled = true;
          fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: +f.querySelector('[name=id]').value, quantity: 1 }] })
          }).then(function (r) { if (!r.ok) throw new Error('add'); return fetch('/cart.js'); })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              btn.textContent = btn.dataset.done;
              var card = f.closest('[data-al-card]'); if (card) card.classList.add('is-seated');
              document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: root.id, data: { itemCount: cart.item_count } } }));
            })
            .catch(function () { btn.disabled = false; btn.textContent = btn.dataset.label; });
        });
      });
    }
    function all() { document.querySelectorAll('.al').forEach(boot); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
    document.addEventListener('shopify:section:load', function (e) { boot(e.target.querySelector('.al')); });
  })();

  (function () {
    function greet() {
      document.querySelectorAll('[data-al-greet]').forEach(function (h) {
        var hr = new Date().getHours();
        var part = hr >= 5 && hr < 12 ? 'Good morning' : (hr >= 12 && hr < 17 ? 'Good afternoon' : 'Good evening');
        h.textContent = part + ', ' + h.getAttribute('data-name') + '.';
      });
    }
    function door() {
      var d = document.querySelector('[data-al-door]');
      if (!d || d.dataset.ready) return;
      d.dataset.ready = '1';
      var seen = false;
      try { seen = sessionStorage.getItem('al-door') === '1'; } catch (e) {}
      if (seen || (window.Shopify && Shopify.designMode)) { d.parentNode.removeChild(d); return; }
      if (d.parentNode !== document.body) document.body.appendChild(d);
      d.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      var btn = d.querySelector('[data-al-hold]');
      var ring = d.querySelector('[data-al-ring]');
      var C = 276.5, need = 900, t0 = 0, raf = 0, done = false;
      var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      function set(p) { ring.style.strokeDashoffset = String(C * (1 - p)); }
      function open() {
        if (done) return;
        done = true;
        try { sessionStorage.setItem('al-door', '1'); } catch (e) {}
        d.classList.add('is-opening');
        setTimeout(function () { d.classList.add('is-open'); }, calm ? 0 : 600);
        setTimeout(function () { d.classList.add('is-gone'); document.documentElement.style.overflow = ''; }, calm ? 150 : 2200);
        setTimeout(function () { if (d.parentNode) d.parentNode.removeChild(d); }, calm ? 800 : 2900);
      }
      function tick(ts) {
        if (!t0) t0 = ts;
        var p = Math.min(1, (ts - t0) / need);
        set(p);
        if (p >= 1) { open(); return; }
        raf = requestAnimationFrame(tick);
      }
      function start(e) {
        if (done) return;
        if (e && e.cancelable) e.preventDefault();
        if (calm) { open(); return; }
        t0 = 0; cancelAnimationFrame(raf); raf = requestAnimationFrame(tick);
      }
      function stop() { if (done) return; cancelAnimationFrame(raf); set(0); }
      btn.addEventListener('pointerdown', start);
      ['pointerup', 'pointerleave', 'pointercancel'].forEach(function (ev) { btn.addEventListener(ev, stop); });
      btn.addEventListener('keydown', function (e) { if ((e.key === 'Enter' || e.key === ' ') && !e.repeat) start(e); });
      btn.addEventListener('keyup', function (e) { if (e.key === 'Enter' || e.key === ' ') stop(); });
      btn.addEventListener('contextmenu', function (e) { e.preventDefault(); });
      try { btn.focus({ preventScroll: true }); } catch (e) {}
    }
    function run() { greet(); door(); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  })();

  (function () {
    var KEY = 'al-hold-pending';
    function read() { try { return JSON.parse(localStorage.getItem(KEY) || '{}') || {}; } catch (e) { return {}; } }
    function write(o) { try { localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} }
    function run() {
      var btns = document.querySelectorAll('[data-al-hold-btn]');
      if (!btns.length) return;
      var pending = read(), changed = false, focusSeat = null;
      btns.forEach(function (b) {
        var seat = b.getAttribute('data-seat'), kind = b.getAttribute('data-kind');
        var form = b.closest('form');
        var p = pending[seat];
        if (p) {
          if ((p === 'hold' && kind === 'release') || (p === 'release' && kind === 'hold')) { delete pending[seat]; changed = true; }
          else {
            b.disabled = true;
            b.textContent = p === 'hold' ? 'Hold requested' : 'Release requested';
            var note = document.createElement('p');
            note.className = 'al-card__pending';
            note.textContent = p === 'hold' ? 'Your request is with Anthony. Your seat shows as held once he confirms it.' : 'Your request is with Anthony. The seat is released once he confirms it.';
            form.parentNode.insertBefore(note, form.nextSibling);
            focusSeat = focusSeat || seat;
          }
        }
        if (form && !form.dataset.alHoldReady) {
          form.dataset.alHoldReady = '1';
          form.addEventListener('submit', function () { var o = read(); o[seat] = kind; write(o); });
        }
      });
      if (changed) write(pending);
      if (focusSeat && (location.hash === '#contact_form' || /contact_posted/.test(location.search))) {
        setTimeout(function () {
          var s = document.querySelector('[data-al-seat][data-handle="' + focusSeat + '"]');
          if (s) s.click();
        }, 0);
      }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  })();

  (function () {
    var KEY = 'al-plus-pending';
    function run() {
      var btn = document.querySelector('[data-al-plus]');
      if (!btn) { try { localStorage.removeItem(KEY); } catch (e) {} return; }
      var form = btn.closest('form');
      var pending = null;
      try { pending = localStorage.getItem(KEY); } catch (e) {}
      if (pending) {
        var input = form.querySelector('input[type="text"]');
        if (input) { input.value = pending; input.disabled = true; }
        var mail = form.querySelector('input[type="email"]');
        if (mail) { mail.disabled = true; mail.placeholder = ''; }
        btn.disabled = true;
        btn.textContent = 'Nominated';
        var note = document.createElement('p');
        note.className = 'al-card__pending';
        note.textContent = 'Your nomination is with Anthony. It shows here once he has recorded it.';
        form.parentNode.appendChild(note);
      }
      form.addEventListener('submit', function () {
        var input = form.querySelector('input[type="text"]');
        try { localStorage.setItem(KEY, (input && input.value || '').slice(0, 60)); } catch (e) {}
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  })();

  /* the lounge window and the bar */
  (function () {
    var WORDS = {
      dawn: ['this morning', 'For this morning', 'An early start. {N} is ready when you are.'],
      day: ['today', 'For today', '{N}, for the day ahead.'],
      golden: ['this evening', 'For tonight', 'As the sun goes down, I have set {n} aside for you.'],
      evening: ['tonight', 'For tonight', 'This evening, I have set {n} aside for you.'],
      night: ['tonight', 'For tonight', 'A still night. I have kept {n} back for you.']
    };
    function london() {
      var h = 0, m = 0;
      try {
        new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(new Date()).forEach(function (p) {
          if (p.type === 'hour') h = parseInt(p.value, 10) % 24;
          if (p.type === 'minute') m = parseInt(p.value, 10);
        });
      } catch (e) { var d = new Date(); h = d.getHours(); m = d.getMinutes(); }
      return { h: h, m: m, text: ('0' + h).slice(-2) + ':' + ('0' + m).slice(-2) };
    }
    function dayOfYear() { var n = new Date(); return Math.floor((n - new Date(n.getFullYear(), 0, 0)) / 864e5); }
    function phaseNow() {
      var t = london(), x = t.h + t.m / 60, s = Math.sin(2 * Math.PI * (dayOfYear() - 80) / 365);
      var off = ((t.h - new Date().getUTCHours()) + 24) % 24;
      var rise = 5.9 - 2.17 * s + off, set = 18.12 + 2.23 * s + off;
      if (x < rise - 1 || x >= set + 2) return 'night';
      if (x < rise + 1.5) return 'dawn';
      if (x < set - 1.5) return 'day';
      if (x < set + 0.5) return 'golden';
      return 'evening';
    }
    function fill(t, n) { return t.replace('{N}', n).replace('{n}', /^The /.test(n) ? 'the ' + n.slice(4) : n); }
    var LABEL = { dawn: 'First light', day: 'Daylight', golden: 'Sunset', evening: 'Evening', night: 'Night' };

    function pickSeat(root, phase) {
      var seats = [].slice.call(root.querySelectorAll('[data-al-seat]')).map(function (s) {
        var n = s.querySelector('.al-seat__name');
        return { el: s, name: s.getAttribute('data-say') || (n ? n.textContent.trim() : ''), open: s.classList.contains('al-seat--open'), soon: s.classList.contains('al-seat--soon') };
      }).filter(function (s) { return s.name; });
      if (!seats.length) return null;
      var open = seats.filter(function (s) { return s.open; }), soon = seats.filter(function (s) { return s.soon; });
      if (phase === 'dawn' || phase === 'day') return open[0] || soon[0] || seats[0];
      if (soon.length) return soon[dayOfYear() % soon.length];
      return open[0] || seats[0];
    }

    function boot(root) {
      if (!root || root.dataset.alWinReady) return;
      var win = root.querySelector('[data-al-win]'), bar = root.querySelector('[data-al-bar]');
      if (!win && !bar) return;
      root.dataset.alWinReady = '1';
      var pick = null, phase = 'evening';

      function apply() {
        phase = phaseNow();
        root.setAttribute('data-phase', phase);
        if (win) {
          win.setAttribute('data-phase', phase);
          var meta = win.querySelector('[data-al-win-meta]');
          if (meta) meta.textContent = 'London · ' + london().text + ' · ' + LABEL[phase];
        }
        var w = WORDS[phase], p = pickSeat(root, phase);
        root.querySelectorAll('.al-seat__tag').forEach(function (t) { t.parentNode.removeChild(t); });
        root.querySelectorAll('.al-seat.is-suggested').forEach(function (s) { s.classList.remove('is-suggested'); });
        pick = p;
        if (p) {
          p.el.classList.add('is-suggested');
          var tag = document.createElement('span'); tag.className = 'al-seat__tag'; tag.textContent = w[1]; p.el.appendChild(tag);
        }
        if (bar) {
          var card = bar.querySelector('[data-al-aside]');
          if (card && p) {
            card.querySelector('[data-al-aside-k]').textContent = 'Set aside for you · ' + w[0];
            card.querySelector('[data-al-aside-t]').textContent = p.name;
            card.querySelector('[data-al-aside-l]').textContent = fill(w[2], p.name);
            card.querySelector('[data-al-aside-go]').textContent = 'See ' + fill('{n}', p.name);
            card.hidden = false;
          }
        }
      }
      apply();
      setInterval(apply, 5 * 60 * 1000);

      function showSeat() {
        if (!pick) return;
        pick.el.click();
        try { pick.el.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' }); } catch (e) { pick.el.scrollIntoView(); }
      }

      if (!bar) return;
      var go = bar.querySelector('[data-al-aside-go]');
      if (go) go.addEventListener('click', showSeat);

      var log = bar.querySelector('[data-al-log]');
      var name = bar.getAttribute('data-name');
      var hello = bar.querySelector('[data-al-hello]');
      if (hello) {
        var hr = new Date().getHours();
        var part = hr >= 5 && hr < 12 ? 'Good morning' : (hr >= 12 && hr < 17 ? 'Good afternoon' : 'Good evening');
        hello.textContent = part + (name ? ', ' + name : '') + '. Anything I can bring you?';
      }
      function say(who, text, note, cls) {
        var m = document.createElement('div'); m.className = 'al-msg' + (cls ? ' ' + cls : '');
        var a = document.createElement('span'); a.className = 'al-msg__who'; a.textContent = who; m.appendChild(a);
        var b = document.createElement('span'); b.className = 'al-msg__text'; b.textContent = text; m.appendChild(b);
        if (note) { var c = document.createElement('span'); c.className = 'al-msg__note'; c.textContent = note; m.appendChild(c); }
        log.appendChild(m); log.scrollTop = log.scrollHeight;
        return m;
      }
      function answer(key) {
        if (key === 'aside') return pick ? fill(WORDS[phase][2], pick.name) + ' Shall I show you to the seat?' : 'Every seat is named after its scent. Choose one above.';
        var t = bar.querySelector('[data-al-ans="' + key + '"]');
        return t ? (t.content ? t.content.textContent : t.textContent).trim() : '';
      }
      bar.querySelectorAll('[data-al-q]').forEach(function (chip) {
        chip.addEventListener('click', function () {
          var key = chip.getAttribute('data-al-q');
          say('You', chip.textContent.trim(), '', 'al-msg--me');
          chip.parentNode.removeChild(chip);
          var dots = document.createElement('span'); dots.className = 'al-msg__dots'; dots.textContent = '···'; dots.setAttribute('aria-hidden', 'true');
          log.appendChild(dots); log.scrollTop = log.scrollHeight;
          setTimeout(function () {
            dots.parentNode && dots.parentNode.removeChild(dots);
            var m = say('Host', answer(key), chip.getAttribute('data-note') || '');
            if (key === 'aside' && pick) {
              var b = document.createElement('button'); b.type = 'button'; b.className = 'al-chip'; b.textContent = 'Show me ' + fill('{n}', pick.name);
              b.addEventListener('click', showSeat); m.appendChild(b);
            }
          }, 800);
        });
      });

      /* questions for Anthony: sent by email; his reply appears here */
      var KEY = 'al-ask-pending';
      var form = bar.querySelector('.al-ask');
      if (!form) return;
      var input = form.querySelector('textarea');
      input.addEventListener('input', function () { input.style.height = 'auto'; input.style.height = Math.min(input.scrollHeight, 140) + 'px'; });
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); if (input.value.trim()) form.requestSubmit ? form.requestSubmit() : form.submit(); } });
      form.addEventListener('submit', function () { try { localStorage.setItem(KEY, JSON.stringify({ q: input.value.trim().slice(0, 500), t: Date.now() })); } catch (e) {} });
      var pending = null;
      try { pending = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) {}
      if (pending && pending.q) {
        var replied = parseInt(bar.getAttribute('data-replied') || '0', 10) * 1000;
        if (replied && replied > pending.t) { try { localStorage.removeItem(KEY); } catch (e) {} }
        else {
          say('You', pending.q, '', 'al-msg--me');
          say('Host', 'I have passed that to Anthony. He will answer you personally, here.', 'With Anthony');
          form.classList.add('is-sent');
          var again = document.createElement('button'); again.type = 'button'; again.className = 'al-chip'; again.textContent = 'Ask something else';
          again.addEventListener('click', function () { try { localStorage.removeItem(KEY); } catch (e) {} form.classList.remove('is-sent'); again.parentNode.removeChild(again); input.focus(); });
          form.parentNode.insertBefore(again, form);
          if (/contact_posted/.test(location.search) || location.hash === '#contact_form') {
            setTimeout(function () { try { bar.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {} }, 300);
          }
        }
      }
    }
    function all() { document.querySelectorAll('.al').forEach(boot); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
    document.addEventListener('shopify:section:load', function (e) { boot(e.target.querySelector('.al')); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["antaro-atelier-notes"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function mark() { if (document.querySelector('.an, .ap')) document.body.classList.add('at-page'); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mark); else mark();
    document.addEventListener('shopify:section:load', mark);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["antaro-atelier-terminal"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function boot(root) {
      if (!root || root.dataset.atReady) return;
      root.dataset.atReady = '1';
      document.body.classList.add('at-page');
      var g = root.querySelector('[data-at-greeting]'), c = root.querySelector('[data-at-clock]');
      function tick() {
        var parts = {};
        try {
          new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', hour: '2-digit', minute: '2-digit', hour12: false })
            .formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
        } catch (e) { var d = new Date(); parts.hour = ('0' + d.getHours()).slice(-2); parts.minute = ('0' + d.getMinutes()).slice(-2); }
        var h = parseInt(parts.hour, 10);
        if (g) g.textContent = h < 12 ? 'Good morning' : (h < 18 ? 'Good afternoon' : 'Good evening');
        if (c) c.textContent = parts.hour + ':' + parts.minute + ' London';
      }
      tick(); setInterval(tick, 30000);
    }
    function all() { document.querySelectorAll('.at').forEach(boot); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
    document.addEventListener('shopify:section:load', function (e) { boot(e.target.querySelector('.at')); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["antaro-aw-window"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var mq = window.matchMedia('(min-width: 990px) and (pointer: fine)');
    function boot() {
      var src = document.querySelector('[data-aw-win-src]');
      var root = document.getElementById('aw-departures');
      if (!src || !root) return;
      var grid = root.querySelector('.aw-dep__grid');
      var pass = root.querySelector('.aw-dep__pass');
      if (!grid || !pass || grid.querySelector('[data-aw-win]')) return;
      var data = {};
      src.querySelectorAll('[data-k]').forEach(function (s) {
        data[s.getAttribute('data-k')] = { src: s.getAttribute('data-src'), srcset: s.getAttribute('data-srcset'), alt: s.getAttribute('data-alt'), url: s.getAttribute('data-url') };
      });
      var rows = Array.prototype.slice.call(root.querySelectorAll('[data-aw-row]'));
      if (!rows.length) return;
      function keyOf(row) { var li = row.closest('[data-handle]'); return li ? li.getAttribute('data-handle') : ''; }

      var win = document.createElement('div');
      win.className = 'aw-win';
      win.setAttribute('data-aw-win', '');
      win.setAttribute('role', 'group');
      win.setAttribute('aria-label', 'Gate window');
      win.innerHTML = '<div class="aw-win__frame"><img class="aw-win__img" alt="" decoding="async" sizes="360px"><img class="aw-win__img" alt="" decoding="async" sizes="360px"></div>' +
        '<div class="aw-win__meta"><span class="aw-win__code"></span><a class="aw-win__link" href="#"></a></div>';
      var imgs = win.querySelectorAll('.aw-win__img');
      var code = win.querySelector('.aw-win__code');
      var link = win.querySelector('.aw-win__link');
      var label = src.getAttribute('data-label') || 'See the scent';
      link.innerHTML = '';
      link.appendChild(document.createTextNode(label + ' '));
      var arrow = document.createElement('span'); arrow.setAttribute('aria-hidden', 'true'); arrow.textContent = '→'; link.appendChild(arrow);
      grid.insertBefore(win, pass);
      grid.classList.add('has-win');

      var front = 0, current = '', timer = null;
      function show(row) {
        var k = keyOf(row);
        if (!k || k === current) return;
        current = k;
        var d = data[k] || {};
        var name = row.getAttribute('data-aw-name') || '';
        code.textContent = (row.getAttribute('data-aw-flight') || '') + ' · ' + name.toUpperCase();
        if (d.url) { link.href = d.url; link.hidden = false; link.setAttribute('aria-label', label + ', ' + name); } else { link.hidden = true; }
        var back = imgs[1 - front], top = imgs[front];
        if (!d.src) { top.classList.remove('is-on'); back.classList.remove('is-on'); return; }
        var reveal = function () {
          if (current !== k) return;
          back.classList.add('is-on'); top.classList.remove('is-on'); front = 1 - front;
        };
        back.onload = reveal;
        back.alt = d.alt || '';
        back.srcset = d.srcset || '';
        back.src = d.src;
        if (back.complete && back.naturalWidth) reveal();
      }
      function queue(row) {
        clearTimeout(timer);
        timer = setTimeout(function () { show(row); }, 70);
      }
      rows.forEach(function (row) {
        row.addEventListener('mouseenter', function () { if (mq.matches) queue(row); });
        row.addEventListener('focus', function () { if (mq.matches) { clearTimeout(timer); show(row); } });
      });
      var start = root.querySelector('.aw-dep__row--last') || rows[0];
      show(start);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["antaro-billboard"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    function post(url, body) {
      return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' }, body: JSON.stringify(body) });
    }
    function bindForm(form) {
      var slide = form.closest('.bb-slide');
      var done = slide.querySelector('[data-bb-done]');
      var note = form.querySelector('[data-bb-note]');
      var label = form.querySelector('[data-bb-label]');
      var btn = form.querySelector('button');
      var defaultLabel = label.textContent;
      // v19: someone who already got a boarding pass on this phone or browser isn't asked again.
      try { if (localStorage.getItem('antaro-boarding-pass') === '1') { form.hidden = true; done.hidden = false; } } catch (err) {}
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = form.email.value.trim();
        var first = form.first_name.value.trim();
        form.email.removeAttribute('aria-invalid');
        note.removeAttribute('data-error');
        if (!EMAIL_RE.test(email)) {
          form.email.setAttribute('aria-invalid', 'true');
          note.textContent = 'Please enter a valid email address.';
          note.setAttribute('data-error', '');
          form.email.focus();
          return;
        }
        btn.disabled = true;
        label.textContent = 'Reserving your seat…';
        var base = 'https://a.klaviyo.com/client/';
        var q = '?company_id=' + encodeURIComponent(form.dataset.company);
        var profile = { data: { type: 'profile', attributes: { email: email } } };
        if (first) profile.data.attributes.first_name = first;
        post(base + 'profiles/' + q, profile).catch(function () {}).then(function () {
          return post(base + 'subscriptions/' + q, { data: { type: 'subscription', attributes: { custom_source: 'Homepage — Billboard',
            profile: { data: { type: 'profile', attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } },
            relationships: { list: { data: { type: 'list', id: form.dataset.list } } } } });
        }).then(function (res) {
          if (!res || !res.ok) throw new Error('subscribe failed');
          form.hidden = true; done.hidden = false; done.focus();
          try { localStorage.setItem('antaro-boarding-pass', '1'); } catch (err) {}
        }).catch(function () {
          btn.disabled = false; label.textContent = defaultLabel;
          note.textContent = 'Something went wrong. Please try again in a moment.';
          note.setAttribute('data-error', '');
        });
      });
    }
    function scrollTo(el) { if (el) el.scrollIntoView({ behavior: reduce.matches ? 'auto' : 'smooth', block: 'start' }); }
    function boot(root) {
      if (!root || root.dataset.bbReady) return;
      root.dataset.bbReady = '1';
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-bb-slide]'));
      var tiles = Array.prototype.slice.call(root.querySelectorAll('[data-bb-tile]'));
      function show(i) {
        slides.forEach(function (s, n) { s.hidden = n !== i; });
        tiles.forEach(function (t) { t.setAttribute('aria-pressed', String(+t.dataset.bbTile === i)); });
        var s = slides[i];
        if (s) { root.style.setProperty('--bb-bg', s.dataset.bg); root.style.setProperty('--bb-fg', s.dataset.fg); }
      }
      tiles.forEach(function (t) { t.addEventListener('click', function () { show(+t.dataset.bbTile); if (t.classList.contains('bb-ptile')) scrollTo(root); }); });
      var info = root.querySelector('[data-bb-info]'), pop = root.querySelector('[data-bb-note-pop]');
      if (info && pop) info.addEventListener('click', function () { var open = pop.hidden; pop.hidden = !open; info.setAttribute('aria-expanded', String(open)); });
      var pbtn = root.querySelector('[data-bb-panel-btn]'), panel = root.querySelector('[data-bb-panel]');
      if (pbtn && panel) pbtn.addEventListener('click', function () { var open = panel.hidden; panel.hidden = !open; pbtn.setAttribute('aria-expanded', String(open)); });
      root.querySelectorAll('[data-bb-form]').forEach(bindForm);
      // v93 · Weekend Tote: Cream / Black, like the Core Case finishes. Choosing one holds the rotation.
      root.querySelectorAll('[data-wt-slide]').forEach(function (sl) {
        sl.querySelectorAll('[data-wt-fin]').forEach(function (b) {
          b.addEventListener('click', function () {
            var f = b.dataset.wtFin;
            sl.querySelectorAll('[data-wt-fin]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
            sl.querySelectorAll('[data-wt-img]').forEach(function (im) { im.classList.toggle('is-on', im.dataset.wtImg === f); });
            var g = sl.querySelector('[data-wt-ghost]'), n = sl.querySelector('[data-wt-name]'), t = f === 'black' ? 'Black' : 'Cream';
            if (g) g.textContent = t; if (n) n.textContent = t;
            root.dispatchEvent(new CustomEvent('antaro:bb-hold'));
          });
        });
      });
      // v27: someone who already holds a boarding pass sees "You're on board" instead of the button.
      try {
        if (localStorage.getItem('antaro-boarding-pass') === '1') {
          root.querySelectorAll('[data-bb-board-wrap]').forEach(function (w) {
            var d = w.parentNode.querySelector('[data-bb-board-done]');
            if (d) { w.hidden = true; d.hidden = false; }
          });
        }
      } catch (err) {}
      root.addEventListener('click', function (e) {
        var a = e.target.closest('a[href^="#"]');
        if (!a) return;
        var h = a.getAttribute('href');
        var target = h === '#films' ? document.querySelector('[id$="__films"]') : document.querySelector(h);
        if (!target) return;
        e.preventDefault();
        scrollTo(target);
      });
    }
    function all() { document.querySelectorAll('[data-bb]').forEach(boot); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
    document.addEventListener('shopify:section:load', function (e) { boot(e.target.querySelector('[data-bb]')); });
    document.addEventListener('shopify:block:select', function (e) {
      var root = e.target.closest('[data-bb]'); if (!root) return;
      var i = +e.target.dataset.bbSlide; if (isNaN(i)) return;
      var t = root.querySelector('[data-bb-tile="' + i + '"]'); if (t) t.click();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["antaro-checkin"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function boot(root) {
      if (!root || root.dataset.ckReady) return;
      root.dataset.ckReady = '1';
      var gs = root.querySelectorAll('[data-ck-greet]'), c = root.querySelector('[data-ck-clock]'), bigs = root.querySelectorAll('[data-ck-clock-big]');
      function tick() {
        var p = {};
        try { new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; }); }
        catch (e) { var d = new Date(); p.hour = ('0' + d.getHours()).slice(-2); p.minute = ('0' + d.getMinutes()).slice(-2); }
        var h = parseInt(p.hour, 10);
        var greet = h < 12 ? 'Good morning' : (h < 18 ? 'Good afternoon' : 'Good evening');
        gs.forEach(function (g) { g.textContent = greet; });
        if (c) c.textContent = p.hour + ':' + p.minute + ' London';
        bigs.forEach(function (big) { big.textContent = p.hour + ':' + p.minute; });
      }
      tick(); setInterval(tick, 30000);
      var zones = Array.prototype.slice.call(root.querySelectorAll('[data-ck-zone]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('[data-ck-panel]'));
      zones.forEach(function (z) {
        z.addEventListener('click', function () {
          var id = z.dataset.ckZone;
          zones.forEach(function (o) { var on = o === z; o.classList.toggle('is-on', on); o.setAttribute('aria-pressed', String(on)); });
          panels.forEach(function (p) { p.hidden = p.dataset.ckPanel !== id; });
          walkPlan(z);
        });
      });

      // The traveller: walks to whichever zone is chosen (laptop plan and phone map).
      var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      function centre(el) { return { x: el.offsetLeft + el.offsetWidth / 2, y: el.offsetTop + el.offsetHeight / 2 }; }
      function jump(dot, x, y) { dot.style.transition = 'none'; dot.style.left = x + 'px'; dot.style.top = y + 'px'; void dot.offsetWidth; dot.style.transition = ''; }

      // Laptop: top then left (the CSS delays the left move).
      var plan = root.querySelector('.ck-plan'), me = root.querySelector('[data-ck-me]');
      function walkPlan(z, instant) {
        if (!me || !z || !plan || !plan.offsetWidth) return;
        var c = centre(z);
        if (instant || reduce) { jump(me, c.x, c.y); return; }
        me.style.left = c.x + 'px'; me.style.top = c.y + 'px';
      }

      // Phones and tablets: the traveller stays on the walkway and stops beside the zone
      // (level with a column zone's middle, or at the top edge of the full-width Check-in),
      // so it never sits over a zone's words.
      var pplan = root.querySelector('.ck-pplan'), pme = root.querySelector('[data-ck-pme]');
      var pzones = Array.prototype.slice.call(root.querySelectorAll('[data-ck-pzone]'));
      var pcards = Array.prototype.slice.call(root.querySelectorAll('[data-ck-pcard]'));
      var placed = false;
      function stopFor(b) {
        var mid = pplan.clientWidth / 2;
        var full = b.offsetWidth > pplan.clientWidth * 0.6;
        return { x: mid, y: full ? b.offsetTop : b.offsetTop + b.offsetHeight / 2 };
      }
      function walkPhone(b, instant) {
        if (!pme || !b || !pplan || !pplan.offsetWidth) return;
        var s = stopFor(b);
        if (instant || reduce || !placed) { jump(pme, s.x, s.y); placed = true; return; }
        pme.style.left = s.x + 'px'; pme.style.top = s.y + 'px';
      }
      pzones.forEach(function (b) {
        b.addEventListener('click', function () {
          var id = b.dataset.ckPzone;
          pzones.forEach(function (o) { var on = o === b; o.classList.toggle('is-on', on); o.setAttribute('aria-pressed', String(on)); });
          pcards.forEach(function (p) { p.hidden = p.dataset.ckPcard !== id; });
          walkPhone(b);
        });
      });
      // v19 phones: the zone details open in a panel that slides up from the bottom of the screen,
      // so a tap always answers where the thumb is. Arrows step to the neighbouring zone.
      (function () {
        var sheet = root.querySelector('[data-ck-sheet]'), scrim = root.querySelector('[data-ck-scrim]');
        if (!sheet || !pzones.length) return;
        var order = ['departures', 'arrivals', 'atelier', 'store', 'qc', 'checkin', 'desk'];
        var byId = {}; pzones.forEach(function (b) { byId[b.dataset.ckPzone] = b; });
        var seq = order.filter(function (id) { return byId[id]; });
        pzones.forEach(function (b) { if (seq.indexOf(b.dataset.ckPzone) < 0) seq.push(b.dataset.ckPzone); });
        var current = null, lastTap = null, openTimer = 0;
        function nameOf(id) { var n = byId[id] && byId[id].querySelector('.ck-pz__name'); return n ? n.textContent.trim() : id; }
        function setSteps() {
          var i = seq.indexOf(current);
          sheet.querySelectorAll('[data-ck-step]').forEach(function (btn) {
            var j = i + parseInt(btn.dataset.ckStep, 10);
            var ok = i > -1 && j >= 0 && j < seq.length;
            btn.hidden = !ok;
            if (ok) { btn.dataset.target = seq[j]; btn.querySelector('[data-ck-step-name]').textContent = nameOf(seq[j]); }
          });
        }
        function keepVisible(b) {
          if (!b) return;
          var r = b.getBoundingClientRect(), room = window.innerHeight - sheet.offsetHeight - 16;
          var head = document.querySelector('.header, header-component, #header-component');
          var top = head ? Math.max(0, head.getBoundingClientRect().bottom) + 12 : 80;
          var dy = 0;
          if (r.bottom > room) dy = r.bottom - room;
          if (r.top - dy < top) dy = r.top - top;
          if (Math.abs(dy) > 4) window.scrollBy({ top: dy, behavior: reduce ? 'auto' : 'smooth' });
        }
        function open() {
          sheet.classList.add('is-open'); scrim.hidden = false;
          requestAnimationFrame(function () { scrim.classList.add('is-on'); });
          document.documentElement.classList.add('ck-sheet-open');
          keepVisible(lastTap);
        }
        function close(focusBack) {
          clearTimeout(openTimer);
          sheet.classList.remove('is-open'); scrim.classList.remove('is-on');
          document.documentElement.classList.remove('ck-sheet-open');
          setTimeout(function () { if (!sheet.classList.contains('is-open')) scrim.hidden = true; }, 300);
          if (focusBack && lastTap) { try { lastTap.focus({ preventScroll: true }); } catch (e) {} }
        }
        pzones.forEach(function (b) {
          b.addEventListener('click', function () {
            current = b.dataset.ckPzone; lastTap = b; setSteps();
            sheet.scrollTop = 0;
            clearTimeout(openTimer);
            if (sheet.classList.contains('is-open')) { setTimeout(function () { keepVisible(b); }, 30); return; }
            openTimer = setTimeout(open, reduce ? 0 : 260);
          });
        });
        sheet.querySelectorAll('[data-ck-step]').forEach(function (btn) {
          btn.addEventListener('click', function () { var t = byId[btn.dataset.target]; if (t) t.click(); });
        });
        sheet.querySelector('[data-ck-close]').addEventListener('click', function () { close(true); });
        scrim.addEventListener('click', function () { close(false); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && sheet.classList.contains('is-open')) close(true); });
        var grab = sheet.querySelector('[data-ck-grab]'), y0 = null, x0 = 0;
        sheet.addEventListener('touchstart', function (e) { if (sheet.scrollTop <= 0) { y0 = e.touches[0].clientY; x0 = e.touches[0].clientX; } }, { passive: true });
        sheet.addEventListener('touchmove', function (e) {
          if (y0 === null) return;
          var dy = e.touches[0].clientY - y0, dx = e.touches[0].clientX - x0;
          if (Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy)) { y0 = null; sheet.style.transition = ''; sheet.style.transform = ''; return; }
          if (dy > 0) { sheet.style.transition = 'none'; sheet.style.transform = 'translateY(' + dy + 'px)'; }
        }, { passive: true });
        sheet.addEventListener('touchend', function (e) {
          if (y0 === null) return;
          var dy = (e.changedTouches[0] || {}).clientY - y0; y0 = null;
          sheet.style.transition = ''; sheet.style.transform = '';
          if (dy > 70) close(false);
        });
        window.addEventListener('resize', function () { if (window.innerWidth >= 1100 && sheet.classList.contains('is-open')) close(false); });
      })();
      // v19: "Show on map" scrolls to the map, waits until the page has settled, then selects the zone.
      function headBottom() {
        var hd = document.querySelector('header-component, .header, #header-component');
        if (!hd) return 0;
        var h = hd.getBoundingClientRect().height;
        return h > 0 && h < window.innerHeight / 3 ? h : 0;
      }
      function scrollAndThen(y, fn) {
        y = Math.max(0, Math.round(y));
        window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
        var last = -1, still = 0, t0 = Date.now();
        (function poll() {
          var cur = window.scrollY;
          still = Math.abs(cur - last) < 1 ? still + 1 : 0; last = cur;
          if (still >= 3 || Date.now() - t0 > 1600) { fn(); return; }
          setTimeout(poll, 60);
        })();
      }
      function tileFor(id) {
        var t = root.querySelector('[data-ck-pzone="' + id + '"]');
        if (!t || !t.offsetParent) t = root.querySelector('[data-ck-zone="' + id + '"]');
        return t && t.offsetParent ? t : null;
      }
      function showOnMap(id) {
        var tile = tileFor(id); if (!tile) return;
        var head = headBottom() + 16, y;
        if (tile.hasAttribute('data-ck-zone')) { var mp = root.querySelector('.ck-map'); y = mp.getBoundingClientRect().top + window.scrollY - head; }
        else { y = tile.getBoundingClientRect().top + window.scrollY - head; }
        scrollAndThen(y, function () { tile.click(); });
      }
      // v19: tap a zone that is already chosen to go straight in.
      var picked = null;
      function hrefFor(t) {
        var id = t.dataset.ckZone || t.dataset.ckPzone;
        var a = root.querySelector('[data-ck-panel="' + id + '"] a.ck-panel__cta') || root.querySelector('[data-ck-pcard="' + id + '"] a.ck-pcard__cta');
        return a ? a.getAttribute('href') : '';
      }
      root.addEventListener('click', function (e) {
        var t = e.target.closest('[data-ck-zone], [data-ck-pzone]'); if (!t) return;
        if (t === picked && t.classList.contains('is-on')) {
          var href = hrefFor(t);
          if (href) { e.preventDefault(); e.stopImmediatePropagation(); window.location.href = href; }
        }
      }, true);
      root.addEventListener('click', function (e) {
        var t = e.target.closest('[data-ck-zone], [data-ck-pzone]'); if (t) picked = t;
      });
      // v19 laptops: a small card beside the chosen zone with its main button, so the next step is where you are looking.
      (function () {
        var card = root.querySelector('[data-ck-zcard]'), planEl = root.querySelector('.ck-plan');
        if (!card || !planEl) return;
        var timer = 0;
        function fill(z) {
          var id = z.dataset.ckZone, p = root.querySelector('[data-ck-panel="' + id + '"]');
          var name = p && p.querySelector('.ck-panel__name'), st = p && p.querySelector('.ck-panel__status'), cta = p && p.querySelector('a.ck-panel__cta');
          card.innerHTML = '';
          var n = document.createElement('p'); n.className = 'ck-zcard__name'; n.textContent = name ? name.textContent : ''; card.appendChild(n);
          if (st) { var s2 = st.cloneNode(true); s2.className = 'ck-zcard__status'; card.appendChild(s2); }
          if (z.dataset.plain) { var l = document.createElement('p'); l.className = 'ck-zcard__line'; l.textContent = z.dataset.plain; card.appendChild(l); }
          if (cta) { var a = cta.cloneNode(true); a.className = 'ck-zcard__cta'; card.appendChild(a); }
          card.style.left = '0px'; card.style.top = '0px'; card.style.visibility = 'hidden'; card.hidden = false;
          var w = card.offsetWidth, h = card.offsetHeight, gap = 12, pw = planEl.offsetWidth, ph = planEl.offsetHeight;
          var x0 = z.offsetLeft, y0 = z.offsetTop, zw = z.offsetWidth, zh = z.offsetHeight;
          var others = Array.prototype.slice.call(root.querySelectorAll('[data-ck-zone]')).filter(function (o) { return o !== z && o.offsetParent; })
            .map(function (o) { return { l: o.offsetLeft, t: o.offsetTop, r: o.offsetLeft + o.offsetWidth, b: o.offsetTop + o.offsetHeight }; });
          function clampX(x) { return Math.max(0, Math.min(x, pw - w)); }
          function clampY(y) { return Math.max(0, Math.min(y, ph - h)); }
          var spots = [
            { x: x0 + zw + gap, y: clampY(y0) }, { x: x0 - w - gap, y: clampY(y0) },
            { x: clampX(x0 + (zw - w) / 2), y: y0 - h - gap }, { x: clampX(x0 + (zw - w) / 2), y: y0 + zh + gap }
          ];
          function overlap(sp) {
            if (sp.x < 0 || sp.y < 0 || sp.x + w > pw || sp.y + h > ph) return Infinity;
            return others.reduce(function (sum, o) {
              var ix = Math.max(0, Math.min(sp.x + w, o.r) - Math.max(sp.x, o.l)), iy = Math.max(0, Math.min(sp.y + h, o.b) - Math.max(sp.y, o.t));
              return sum + ix * iy;
            }, 0);
          }
          var best = spots[0], bestO = overlap(spots[0]);
          spots.forEach(function (sp) { var o = overlap(sp); if (o < bestO) { best = sp; bestO = o; } });
          if (bestO === Infinity) best = { x: clampX(spots[0].x), y: clampY(spots[0].y) };
          card.style.left = best.x + 'px'; card.style.top = best.y + 'px'; card.style.visibility = '';
          card.classList.remove('is-on'); void card.offsetWidth; card.classList.add('is-on');
        }
        root.querySelectorAll('[data-ck-zone]').forEach(function (z) {
          z.addEventListener('click', function () { clearTimeout(timer); card.hidden = true; timer = setTimeout(function () { fill(z); }, reduce ? 0 : 420); });
        });
        document.addEventListener('click', function (e) { if (!card.hidden && !e.target.closest('.ck-plan, .ck-today')) card.hidden = true; });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape') card.hidden = true; });
      })();
      // v19 phones: Today at the terminal picks its own lines.
      (function () {
        var td = root.querySelector('[data-ck-today]');
        if (!td) return;
        var box = td.querySelector('[data-ck-today-rows]'), more = td.querySelector('[data-ck-today-more]'), count = td.querySelector('[data-ck-today-count]');
        var rows = Array.prototype.slice.call(box.querySelectorAll('[data-ck-tz]'));
        var store = {}; function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
        var firstVisit = ls('antaro-seen') !== '1'; ls('antaro-seen', '1');
        var hasPass = ls('antaro-boarding-pass') === '1';
        if (hasPass) { var dc = root.querySelector('[data-ck-door-pass] [data-ck-door-cta]'); if (dc) dc.textContent = 'You’re on board'; }
        var full = false, extra = [];
        function line(o) {
          var row = document.createElement('div');
          row.className = 'ck-today__row' + (o.personal ? ' ck-today__row--you' : '');
          var b;
          if (o.go === 'store') { b = document.createElement('a'); var sa = box.querySelector('[data-ck-tz="store"] a.ck-today__main'); b.href = sa ? sa.getAttribute('href') : '/collections/antaro-store'; }
          else if (o.go) { b = document.createElement('button'); b.type = 'button'; if (o.go === 'cart') b.setAttribute('data-ck-cart', ''); else b.setAttribute('data-ck-showmap', o.go); }
          else { b = document.createElement('div'); }
          b.className = 'ck-today__main';
          row.appendChild(b);
          var n = document.createElement('span'); n.className = 'ck-today__name';
          var n1 = document.createElement('span'); n1.textContent = o.name; n.appendChild(n1);
          if (o.sub) { var n2 = document.createElement('small'); n2.textContent = o.sub; n.appendChild(n2); }
          var st = document.createElement('span'); st.className = 'ck-today__st ck-today__st--' + o.tone; st.appendChild(document.createElement('i')); st.appendChild(document.createTextNode(o.status));
          var go = document.createElement('span'); go.className = 'ck-today__go'; go.setAttribute('aria-hidden', 'true'); go.textContent = o.go ? '›' : '';
          b.appendChild(n); b.appendChild(st); b.appendChild(go);
          return row;
        }
        function launchIn() {
          var raw = td.dataset.launch; if (!raw) return '';
          var t = new Date(raw.replace(' ', 'T')); if (isNaN(t)) return '';
          var ms = t - new Date(); if (ms <= 0) return '';
          var d = Math.floor(ms / 864e5), h = Math.floor(ms % 864e5 / 36e5), m = Math.floor(ms % 36e5 / 6e4);
          return d > 0 ? d + 'd ' + h + 'h' : (h > 0 ? h + 'h ' + m + 'm' : m + 'm');
        }
        function layout(personal) {
          extra.forEach(function (x) { x.remove(); }); extra = [];
          var main = rows.filter(function (r) { return r.dataset.go === '1' && r.dataset.ckTz !== 'checkin' && r.dataset.ckTz !== 'desk'; });
          var rank = { open: 0, last: 0, soon: 1, here: 2, invite: 3, off: 4 };
          function rk(x) { return Object.prototype.hasOwnProperty.call(rank, x) ? rank[x] : 9; }
          main.sort(function (a, b) { return rk(a.dataset.status) - rk(b.dataset.status); });
          var adds = [];
          if (personal) adds.push(line(personal));
          if (td.dataset.final) adds.push(line({ name: 'Final call', sub: td.dataset.final + ' · few left', status: 'Last few', tone: 'soon', go: 'store' }));
          else if (td.dataset.new) adds.push(line({ name: 'Just in', sub: td.dataset.new, status: 'New', tone: 'open', go: 'store' }));
          var left = Math.max(1, 4 - adds.length);
          var shownMain = main.slice(0, left);
          var cd = launchIn();
          rows.forEach(function (r) {
            var on = full ? true : shownMain.indexOf(r) > -1;
            r.hidden = !on;
            if (r.dataset.ckTz === 'departures' && cd && ['open', 'last', 'off'].indexOf(r.dataset.status) < 0) { var sub = r.querySelector('[data-ck-tsub]'); if (sub) { sub.dataset.plain = sub.dataset.plain || sub.textContent; sub.textContent = 'Boarding opens in ' + cd; } }
          });
          main.concat(rows.filter(function (r) { return main.indexOf(r) < 0; })).forEach(function (r) { box.appendChild(r); });
          adds.reverse().forEach(function (a) { box.insertBefore(a, box.firstChild); extra.push(a); });
          count.textContent = '(' + rows.length + ')';
          more.firstChild.textContent = full ? 'Show less ' : (td.querySelector('[data-ck-today-more]').dataset.label || 'See the full board ');
          more.setAttribute('aria-expanded', String(full));
        }
        more.dataset.label = more.firstChild.textContent;
        more.addEventListener('click', function () { full = !full; layout(currentPersonal); });
        box.addEventListener('click', function (e) {
          if (e.target.closest('[data-ck-cart]')) { var c = document.querySelector('.header-actions__cart-icon, cart-drawer-component button, a[href$="/cart"]'); if (c) c.click(); return; }
          var m = e.target.closest('[data-ck-showmap]'); if (m) { e.preventDefault(); showOnMap(m.dataset.ckShowmap); }
        });
        var currentPersonal = null;
        function pick(items) {
          if (items > 0) return { personal: true, name: 'Your cart is waiting', sub: items + (items === 1 ? ' item' : ' items'), status: 'At the gate', tone: 'soon', go: 'cart' };
          if (hasPass) return { personal: true, name: 'You’re on board', sub: 'Seat reserved · we’ll email you', status: 'Confirmed', tone: 'open' };
          if (firstVisit) return { personal: true, name: 'First visit?', sub: 'Start at Check-in', status: 'Welcome', tone: 'here', go: 'checkin' };
          return null;
        }
        currentPersonal = pick(parseInt(td.dataset.cartCount, 10) || 0);
        layout(currentPersonal);
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) { var p2 = pick(c.item_count || 0); if (JSON.stringify(p2) !== JSON.stringify(currentPersonal)) { currentPersonal = p2; layout(currentPersonal); } })
          .catch(function () {});
        setInterval(function () { if (td.dataset.launch) layout(currentPersonal); }, 60000);
      })();
      // v19 phones: "New here?" opens the explanation of the terminal words.
      (function () {
        var cpt = root.querySelector('[data-ck-concept]'), how = root.querySelector('[data-ck-how]');
        if (!cpt || !how) return;
        how.addEventListener('click', function () {
          var open = !cpt.classList.contains('is-open');
          cpt.classList.toggle('is-open', open); how.setAttribute('aria-expanded', String(open));
          how.querySelector('.ck-how__sign').textContent = open ? '−' : '+';
        });
      })();
      // While on screen and the tab is visible: run fn now (on becoming visible) and every `every` ms.
      function whileVisible(el, every, fn) {
        var onScreen = false, timer = null;
        function sync() {
          var go = onScreen && !document.hidden;
          if (go && !timer) { fn(true); timer = setInterval(function () { fn(false); }, every); }
          if (!go && timer) { clearInterval(timer); timer = null; }
        }
        if (!('IntersectionObserver' in window)) return;
        new IntersectionObserver(function (es) { onScreen = es[es.length - 1].isIntersecting; sync(); }).observe(el);
        document.addEventListener('visibilitychange', sync);
      }

      // Departures split-flap: cycles the codes (or names) from the section setting.
      var LET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ', DIG = '0123456789';
      function flapSteps(from, to) {
        var out = [], i, k;
        if (DIG.indexOf(to) > -1 && to !== '') {
          if (DIG.indexOf(from) > -1 && from !== '') { i = DIG.indexOf(from); while (DIG.charAt(i) !== to) { i = (i + 1) % 10; out.push(DIG.charAt(i)); } return out; }
          i = (DIG.indexOf(to) + 7) % 10;
          for (k = 0; k < 3; k++) { i = (i + 1) % 10; out.push(DIG.charAt(i)); }
          return out;
        }
        for (k = 0; k < (to === ' ' || to === '' ? 2 : 3); k++) out.push(LET.charAt(Math.floor(Math.random() * 26)));
        out.push(to);
        return out;
      }
      Array.prototype.slice.call(root.querySelectorAll('[data-ck-sf]')).forEach(function (el) {
        var flaps = Array.prototype.slice.call(el.querySelectorAll('.ck-sf__row i')), sr = el.querySelector('[data-ck-sf-text]');
        var codes = (el.getAttribute('data-codes') || '').split(',').map(function (s) { return s.trim().toUpperCase(); }).filter(Boolean);
        if (reduce || codes.length < 2 || !flaps.length) return;
        function cells(s) { var a = []; for (var i = 0; i < flaps.length; i++) a.push(i < s.length ? s.charAt(i) : ''); return a; }
        function put(f, ch, last) {
          f.textContent = ch === ' ' ? '' : ch;
          if (last) f.classList.toggle('is-gap', ch === ' ');
          f.classList.remove('is-flip'); void f.offsetWidth; f.classList.add('is-flip');
        }
        var idx = 0, cur = cells(codes[0]), pending = [];
        function show(next) {
          pending.forEach(clearTimeout); pending = [];
          var target = cells(next);
          target.forEach(function (ch, i) {
            if (cur[i] === ch) return;
            var steps = flapSteps(cur[i], ch);
            steps.forEach(function (s, k) {
              pending.push(setTimeout(function () { put(flaps[i], s, k === steps.length - 1); }, i * 70 + k * 75));
            });
          });
          cur = target;
          if (sr) sr.textContent = next;
        }
        whileVisible(el, 3500, function (first) { if (first) return; idx = (idx + 1) % codes.length; show(codes[idx]); });
      });

      // Arrivals: the six vessels land one after another, then replay gently every 12s.
      Array.prototype.slice.call(root.querySelectorAll('[data-ck-land]')).forEach(function (el) {
        if (reduce || el.hasAttribute('data-landed') || !('IntersectionObserver' in window)) return;
        el.setAttribute('data-ck-land', 'wait');
        whileVisible(el, 12000, function () {
          el.setAttribute('data-ck-land', '');
          el.classList.remove('is-landing'); void el.offsetWidth; el.classList.add('is-landing');
        });
      });

      // Private lounge: the candlelight behind the glass moves only while the map is on screen.
      Array.prototype.slice.call(root.querySelectorAll('[data-ck-lounge]')).forEach(function (el) {
        if (reduce || el.classList.contains('is-open') || !('IntersectionObserver' in window)) return;
        var seen = false;
        function sync() { el.classList.toggle('is-on', seen && !document.hidden); }
        new IntersectionObserver(function (es) { seen = es[es.length - 1].isIntersecting; sync(); }).observe(el);
        document.addEventListener('visibilitychange', sync);
      });

      // The ANTARO Store: the shop window shows one item at a time (tile, phone card and laptop panel stay in step),
      // behind a shutter that rolls up the first time each map comes into view.
      var swCountEl = root.querySelector('[data-sw-count]');
      var swM = swCountEl ? parseInt(swCountEl.getAttribute('data-sw-count'), 10) || 0 : 0;
      if (swM > 0) {
        var swItems = Array.prototype.slice.call(root.querySelectorAll('[data-sw-item]'));
        var swDots = Array.prototype.slice.call(root.querySelectorAll('[data-sw-dot]'));
        var swPos = Array.prototype.slice.call(root.querySelectorAll('[data-sw-pos]'));
        var swTiles = Array.prototype.slice.call(root.querySelectorAll('[data-sw-tile]'));
        var swI = 0, swHold = 0, swTimer = null, swVis = swTiles.map(function () { return false; });
        // v20: the phone card's window is a swipe row. Swiping moves the dots and the map tile with it,
        // and once someone has swiped, the window stops turning by itself.
        var swTracks = Array.prototype.slice.call(root.querySelectorAll('.ck-pcard [data-sw-track]'));
        var swUser = false, swTouchAt = 0;
        function swStep(tr) { var it = tr.querySelectorAll('.ck-swc__item'); return it.length > 1 ? it[1].offsetLeft - it[0].offsetLeft : 0; }
        function swScrollTo(i, smooth) {
          swTracks.forEach(function (tr) {
            var st = swStep(tr); if (!st || !tr.offsetWidth) return;
            tr.scrollTo({ left: st * i, behavior: smooth && !reduce ? 'smooth' : 'auto' });
          });
        }
        swTracks.forEach(function (tr) {
          function touched() { swUser = true; swTouchAt = Date.now(); }
          tr.addEventListener('touchstart', touched, { passive: true });
          tr.addEventListener('pointerdown', touched);
          tr.addEventListener('wheel', touched, { passive: true });
          var raf = 0;
          tr.addEventListener('scroll', function () {
            if (Date.now() - swTouchAt > 1500) return;
            swTouchAt = Date.now();
            clearTimeout(raf);
            raf = setTimeout(function () {
              var st = swStep(tr); if (!st) return;
              var k = Math.max(0, Math.min(swM - 1, Math.round(tr.scrollLeft / st)));
              if (k !== swI) swShow(k, false, true);
            }, 60);
          }, { passive: true });
        });
        Array.prototype.slice.call(root.querySelectorAll('.ck-pz--store')).forEach(function (el) {
          el.addEventListener('click', function () { setTimeout(function () { swScrollTo(swI, false); }, 40); });
        });
        function swShow(i, anim, fromTrack) {
          swI = i;
          if (!fromTrack) swScrollTo(i, anim);
          swItems.forEach(function (el) {
            var on = parseInt(el.getAttribute('data-sw-item'), 10) === i;
            el.hidden = !on;
            if (on && anim && !reduce) { el.classList.remove('is-in'); void el.offsetWidth; el.classList.add('is-in'); }
          });
          swDots.forEach(function (d) { var on = parseInt(d.getAttribute('data-sw-dot'), 10) === i; d.classList.toggle('is-on', on); d.setAttribute('aria-pressed', String(on)); });
          swPos.forEach(function (p) { p.textContent = (i + 1) + ' of ' + swM; });
        }
        function swPause() { swHold = Date.now() + 8000; }
        swDots.forEach(function (d) { d.addEventListener('click', function () { swPause(); swShow(parseInt(d.getAttribute('data-sw-dot'), 10), true); }); });
        Array.prototype.slice.call(root.querySelectorAll('[data-sw-card], .ck-zone--store, .ck-pz--store')).forEach(function (el) {
          el.addEventListener('pointerdown', swPause); el.addEventListener('focusin', swPause);
        });
        if ('IntersectionObserver' in window) {
          var swSync = function () {
            var go = !reduce && swM > 1 && !document.hidden && swVis.some(Boolean);
            if (go && !swTimer) swTimer = setInterval(function () { if (swUser || Date.now() < swHold) return; swShow((swI + 1) % swM, true); }, 3200);
            if (!go && swTimer) { clearInterval(swTimer); swTimer = null; }
          };
          var swIO = new IntersectionObserver(function (es) {
            es.forEach(function (e) {
              var k = swTiles.indexOf(e.target);
              if (k > -1) swVis[k] = e.isIntersecting;
              var sh = e.target.querySelector('.ck-sw__shutter.is-down');
              if (sh && e.isIntersecting && e.intersectionRatio >= 0.6) sh.classList.add('is-up');
            });
            swSync();
          }, { threshold: [0, 0.6, 1] });
          swTiles.forEach(function (t) {
            var sh = t.querySelector('.ck-sw__shutter');
            if (sh && !reduce) sh.classList.add('is-down');
            swIO.observe(t);
          });
          document.addEventListener('visibilitychange', swSync);
        }
      }

      // Phone map: a status line never wraps mid-phrase. If it doesn't fit on one line it tries 10.5px;
      // if it still doesn't fit, it breaks only at " · " (each part is nowrap).
      var stEls = Array.prototype.slice.call(root.querySelectorAll('[data-ck-st]'));
      function fitStatus() {
        stEls.forEach(function (s) {
          var t = s.querySelector('.ck-pz__st');
          s.classList.remove('is-tight');
          if (!t || !s.offsetWidth) return;
          function lines() { return Math.round(t.getBoundingClientRect().height / (parseFloat(getComputedStyle(t).lineHeight) || 14)); }
          if (lines() > 1) { s.classList.add('is-tight'); if (lines() > 1) s.classList.remove('is-tight'); }
        });
      }

      function settle() {
        fitStatus();
        walkPlan(root.querySelector('.ck-zone.is-on'), true);
        walkPhone(root.querySelector('.ck-pz.is-on'), true);
      }
      settle();
      var rt;
      window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(settle, 150); });
      window.addEventListener('load', settle);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(settle);
    }
    function all() { document.querySelectorAll('[data-ck]').forEach(boot); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
    document.addEventListener('shopify:section:load', function (e) { boot(e.target.querySelector('[data-ck]')); });
  })();

  /* The Lounge: works out Open / Last call / Resting / Closed (London time) and keeps it current. */
  (function () {
    function london() {
      try {
        var p = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date());
        var h = 0, m = 0; p.forEach(function (x) { if (x.type === 'hour') h = +x.value % 24; if (x.type === 'minute') m = +x.value; });
        return h * 60 + m;
      } catch (e) { var d = new Date(); return d.getHours() * 60 + d.getMinutes(); }
    }
    function mins(t) { var a = /^(\d{1,2}):(\d{2})$/.exec(t || ''); return a ? (+a[1]) * 60 + (+a[2]) : null; }
    function nice(t) { var n = mins(t); if (n === null) return t; var h = Math.floor(n / 60), m = n % 60, ap = h < 12 ? 'am' : 'pm'; var hh = h % 12 || 12; return hh + (m ? ':' + (m < 10 ? '0' : '') + m : '') + ap; }
    function niceDate(d) { try { return new Date(d + 'T12:00:00').toLocaleDateString('en-GB', { day: 'numeric', month: 'long' }); } catch (e) { return d; } }
    function read(src) {
      return { section: src.getAttribute('data-section'), open: src.getAttribute('data-open') === 'true', guest: src.getAttribute('data-guest') === 'true', name: src.getAttribute('data-name') || 'The Lounge',
        note: src.getAttribute('data-note') || '', back: src.getAttribute('data-back') || '', hours: src.getAttribute('data-hours') === 'true', from: src.getAttribute('data-from') || '07:00', to: src.getAttribute('data-to') || '23:00' };
    }
    function work(c) {
      if (!c.open) return { k: 'resting', t: 'Resting' + (c.back ? ' · back ' + niceDate(c.back) : '') };
      if (c.hours) {
        var now = london(), f = mins(c.from), t = mins(c.to);
        if (f !== null && t !== null) {
          var inside = f < t ? (now >= f && now < t) : (now >= f || now < t);
          if (!inside) return { k: 'closed', t: 'Closed · opens ' + nice(c.from) };
          var left = (t - now + 1440) % 1440;
          if (left <= 30) return { k: 'last', t: 'Last call · closes ' + c.to };
        }
      }
      return { k: 'open', t: c.guest ? 'Open · your seat is ready' : 'Open · by invitation' };
    }
    function apply(root, c) {
      var st = work(c);
      root.setAttribute('data-ck-lstate', st.k);
      root.querySelectorAll('[data-ck-lounge]').forEach(function (el) { el.setAttribute('data-lstate', st.k); });
      root.querySelectorAll('[data-ck-lst]').forEach(function (el) { el.textContent = st.t; });
      root.querySelectorAll('[data-ck-lname]').forEach(function (el) { el.textContent = c.name; });
      root.querySelectorAll('.ck-pz--atelier .ck-pz__st').forEach(function (el) {
        var parts = st.t.split(' · ');
        el.innerHTML = '';
        parts.forEach(function (p, i) { var s = document.createElement('span'); s.className = 'ck-pz__stp'; s.textContent = p + (i < parts.length - 1 ? ' ·' : ''); el.appendChild(s); if (i < parts.length - 1) el.appendChild(document.createTextNode(' ')); });
      });
      root.querySelectorAll('[data-ck-lnote]').forEach(function (el) { el.textContent = c.note; el.hidden = !(st.k === 'resting' && c.note); });
      root.querySelectorAll('[data-ck-lhours]').forEach(function (el) { el.textContent = 'Opening hours ' + c.from + '–' + c.to; el.hidden = !c.hours; });
    }
    function boot(root) {
      var src = root.querySelector('[data-ck-lsrc]');
      if (!src || root.dataset.ckLready) return;
      root.dataset.ckLready = '1';
      var c = read(src);
      apply(root, c);
      setInterval(function () {
        if (document.hidden) return;
        fetch(location.pathname + '?section_id=' + encodeURIComponent(c.section), { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.text() : null; })
          .then(function (html) {
            if (!html) { apply(root, c); return; }
            var m = /<span hidden data-ck-lsrc[^>]*>/.exec(html);
            if (m) { var tmp = document.createElement('div'); tmp.innerHTML = m[0] + '</span>'; var n = tmp.firstChild; if (n) c = read(n); }
            apply(root, c);
          })
          .catch(function () { apply(root, c); });
      }, 60000);
    }
    function all() { document.querySelectorAll('[data-ck]').forEach(boot); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
    document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('[data-ck]'); if (r) boot(r); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["antaro-core-arrivals"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function boot(root) {
      if (!root || root.dataset.caReady) return;
      root.dataset.caReady = '1';
      document.body.classList.add('ca-page');

      var g = root.querySelector('[data-ca-greeting]'), c = root.querySelector('[data-ca-clock]');
      function tick() {
        var parts = {};
        try {
          new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', hour: '2-digit', minute: '2-digit', hour12: false })
            .formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
        } catch (e) { var d = new Date(); parts.hour = ('0' + d.getHours()).slice(-2); parts.minute = ('0' + d.getMinutes()).slice(-2); }
        var h = parseInt(parts.hour, 10);
        if (g) g.textContent = h < 12 ? 'Good morning' : (h < 18 ? 'Good afternoon' : 'Good evening');
        if (c) c.textContent = parts.hour + ':' + parts.minute + ' London';
      }
      tick(); setInterval(tick, 30000);

      // v32: choosing a candle changes the world and opens its baggage tag.
      var rows = Array.prototype.slice.call(root.querySelectorAll('[data-ca-row]'));
      var layers = root.querySelectorAll('[data-ca-layer]');
      var tag = root.querySelector('.ca-tag');
      var body = root.querySelector('[data-ca-body]');
      var scroller = root.querySelector('[data-ca-scroll]');
      var scrim = root.querySelector('[data-ca-scrim]');
      var stamp = root.querySelector('[data-ca-stamp]');
      var jumps = Array.prototype.slice.call(root.querySelectorAll('[data-ca-jump]'));
      var posEl = root.querySelector('[data-ca-pos]'), prevEl = root.querySelector('[data-ca-prev]'), nextEl = root.querySelector('[data-ca-next]');
      var stubFrom = root.querySelector('[data-ca-stub-from]'), stubTag = root.querySelector('[data-ca-stub-tag]');
      var cartLine = root.querySelector('[data-ca-cartline]'), cartText = root.querySelector('[data-ca-cart-text]');
      var currency = (tag && tag.dataset.currency) || 'GBP';
      var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
      var sheetMq = window.matchMedia('(max-width: 989px)');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      var n = rows.length, cur = 0, cartState = null;
      if (!n || !tag || !body) return;

      function lum(hex) {
        var m = /^#?([0-9a-f]{6})$/i.exec((hex || '').trim()); if (!m) return 1;
        var v = parseInt(m[1], 16), c = [(v >> 16) & 255, (v >> 8) & 255, v & 255].map(function (x) {
          x /= 255; return x <= 0.03928 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4); });
        return 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
      }
      function world(i) {
        layers.forEach(function (l, k) { l.classList.toggle('is-on', k === i); });
        var l = layers[i]; if (!l) return;
        var col = l.style.getPropertyValue('--c').trim();
        var dark = l.querySelector('img') ? true : lum(col) < 0.2;
        root.dataset.tone = dark ? 'dark' : 'light';
        document.body.style.setProperty('--ca-body', col || '#efe9df');
      }
      function money(c) { try { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: currency }).format(c / 100); } catch (e) { return '£' + (c / 100).toFixed(2); } }

      function isOpen() { return root.classList.contains('is-open'); }
      function openSheet() {
        if (!sheetMq.matches || isOpen()) return;
        if (scrim) scrim.hidden = false;
        void tag.offsetWidth;
        root.classList.add('is-open');
        document.documentElement.style.overflow = 'hidden';
        tag.setAttribute('role', 'dialog'); tag.setAttribute('aria-modal', 'true');
        var c = root.querySelector('[data-ca-close]'); setTimeout(function () { if (c) c.focus({ preventScroll: true }); }, 60);
      }
      function closeSheet() {
        if (!isOpen()) return;
        root.classList.remove('is-open');
        document.documentElement.style.overflow = '';
        tag.removeAttribute('role'); tag.removeAttribute('aria-modal');
        setTimeout(function () { if (scrim && !isOpen()) scrim.hidden = true; }, 320);
        var h = rows[cur] && rows[cur].querySelector('[data-ca-pick]'); if (h) h.focus({ preventScroll: true });
      }
      if (scrim) scrim.addEventListener('click', closeSheet);
      var cb = root.querySelector('[data-ca-close]'); if (cb) cb.addEventListener('click', closeSheet);
      var onMq = function () { if (!sheetMq.matches && isOpen()) closeSheet(); };
      if (sheetMq.addEventListener) sheetMq.addEventListener('change', onMq); else if (sheetMq.addListener) sheetMq.addListener(onMq);

      function select(i, fromTap) {
        cur = (i + n) % n;
        rows.forEach(function (r, k) {
          r.classList.toggle('is-on', k === cur);
          var h = r.querySelector('[data-ca-pick]'); if (h) h.setAttribute('aria-pressed', k === cur ? 'true' : 'false');
        });
        jumps.forEach(function (b, k) { b.setAttribute('aria-pressed', k === cur ? 'true' : 'false'); });
        world(cur);
        var tpl = root.querySelector('template[data-ca-tag="' + cur + '"]');
        body.innerHTML = '';
        if (tpl) body.appendChild(tpl.content.cloneNode(true));
        if (stamp) stamp.classList.remove('is-on');
        var r = rows[cur];
        if (posEl) posEl.textContent = (cur + 1) + ' of ' + n;
        if (prevEl) prevEl.textContent = rows[(cur - 1 + n) % n].dataset.caName || '';
        if (nextEl) nextEl.textContent = rows[(cur + 1) % n].dataset.caName || '';
        if (stubFrom) stubFrom.textContent = r.dataset.caFrom || '';
        if (stubTag) stubTag.textContent = 'CR ' + (r.dataset.caCode || '');
        if (scroller) scroller.scrollTop = 0;
        var aj = jumps[cur];
        if (aj && isOpen()) { try { aj.scrollIntoView({ block: 'nearest', inline: 'center', behavior: reduce.matches ? 'auto' : 'smooth' }); } catch (e) {} }
        bindBuy(); renderBuy();
        if (fromTap) openSheet();
      }
      function step(d) { select(cur + d, false); }
      rows.forEach(function (r, k) {
        var h = r.querySelector('[data-ca-pick]');
        if (h) h.addEventListener('click', function () { select(k, true); });
      });
      root.querySelectorAll('[data-ca-step]').forEach(function (b) { b.addEventListener('click', function () { step(Number(b.dataset.caStep)); }); });
      jumps.forEach(function (b) { b.addEventListener('click', function () { select(Number(b.dataset.caJump), false); }); });

      // cart
      function lineFor(vid) {
        if (!cartState || !cartState.items) return null;
        for (var k = 0; k < cartState.items.length; k++) if (String(cartState.items[k].variant_id) === String(vid)) return cartState.items[k];
        return null;
      }
      function renderBuy() {
        var btn = body.querySelector('[data-ca-add]'), st = body.querySelector('[data-ca-stepper]');
        if (btn && st) {
          var line = lineFor(st.dataset.variantId), q = line ? line.quantity : 0;
          btn.hidden = q > 0; st.hidden = q === 0;
          var t = st.querySelector('[data-ca-qty-text]'); if (t) t.textContent = q + ' in your cart';
          var max = Number(st.dataset.max || 0), plus = st.querySelector('[data-ca-qty="1"]');
          if (plus) plus.disabled = max > 0 && q >= max;
          if (q > 0 && stamp) stamp.classList.add('is-on');
        }
        var tw = body.querySelector('[data-ca-add-twin]'), both = body.querySelector('[data-ca-add-both]'), bnote = body.querySelector('.ca-tag__both-note');
        var tinIn = tw ? !!lineFor(tw.dataset.caAddTwin) : false, coreIn = false;
        if (both) { coreIn = !!lineFor(both.dataset.caAddBoth.split(',')[0]); both.hidden = tinIn || coreIn; if (bnote) bnote.hidden = both.hidden; }
        if (tw) tw.textContent = tinIn ? tw.dataset.done : ((both && !both.hidden) ? tw.dataset.with : tw.dataset.solo);
        var oneEl = body.querySelector('[data-ca-one]'); if (oneEl && !oneEl.dataset.base) oneEl.dataset.base = oneEl.textContent;
        earlyRules();
      }
      function markCart(cart) {
        if (!cart || !cart.items) return;
        cartState = cart;
        var ids = cart.items.map(function (it) { return String(it.product_id); });
        rows.forEach(function (r, k) {
          var inCart = !!r.dataset.productId && ids.indexOf(r.dataset.productId) !== -1;
          if (jumps[k]) jumps[k].classList.toggle('is-in-cart', inCart);
        });
        if (cartLine && cartText) {
          if (cart.item_count > 0) { cartText.textContent = cart.item_count + ' in cart · ' + money(cart.total_price); cartLine.hidden = false; }
          else cartLine.hidden = true;
        }
        renderBuy();
      }
      function getCart() { return fetch(routeRoot + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
      function announce(cart) {
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'ca-arrivals', data: { source: 'ca-arrivals', itemCount: cart.item_count } } }));
      }
      function showError(msg) { var e = body.querySelector('[data-ca-error]'); if (e) { e.textContent = msg || 'Something went wrong. Please try again.'; e.hidden = false; } }
      function post(path, payload) {
        return fetch(routeRoot + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) })
          .then(function (res) { return res.json().then(function (d) { if (!res.ok) throw new Error(d.description || d.message || 'Could not update your cart.'); return d; }); });
      }
      // v56: early arrivals — one Core candle each, marked _early_arrival on the order.
      var early = root.dataset.caEarly === '1', claimed = root.dataset.caClaimed || '';
      var coreIds = {};
      Array.prototype.forEach.call(root.querySelectorAll('template[data-ca-tag]'), function (t) { var a = t.content.querySelector('[data-ca-add]'); if (a && a.dataset.caAdd) coreIds[String(a.dataset.caAdd)] = true; });
      function coreLine() { if (!cartState || !cartState.items) return null; for (var k = 0; k < cartState.items.length; k++) if (coreIds[String(cartState.items[k].variant_id)]) return cartState.items[k]; return null; }
      function markEarly(items) { if (!early) return items; return items.map(function (it) { return coreIds[String(it.id)] ? { id: it.id, quantity: 1, properties: { _early_arrival: 'Early arrival' } } : it; }); }
      function earlyRules() {
        if (!early) return;
        var btn = body.querySelector('[data-ca-add]'), set = body.querySelector('[data-ca-add-set]'), one = body.querySelector('[data-ca-one]');
        var mine = btn ? String(btn.dataset.caAdd) : '', other = coreLine(), blocked = '';
        if (claimed) blocked = 'You\'ve already chosen ' + claimed + '.';
        else if (other && String(other.variant_id) !== mine) blocked = 'One Core candle per early arrival. ' + (other.product_title || 'Another candle').split(' — ')[0] + ' is in your cart.';
        if (btn) { btn.disabled = !!blocked; if (blocked) btn.hidden = false; }
        if (set) set.disabled = !!blocked || !!(other && String(other.variant_id) === mine);
        if (one) one.textContent = blocked || one.dataset.base || one.textContent;
      }
      function addItems(btn, items, stampIt) {
        items = markEarly(items);
        btn.classList.add('is-loading');
        var e = body.querySelector('[data-ca-error]'); if (e) e.hidden = true;
        post('cart/add.js', { items: items })
          .then(function () { if (stampIt && stamp) stamp.classList.add('is-on'); return getCart(); })
          .then(function (cart) { btn.classList.remove('is-loading'); markCart(cart); announce(cart); })
          .catch(function (err) { btn.classList.remove('is-loading'); showError(err.message); });
      }
      function bindBuy() {
        var btn = body.querySelector('[data-ca-add]');
        if (btn) btn.addEventListener('click', function () { addItems(btn, [{ id: Number(btn.dataset.caAdd), quantity: 1 }], true); });
        var tw = body.querySelector('[data-ca-add-twin]');
        if (tw) tw.addEventListener('click', function () { if (!lineFor(tw.dataset.caAddTwin)) addItems(tw, [{ id: Number(tw.dataset.caAddTwin), quantity: 1 }], false); });
        var bo = body.querySelector('[data-ca-add-both]');
        if (bo) bo.addEventListener('click', function () {
          var ids = bo.dataset.caAddBoth.split(',');
          addItems(bo, ids.map(function (id) { return { id: Number(id), quantity: 1 }; }), true);
        });
        var set = body.querySelector('[data-ca-add-set]');
        if (set) set.addEventListener('click', function () {
          var ids = set.dataset.caAddSet.split(',');
          addItems(set, ids.map(function (id) { return { id: Number(id), quantity: 1 }; }), true);
        });
        var st = body.querySelector('[data-ca-stepper]');
        if (st) st.querySelectorAll('[data-ca-qty]').forEach(function (b) {
          b.addEventListener('click', function () {
            var line = lineFor(st.dataset.variantId); if (!line) return;
            var q = Math.max(0, line.quantity + Number(b.dataset.caQty));
            st.classList.add('is-loading');
            post('cart/change.js', { id: line.key, quantity: q })
              .then(function (cart) { st.classList.remove('is-loading'); if (q === 0 && stamp) stamp.classList.remove('is-on'); markCart(cart); announce(cart); })
              .catch(function (err) { st.classList.remove('is-loading'); showError(err.message); });
          });
        });
      }
      document.addEventListener('cart:update', function (e) {
        var d = e.detail || {}; if (d.sourceId === 'ca-arrivals') return;
        if (d.resource && d.resource.items) markCart(d.resource); else getCart().then(markCart).catch(function () {});
      });
      window.addEventListener('pageshow', function (e) { if (e.persisted) getCart().then(markCart).catch(function () {}); });

      // keys + swipe
      root.addEventListener('keydown', function (e) {
        var t = (e.target && e.target.tagName) || '';
        if (t === 'INPUT' || t === 'TEXTAREA' || t === 'SELECT') return;
        if (e.key === 'Escape' && isOpen()) { closeSheet(); return; }
        if ((e.key === 'ArrowRight' || e.key === 'ArrowLeft') && (tag.contains(e.target) || e.target.closest('.ca-board'))) {
          e.preventDefault(); step(e.key === 'ArrowRight' ? 1 : -1);
        }
      });
      if (scroller && 'ontouchstart' in window) {
        var sx = 0, sy = 0, on = false, top = false;
        scroller.addEventListener('touchstart', function (e) {
          if (e.touches.length !== 1) { on = false; return; }
          on = true; sx = e.touches[0].clientX; sy = e.touches[0].clientY; top = !!e.target.closest('.ca-tag__top, .ca-tag__hole');
        }, { passive: true });
        scroller.addEventListener('touchend', function (e) {
          if (!on || !isOpen()) return; on = false;
          if (e.target.closest('.ca-tag__jump')) return;
          var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
          if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) { step(dx < 0 ? 1 : -1); return; }
          if (dy > 70 && Math.abs(dy) > Math.abs(dx) * 1.5 && (top || scroller.scrollTop <= 0)) closeSheet();
        }, { passive: true });
      }

      // v32 step 6: time of day (London)
      function londonHour() {
        try { var p = {}; new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', hour: '2-digit', hour12: false }).formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; }); return parseInt(p.hour, 10) % 24; }
        catch (e) { return new Date().getHours(); }
      }
      function inHours(spec, hr) {
        var m = /^\s*(\d{1,2})\s*-\s*(\d{1,2})\s*$/.exec(spec || ''); if (!m) return false;
        var a = Number(m[1]) % 24, b = Number(m[2]); if (b > 24) return false;
        return a < b ? (hr >= a && hr < b) : (hr >= a || hr < b % 24);
      }
      var nowBox = root.querySelector('[data-ca-now]'), nowIdx = -1;
      function renderNow() {
        var hr = londonHour(); nowIdx = -1;
        rows.forEach(function (r, k) { if (nowIdx < 0 && inHours(r.dataset.caHours, hr)) nowIdx = k; });
        rows.forEach(function (r, k) { var t = r.querySelector('[data-ca-nowtag]'); if (t) t.hidden = k !== nowIdx; });
        if (!nowBox) return;
        if (nowIdx < 0) { nowBox.hidden = true; return; }
        var r = rows[nowIdx], mo = (r.dataset.caMoment || '').trim();
        var greet = hr >= 5 && hr < 12 ? 'Good morning' : (hr >= 12 && hr < 18 ? 'Good afternoon' : 'Good evening');
        var txt = (nowBox.dataset.tpl || '').replace('[greeting]', greet).replace('[name]', r.dataset.caName || '').replace('[moment]', mo ? mo.charAt(0).toLowerCase() + mo.slice(1) : '');
        nowBox.querySelector('[data-ca-now-text]').textContent = txt.replace(/:\s*\.$/, '.');
        nowBox.hidden = false;
      }
      renderNow(); setInterval(renderNow, 60000);
      var nowGo = root.querySelector('[data-ca-now-go]');
      if (nowGo) nowGo.addEventListener('click', function () { if (nowIdx >= 0) select(nowIdx, true); });

      // v32 step 6: Home & away pairs
      root.querySelectorAll('[data-ca-pair]').forEach(function (b) {
        b.addEventListener('click', function () {
          select(Number(b.dataset.caPair), true);
          if (!sheetMq.matches) { try { tag.scrollIntoView({ block: 'nearest', behavior: reduce.matches ? 'auto' : 'smooth' }); } catch (e) {} }
          var pb = body.querySelector('[data-ca-pairbox]');
          if (pb) {
            pb.classList.remove('is-flash'); void pb.offsetWidth; pb.classList.add('is-flash');
            setTimeout(function () { try { pb.scrollIntoView({ block: 'nearest', behavior: reduce.matches ? 'auto' : 'smooth' }); } catch (e) {} }, sheetMq.matches ? 380 : 0);
          }
        });
      });

      // v32 step 6: "Where will it live?" finder
      var fd = root.querySelector('[data-ca-finder]');
      var fdOpeners = Array.prototype.slice.call(root.querySelectorAll('[data-ca-finder-open]'));
      if (fd) {
        var s1 = fd.querySelector('[data-cf-s1]'), s2 = fd.querySelector('[data-cf-s2]'), s3 = fd.querySelector('[data-cf-s3]');
        var stepEl = fd.querySelector('[data-cf-step]'), bar2 = fd.querySelector('[data-cf-bar2]');
        var t1 = fd.querySelector('[data-cf-s1-title]'), t2 = fd.querySelector('[data-cf-s2-title]'), t3 = fd.querySelector('[data-cf-s3-title]');
        var gp = fd.querySelector('[data-cf-giftpass]'), stillName = (fd.dataset.still || 'STILL').toUpperCase();
        var room = '', gift = false, labels = { s1: stepEl ? stepEl.textContent : 'Step 1 of 2' };
        function fshow(k) {
          s1.hidden = k !== 1; s2.hidden = k !== 2; s3.hidden = k !== 3;
          if (stepEl) stepEl.textContent = k === 1 ? labels.s1 : (k === 2 ? labels.s1.replace('1', '2') : (gift ? 'Their candle' : 'Your candle'));
          if (bar2) bar2.classList.toggle('on', k > 1);
        }
        function fopen(scroll) {
          fd.hidden = false; fshow(1);
          fdOpeners.forEach(function (o) { o.setAttribute('aria-expanded', 'true'); });
          if (scroll) { try { fd.scrollIntoView({ block: 'start', behavior: reduce.matches ? 'auto' : 'smooth' }); } catch (e) {} }
          setTimeout(function () { t1.focus({ preventScroll: true }); }, scroll ? 350 : 0);
        }
        function fclose() {
          fd.hidden = true; fdOpeners.forEach(function (o) { o.setAttribute('aria-expanded', 'false'); });
          if (fdOpeners[0]) fdOpeners[0].focus({ preventScroll: true });
        }
        fdOpeners.forEach(function (o) { o.addEventListener('click', function () { if (fd.hidden) fopen(true); else fclose(); }); });
        fd.querySelector('[data-cf-close]').addEventListener('click', fclose);
        fd.querySelectorAll('[data-cf-room]').forEach(function (b) {
          b.addEventListener('click', function () {
            gift = b.hasAttribute('data-cf-gift'); room = b.dataset.cfRoom || '';
            t2.textContent = gift ? t2.dataset.gift : t2.dataset.me;
            fd.querySelectorAll('[data-cf-opts]').forEach(function (g) { g.hidden = g.dataset.cfOpts !== (gift ? 'gift' : 'me'); });
            fshow(2); t2.focus({ preventScroll: true });
          });
        });
        fd.querySelectorAll('[data-cf-pick]').forEach(function (b) {
          b.addEventListener('click', function () {
            var k = b.dataset.cfPick;
            fd.querySelectorAll('[data-cf-result]').forEach(function (r) { r.hidden = r.dataset.cfResult !== k; });
            var tpl = gift ? t3.dataset.gift : t3.dataset.me;
            t3.textContent = tpl.replace('[room]', room.toLowerCase());
            if (gp) gp.hidden = !(gift && rows[Number(k)] && (rows[Number(k)].dataset.caName || '').toUpperCase() === stillName);
            fshow(3); t3.focus({ preventScroll: true });
          });
        });
        fd.querySelector('[data-cf-back]').addEventListener('click', function () { fshow(1); t1.focus({ preventScroll: true }); });
        fd.querySelector('[data-cf-restart]').addEventListener('click', function () { fshow(1); t1.focus({ preventScroll: true }); });
        fd.querySelectorAll('[data-cf-go]').forEach(function (b) {
          b.addEventListener('click', function () {
            var k = Number(b.dataset.cfGo);
            select(k, true);
            if (!sheetMq.matches) { try { rows[k].scrollIntoView({ block: 'center', behavior: reduce.matches ? 'auto' : 'smooth' }); } catch (e) {} }
          });
        });
      }

      // start: from #handle if given, else the candle for this hour, else the first (tag shown beside the board on desktop only)
      var startAt = nowIdx >= 0 ? nowIdx : 0, h = location.hash.replace('#', ''), hashRow = null;
      rows.forEach(function (r, k) { if (h && r.dataset.handle === h) { startAt = k; hashRow = r; } });
      if (fd && h === 'finder') setTimeout(function () { fopen(true); }, 300);
      select(startAt, false);
      getCart().then(markCart).catch(function () {});
      if (hashRow) setTimeout(function () { hashRow.scrollIntoView({ behavior: reduce.matches ? 'auto' : 'smooth', block: 'center' }); }, 250);
    }
    function all() { document.querySelectorAll('.ca').forEach(boot); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
    document.addEventListener('shopify:section:load', function (e) { boot(e.target.querySelector('.ca')); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["antaro-core-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function boot(root) {
      if (!root || root.dataset.cpReady) return;
      root.dataset.cpReady = '1';
      document.body.classList.add('cp-page');

      var routeRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var sticky = document.querySelector('[data-cp-for="' + root.id + '"]');
      function qa(sel) { var l = Array.prototype.slice.call(root.querySelectorAll(sel)); if (sticky) l = l.concat(Array.prototype.slice.call(sticky.querySelectorAll(sel))); return l; }
      var vid = root.dataset.variant, max = Number(root.dataset.max || 0);
      var cartState = null, currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
      function money(c) { try { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: currency }).format(c / 100); } catch (e) { return '£' + (c / 100).toFixed(2); } }
      function lineFor(id) {
        if (!cartState || !cartState.items) return null;
        for (var k = 0; k < cartState.items.length; k++) if (String(cartState.items[k].variant_id) === String(id)) return cartState.items[k];
        return null;
      }
      function showError(msg) { var e = root.querySelector('[data-cp-error]'); if (e) { e.textContent = msg || 'Something went wrong. Please try again.'; e.hidden = false; } }
      function clearError() { var e = root.querySelector('[data-cp-error]'); if (e) e.hidden = true; }

      function render() {
        var line = lineFor(vid), q = line ? line.quantity : 0;
        qa('[data-cp-buy]').forEach(function (box) {
          var add = box.querySelector('[data-cp-add]'), st = box.querySelector('[data-cp-stepper]');
          if (add) add.hidden = q > 0;
          if (st) {
            st.hidden = q === 0;
            var t = st.querySelector('[data-cp-q]'); if (t) t.textContent = q;
            var plus = st.querySelector('[data-cp-qty="1"]'); if (plus) plus.disabled = max > 0 && q >= max;
          }
        });
        var done = root.querySelector('[data-cp-done]'); if (done) done.hidden = q === 0;
        if (cartState) {
          var txt = cartState.item_count + ' in cart · ' + money(cartState.total_price);
          qa('[data-cp-cart-text]').forEach(function (el) { el.textContent = txt; });
          var sc = sticky && sticky.querySelector('[data-cp-sticky-cart]'); if (sc) sc.hidden = cartState.item_count === 0;
          var ids = cartState.items.map(function (it) { return String(it.product_id); });
          root.querySelectorAll('.cp-switch__chip').forEach(function (c) { c.classList.toggle('is-in-cart', ids.indexOf(c.dataset.productId) !== -1); });
        }
        var tw = root.querySelector('[data-cp-add-twin]');
        if (tw) tw.textContent = lineFor(tw.dataset.cpAddTwin) ? tw.dataset.done : tw.dataset.label;
        earlyRules();
      }
      function getCart() { return fetch(routeRoot + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
      function setCart(cart) { if (cart && cart.items) { cartState = cart; if (cart.currency) currency = cart.currency; render(); } }
      function announce(cart) {
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'cp-core', data: { source: 'cp-core', itemCount: cart.item_count } } }));
      }
      function post(path, payload) {
        return fetch(routeRoot + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) })
          .then(function (res) { return res.json().then(function (d) { if (!res.ok) throw new Error(d.description || d.message || 'Could not update your cart.'); return d; }); });
      }
      // v56: early arrivals — one Core candle each, marked _early_arrival on the order.
      var early = root.dataset.cpEarly === '1', claimed = root.dataset.cpClaimed || '';
      function isCore(it) { return /^core-collection-/.test(it.handle || ''); }
      function earlyRules() {
        if (!early) return;
        var other = null, mine = lineFor(vid);
        if (cartState && cartState.items) cartState.items.forEach(function (it) { if (isCore(it) && String(it.variant_id) !== String(vid)) other = it; });
        var msg = claimed ? 'You\'ve already chosen ' + claimed + '.' : (other ? 'One Core candle per early arrival. ' + (other.product_title || 'Another candle').split(' — ')[0] + ' is in your cart.' : '');
        qa('[data-cp-add]').forEach(function (b) { b.disabled = !!msg; });
        var sb = root.querySelector('[data-cp-set-add]'); if (sb) sb.disabled = !!msg || !!mine;
        var one = root.querySelector('[data-cp-one]'); if (one) { if (!one.dataset.base) one.dataset.base = one.textContent; one.textContent = msg || one.dataset.base; }
      }
      function addItems(btn, items) {
        if (early) items = items.map(function (it) { return String(it.id) === String(vid) || (btn.dataset && btn.dataset.candle && String(it.id) === String(btn.dataset.candle)) ? { id: it.id, quantity: 1, properties: { _early_arrival: 'Early arrival' } } : it; });
        btn.classList.add('is-loading'); btn.disabled = true; clearError();
        return post('cart/add.js', { items: items })
          .then(function () { return getCart(); })
          .then(function (cart) { btn.classList.remove('is-loading'); btn.disabled = false; setCart(cart); announce(cart); return cart; })
          .catch(function (err) { btn.classList.remove('is-loading'); btn.disabled = false; showError(err.message); });
      }

      qa('[data-cp-add]').forEach(function (b) {
        b.addEventListener('click', function () { addItems(b, [{ id: Number(vid), quantity: 1 }]); });
      });
      qa('[data-cp-stepper]').forEach(function (st) {
        st.querySelectorAll('[data-cp-qty]').forEach(function (b) {
          b.addEventListener('click', function () {
            var line = lineFor(vid); if (!line) return;
            var q = Math.max(0, line.quantity + Number(b.dataset.cpQty));
            st.classList.add('is-loading'); clearError();
            post('cart/change.js', { id: line.key, quantity: q })
              .then(function (cart) {
                st.classList.remove('is-loading');
                var after = null; for (var k = 0; k < cart.items.length; k++) if (String(cart.items[k].variant_id) === String(vid)) after = cart.items[k];
                if (after && after.quantity < q) showError('That is all we have of this candle right now.');
                setCart(cart); announce(cart);
              })
              .catch(function (err) { st.classList.remove('is-loading'); showError(err.message); });
          });
        });
      });
      var tw = root.querySelector('[data-cp-add-twin]');
      if (tw) tw.addEventListener('click', function () { if (!lineFor(tw.dataset.cpAddTwin)) addItems(tw, [{ id: Number(tw.dataset.cpAddTwin), quantity: 1 }]); });

      var set = root.querySelector('[data-cp-set]');
      if (set) {
        var thumb = set.querySelector('[data-cp-tote-thumb]');
        set.querySelectorAll('input[type=radio]').forEach(function (r) {
          r.addEventListener('change', function () { if (thumb && r.dataset.img) thumb.innerHTML = '<img src="' + r.dataset.img + '" alt="" width="80" height="80">'; });
        });
        var sb = set.querySelector('[data-cp-set-add]');
        sb.addEventListener('click', function () {
          var t = set.querySelector('input[type=radio]:checked'); if (!t) return;
          addItems(sb, [{ id: Number(sb.dataset.candle), quantity: 1 }, { id: Number(t.value), quantity: 1 }]).then(function (cart) {
            if (!cart) return; sb.textContent = sb.dataset.done; setTimeout(function () { sb.textContent = sb.dataset.label; }, 2400);
          });
        });
      }

      document.addEventListener('cart:update', function (e) {
        var d = e.detail || {}; if (d.sourceId === 'cp-core') return;
        if (d.resource && d.resource.items) setCart(d.resource); else getCart().then(setCart).catch(function () {});
      });
      window.addEventListener('pageshow', function (e) { if (e.persisted) getCart().then(setCart).catch(function () {}); });
      getCart().then(setCart).catch(function () {});

      var sw = root.querySelector('.cp-switch'), onChip = sw && sw.querySelector('.is-on');
      if (sw && onChip && sw.scrollWidth > sw.clientWidth) sw.scrollLeft = Math.max(0, onChip.offsetLeft - (sw.clientWidth - onChip.offsetWidth) / 2);

      // phone sticky bar: shows once the main buy block has scrolled up out of view
      var buy = root.querySelector('[data-cp-buy-main]');
      if (sticky && buy && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          var en = entries[0], on = !en.isIntersecting && en.boundingClientRect.top < 0;
          sticky.classList.toggle('is-on', on);
          sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
          if (on) sticky.removeAttribute('inert'); else sticky.setAttribute('inert', '');
        }, { threshold: 0 }).observe(buy);
      }

      // swipe on the candle, arrow keys anywhere
      var prev = root.querySelector('[data-cp-prev]'), next = root.querySelector('[data-cp-next]');
      var media = root.querySelector('[data-cp-swipe]'), sx = null, sy = null;
      if (media) {
        media.addEventListener('touchstart', function (e) { if (e.touches.length !== 1) { sx = null; return; } sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
        media.addEventListener('touchend', function (e) {
          if (sx === null) return;
          var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
          if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) { var go = dx < 0 ? next : prev; if (go) location.href = go.href; }
          sx = null;
        });
      }
      document.addEventListener('keydown', function (e) {
        if (e.target.closest && e.target.closest('input, textarea, select, [contenteditable]')) return;
        if (e.metaKey || e.ctrlKey || e.altKey) return;
        if (e.key === 'ArrowRight' && next) location.href = next.href;
        if (e.key === 'ArrowLeft' && prev) location.href = prev.href;
      });
    }
    function all() { document.querySelectorAll('.cp').forEach(boot); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
    document.addEventListener('shopify:section:load', function (e) { boot(e.target.querySelector('.cp')); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["antaro-departure-films"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    function init(root) {
      if (!root || root.dataset.awReady) return;
      root.dataset.awReady = '1';
      if (!root.querySelector('[data-aw-film]')) return;
      var playBtn = root.querySelector('[data-aw-play]');
      var soundBtn = root.querySelector('[data-aw-sound]');
      var soundLabel = root.querySelector('[data-aw-sound-label]');
      var current = null, inView = false, userPaused = false, soundOn = false;

      function stages() { return root.querySelectorAll('[data-aw-film]:not([data-aw-pending])'); }
      function picks() { return root.querySelectorAll('[data-aw-film-pick]'); }
      function videoOf(n) { var el = root.querySelector('[data-aw-film="' + n + '"]'); return el && el.querySelector('video'); }

      function setPlaying(on) { if (on) root.setAttribute('data-playing', ''); else root.removeAttribute('data-playing'); playBtn.setAttribute('aria-label', on ? 'Pause' : 'Play'); }

      function play() {
        var v = videoOf(current); if (!v) return;
        v.muted = !soundOn;
        var p = v.play(); if (p && p.then) p.then(function () { setPlaying(true); }).catch(function () { setPlaying(false); }); else setPlaying(true);
      }
      function pause() { var v = videoOf(current); if (v) v.pause(); setPlaying(false); }

      function show(n, restart) {
        stages().forEach(function (s) { var on = s.getAttribute('data-aw-film') === String(n); s.hidden = !on; if (!on) { var vv = s.querySelector('video'); if (vv) vv.pause(); } });
        picks().forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-aw-film-pick') === String(n) ? 'true' : 'false'); });
        current = n;
        var v = videoOf(n);
        if (v && restart) { try { v.currentTime = 0; } catch (e) {} }
        if (inView && !userPaused && !reduce.matches) play(); else setPlaying(false);
      }

      function bindPick(b) { b.addEventListener('click', function () { userPaused = false; show(b.getAttribute('data-aw-film-pick'), true); }); }
      picks().forEach(bindPick);

      // A film uploaded ahead of time unlocks itself at its release moment (the page may have been loaded or cached earlier).
      function checkReleases() {
        var now = Date.now() / 1000, newest = null;
        root.querySelectorAll('[data-aw-pending]').forEach(function (s) {
          if (Number(s.getAttribute('data-release')) > now) return;
          var n = s.getAttribute('data-aw-film');
          s.removeAttribute('data-aw-pending');
          var v = s.querySelector('video'); if (v) v.preload = 'metadata';
          var tile = root.querySelector('[data-aw-release-pick="' + n + '"]');
          if (tile) {
            var b = document.createElement('button');
            b.type = 'button'; b.className = 'aw-films__item'; b.setAttribute('data-aw-film-pick', n); b.setAttribute('aria-pressed', 'false');
            b.innerHTML = tile.querySelector('.aw-films__num').outerHTML + tile.querySelector('.aw-films__name').outerHTML + '<span class="aw-films__state">Now showing</span>';
            tile.replaceWith(b); bindPick(b);
          }
          if (newest === null || Number(n) > Number(newest)) newest = n;
        });
        if (newest !== null) show(newest, true);
      }
      checkReleases();
      if (root.querySelector('[data-aw-pending]')) setInterval(checkReleases, 15000);

      playBtn.addEventListener('click', function () { var v = videoOf(current); if (v && !v.paused) { userPaused = true; pause(); } else { userPaused = false; play(); } });
      soundBtn.addEventListener('click', function () {
        soundOn = !soundOn;
        soundBtn.setAttribute('aria-pressed', soundOn ? 'true' : 'false');
        soundLabel.textContent = soundOn ? 'Sound off' : 'Sound on';
        var v = videoOf(current); if (!v) return;
        if (soundOn) { try { v.currentTime = 0; } catch (e) {} userPaused = false; }
        play();
      });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          inView = entries[0].isIntersecting;
          if (inView && !userPaused && !reduce.matches) play(); else if (!inView) pause();
        }, { threshold: 0.45 }).observe(root.querySelector('.aw-films__frame'));
      }

      // Newest released film shows first.
      var live = stages();
      if (live.length) show(live[live.length - 1].getAttribute('data-aw-film'), false);

      // Add a "Watch the film" link to the Departure hero, if it is on the page.
      if (root.dataset.heroLink === 'true') {
        var copy = document.querySelector('.aw-depart__copy');
        if (copy && !copy.querySelector('.aw-depart__watch')) {
          var a = document.createElement('a');
          a.className = 'aw-depart__watch'; a.href = '#aw-films';
          a.innerHTML = '<svg width="10" height="10" viewBox="0 0 12 12" aria-hidden="true"><path d="M3 1.5v9l7.5-4.5z" fill="currentColor"/></svg><span>' + (root.dataset.heroLinkLabel || 'Watch the film') + '</span>';
          a.addEventListener('click', function (e) { e.preventDefault(); root.scrollIntoView({ behavior: reduce.matches ? 'auto' : 'smooth', block: 'center' }); });
          var next = copy.querySelector('.aw-depart__secondary');
          copy.insertBefore(a, next || null);
        }
      }
    }

    function boot() { init(document.querySelector('.aw-films')); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('.aw-films')); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["antaro-departure-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    function post(url, body) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
        body: JSON.stringify(body)
      });
    }

    function init(root) {
      if (!root || root.dataset.awReady) return;
      root.dataset.awReady = '1';
      var form = root.querySelector('[data-aw-form]');
      var done = root.querySelector('[data-aw-done]');
      var note = root.querySelector('[data-aw-note]');
      var label = root.querySelector('[data-aw-label]');
      var btn = form && form.querySelector('button');
      var company = root.dataset.company;
      var list = root.dataset.list;
      var defaultNote = note ? note.textContent : '';
      var defaultLabel = label ? label.textContent : '';
      // v19: a boarding pass already taken on this phone or browser shows as held, not as a new sign-up.
      try { if (form && done && localStorage.getItem('antaro-boarding-pass') === '1') { form.hidden = true; done.hidden = false; } } catch (x) {}

      var next = root.querySelector('[data-aw-next]');
      if (next) {
        next.addEventListener('click', function (e) {
          var href = next.getAttribute('href') || '';
          if (href.charAt(0) !== '#') return;
          var target = document.querySelector(href);
          if (!target) return;
          e.preventDefault();
          target.scrollIntoView({ behavior: reduce.matches ? 'auto' : 'smooth', block: 'start' });
        });
      }

      if (!form) return;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = form.email.value.trim();
        var first = form.first_name.value.trim();
        form.email.removeAttribute('aria-invalid');
        note.removeAttribute('data-error');
        if (!EMAIL_RE.test(email)) {
          form.email.setAttribute('aria-invalid', 'true');
          note.textContent = 'Please enter a valid email address.';
          note.setAttribute('data-error', '');
          form.email.focus();
          return;
        }
        btn.disabled = true;
        label.textContent = 'Reserving your seat…';
        var base = 'https://a.klaviyo.com/client/';
        var q = '?company_id=' + encodeURIComponent(company);
        var profile = { data: { type: 'profile', attributes: { email: email } } };
        if (first) profile.data.attributes.first_name = first;
        // 1) save the name first so the boarding pass can greet them, 2) subscribe to the list.
        post(base + 'profiles/' + q, profile)
          .catch(function () {})
          .then(function () {
            return post(base + 'subscriptions/' + q, {
              data: {
                type: 'subscription',
                attributes: {
                  custom_source: 'Homepage — Departure hero',
                  profile: { data: { type: 'profile', attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } }
                },
                relationships: { list: { data: { type: 'list', id: list } } }
              }
            });
          })
          .then(function (res) {
            if (!res || !res.ok) throw new Error('subscribe failed');
            form.hidden = true;
            done.hidden = false;
            done.focus();
            try { localStorage.setItem('antaro-boarding-pass', '1'); } catch (x) {}
          })
          .catch(function () {
            btn.disabled = false;
            label.textContent = defaultLabel;
            note.textContent = 'Something went wrong. Please try again in a moment.';
            note.setAttribute('data-error', '');
          });
      });
    }

    function boot() { document.querySelectorAll('.aw-depart').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('.aw-depart')); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["antaro-early-access"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function boot(root) {
      if (!root || root.dataset.eaReady) return;
      root.dataset.eaReady = '1';
      document.body.classList.add('ea-page');
      passengerList(root);
      var rows = Array.prototype.slice.call(root.querySelectorAll('[data-ea-row]'));
      if (!rows.length) return;
      var foot = root.querySelector('[data-ea-foot]'), msg = root.querySelector('[data-ea-msg]'), chosenEl = root.querySelector('[data-ea-chosen]');
      var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var chosen = null;
      function say(t) { if (!msg) return; msg.textContent = t || ''; msg.hidden = !t; }
      function nameOf(row) { var b = row.querySelector('.ea-row__name b'); return b ? b.textContent : 'Your candle'; }
      function paint() {
        rows.forEach(function (r) {
          var on = chosen && String(chosen.variant_id) === r.getAttribute('data-variant');
          r.classList.toggle('is-chosen', !!on);
          var b = r.querySelector('[data-ea-pick]');
          if (b) { b.textContent = on ? b.getAttribute('data-done') : (chosen ? 'Choose instead' : b.getAttribute('data-label')); b.disabled = false; }
          var st = r.querySelector('[data-ea-status]');
          if (st && !r.classList.contains('is-out')) st.textContent = on ? 'In your cart' : 'Boarding';
        });
        if (foot) { foot.hidden = !chosen; if (chosen && chosenEl) { var row = rows.filter(function (r) { return r.getAttribute('data-variant') === String(chosen.variant_id); })[0]; chosenEl.textContent = row ? nameOf(row) : chosen.product_title; } }
      }
      function cart() { return fetch(base + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
      function findEarly(c) { return (c.items || []).filter(function (i) { return i.properties && i.properties._early_access; }); }
      function notify(c) { document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: c, sourceId: root.id, data: { itemCount: c.item_count } } })); }
      cart().then(function (c) { var e = findEarly(c); chosen = e[0] || null; paint(); }).catch(function () {});
      var begin = root.querySelector('[data-ea-begin]');
      if (begin) begin.addEventListener('click', function (e) {
        var t = document.getElementById(begin.getAttribute('href').slice(1)); if (!t) return;
        e.preventDefault();
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      });
      root.querySelectorAll('[data-ea-more]').forEach(function (m) {
        m.addEventListener('click', function () {
          var d = document.getElementById(m.getAttribute('aria-controls')); if (!d) return;
          var open = d.hidden; d.hidden = !open; m.setAttribute('aria-expanded', String(open)); m.textContent = open ? 'Close' : 'Details';
        });
      });
      rows.forEach(function (r) {
        var b = r.querySelector('[data-ea-pick]'); if (!b) return;
        b.addEventListener('click', function () {
          var vid = +r.getAttribute('data-variant');
          if (chosen && chosen.variant_id === vid) return;
          rows.forEach(function (x) { var bb = x.querySelector('[data-ea-pick]'); if (bb) bb.disabled = true; });
          say('');
          cart().then(function (c) {
            var early = findEarly(c);
            var updates = {};
            early.forEach(function (i) { updates[i.key] = 0; });
            var clear = early.length ? fetch(base + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: updates }) }) : Promise.resolve();
            return clear;
          }).then(function () {
            return fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: vid, quantity: 1, properties: { _early_access: 'Early boarding' } }] }) });
          }).then(function (r) { if (!r.ok) throw new Error('add'); return cart(); })
            .then(function (c) { var e = findEarly(c); chosen = e[0] || null; paint(); notify(c); })
            .catch(function () { say('That candle could not be added just now. Please try again.'); cart().then(function (c) { var e = findEarly(c); chosen = e[0] || null; paint(); }).catch(function () { paint(); }); });
        });
      });
    }
    function passengerList(root) {
      var box = root.querySelector('[data-ea-pl]'); if (!box) return;
      var form = box.querySelector('.ea-pl__form'), sent = box.querySelector('[data-ea-pl-sent]'), wait = box.querySelector('[data-ea-pl-wait]');
      var KEY = 'antaro-pl-asked';
      var asked = 0; try { asked = +localStorage.getItem(KEY) || 0; } catch (e) {}
      // Asked within the last 14 days and still not confirmed: a gentle reminder instead of asking again
      if (asked && Date.now() - asked < 14 * 864e5 && !box.querySelector('.ea-pl__form .ea-pl__sent')) { box.classList.add('is-sent'); if (wait) wait.hidden = false; return; }
      if (box.querySelector('.ea-pl__form .ea-pl__sent')) { box.classList.add('is-sent'); box.querySelector('.ea-pl__form .ea-pl__sent').hidden = false; return; }
      if (!form || !window.fetch || !window.FormData) return;
      var joined = box.querySelector('[data-ea-pl-joined]');
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var go = form.querySelector('[data-ea-pl-go]'); if (go) go.disabled = true;
        // First choice: join in place through the ANTARO helper (signed in = email already confirmed by the one-time code).
        // No page reload, so nobody is taken away from their invitation.
        fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'apps/host/passenger', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: '{}', credentials: 'same-origin' })
          .then(function (r) { return r.ok && /json/.test(r.headers.get('content-type') || '') ? r.json() : null; })
          .then(function (d) {
            if (d && d.ok) { box.classList.add('is-sent'); if (joined) joined.hidden = false; return; }
            return viaShopify();
          }, viaShopify);
      });
      function viaShopify() {
        return fetch(form.getAttribute('action') || '/contact', { method: 'POST', body: new FormData(form), credentials: 'same-origin' })
          .then(function (r) {
            if (!r.ok || /challenge/.test(r.url || '')) throw new Error('fallback');
            try { localStorage.setItem(KEY, String(Date.now())); } catch (err) {}
            box.classList.add('is-sent'); if (sent) sent.hidden = false;
          })
          .catch(function () { try { localStorage.setItem(KEY, String(Date.now())); } catch (err) {} form.submit(); });
      }
    }
    function all() { document.querySelectorAll('.ea').forEach(boot); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
    document.addEventListener('shopify:section:load', function (e) { boot(e.target.querySelector('.ea')); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["antaro-gift-pass"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function boot(root) {
      if (!root || root.dataset.agpReady) return;
      root.dataset.agpReady = '1';
      var form = root.querySelector('form.agp-form');
      if (form) form.setAttribute('novalidate', '');
      if (!form) return;
      var q = function (s) { return root.querySelector(s); };
      var idInput = q('[data-agp-id]'), chosen = q('[data-agp-chosen]'), showVal = q('[data-agp-show-value]');
      var price = q('[data-agp-price]'), showName = q('[data-agp-show-name]'), showFrom = q('[data-agp-show-from]');
      var nameIn = q('[data-agp-name]'), fromIn = q('[data-agp-from]'), msgIn = q('[data-agp-message]'), msgOut = q('[data-agp-message-out]');
      var count = q('[data-agp-count]'), recipient = q('[data-agp-recipient]'), meNote = q('[data-agp-me-note]');
      var err = q('[data-agp-error]'), add = q('[data-agp-add]'), offset = q('[data-agp-offset]');
      var done = q('[data-agp-done]'), doneText = q('[data-agp-done-text]'), doneCount = q('[data-agp-cart-count]');
      var nameDefault = showName ? showName.textContent : '', fromDefault = showFrom ? showFrom.textContent : '';
      if (offset) offset.value = new Date().getTimezoneOffset();

      root.querySelectorAll('[data-agp-value]').forEach(function (r) {
        r.addEventListener('change', function () {
          idInput.value = r.value;
          var p = r.dataset.price;
          if (chosen) chosen.textContent = p; if (showVal) showVal.textContent = p;
          if (price) price.textContent = p.indexOf('.') > -1 ? p : p + '.00';
        });
      });
      if (nameIn) nameIn.addEventListener('input', function () { showName.textContent = nameIn.value.trim() || nameDefault; });
      if (fromIn) fromIn.addEventListener('input', function () { showFrom.textContent = fromIn.value.trim() || fromDefault; });
      if (msgIn) msgIn.addEventListener('input', function () { count.textContent = msgIn.value.length + ' / 200'; });

      function setWho(v) {
        var them = v === 'them';
        recipient.hidden = !them; if (meNote) meNote.hidden = them;
        root.querySelectorAll('[data-agp-r]').forEach(function (el) { el.disabled = !them; });
        if (!them) { showName.textContent = nameDefault; } else if (nameIn) { showName.textContent = nameIn.value.trim() || nameDefault; }
      }
      root.querySelectorAll('[data-agp-who]').forEach(function (r) { r.addEventListener('change', function () { if (r.checked) setWho(r.value); }); });

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        err.hidden = true;
        var them = !recipient.hidden;
        if (them) {
          var email = q('[data-agp-email]');
          if (!email.value || !email.checkValidity()) { err.textContent = email.validationMessage || root.dataset.error; err.hidden = false; email.focus(); return; }
          var msg = (msgIn.value || '').trim();
          var from = (fromIn.value || '').trim();
          if (from) { var sig = (msg ? '\n— ' : '— ') + from; msg = msg.slice(0, Math.max(0, 200 - sig.length)) + sig; }
          msgOut.value = msg;
          msgOut.disabled = !msg;
        }
        add.disabled = true;
        fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
          .then(function (res) {
            if (res.ok) {
              var val = chosen ? chosen.textContent.trim() : '';
              return fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js', { headers: { 'Accept': 'application/json' } })
                .then(function (r) { return r.json(); })
                .then(function (cart) {
                  document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: root.id, data: { itemCount: cart.item_count } } }));
                  return cart;
                }, function () { return null; })
                .then(function (cart) {
                  if (!done) { location.href = root.dataset.cart || '/cart'; return; }
                  if (doneText) doneText.textContent = (val ? val + ' ' : '') + doneText.dataset.name + ' ' + doneText.dataset.in;
                  if (doneCount && cart) doneCount.textContent = cart.item_count;
                  done.hidden = false;
                  if (done.getBoundingClientRect().bottom > window.innerHeight) done.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
                  if (add.dataset.done) add.textContent = add.dataset.done;
                  setTimeout(function () { if (add.dataset.label) add.textContent = add.dataset.label; add.disabled = false; }, 2400);
                });
            }
            var d = res.d || {};
            var m = d.description || d.message || root.dataset.error;
            if (m && typeof m === 'object') { m = Object.keys(m).map(function (k) { return m[k]; }).join(' '); }
            err.textContent = m; err.hidden = false; add.disabled = false;
          })
          .catch(function () { err.textContent = root.dataset.error; err.hidden = false; add.disabled = false; });
      });
    }
    function all() { document.querySelectorAll('[data-agp]').forEach(boot); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
    document.addEventListener('shopify:section:load', function (e) { boot(e.target.querySelector('[data-agp]')); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["antaro-help-desk"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var CH = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ&·';
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    function flipTo(box, text, done) {
      var cells = Array.prototype.slice.call(box.children);
      var target = text.split('');
      var tick = 0;
      var timer = setInterval(function () {
        tick++;
        var finished = true;
        cells.forEach(function (cell, i) {
          var ch = target[i] && target[i] !== ' ' ? target[i] : ' ';
          var settle = 5 + i * 2;
          if (tick >= settle) {
            if (cell.textContent !== (ch === ' ' ? ' ' : ch)) cell.textContent = ch === ' ' ? ' ' : ch;
            cell.classList.toggle('is-space', ch === ' ');
            cell.classList.remove('is-moving');
          } else {
            finished = false;
            cell.classList.remove('is-space');
            cell.textContent = CH.charAt((tick * 7 + i * 11) % CH.length);
            cell.classList.add('is-moving');
          }
        });
        if (finished) { clearInterval(timer); if (done) done(); }
      }, 50);
    }

    function boot(root) {
      if (!root || root.dataset.hdReady) return;
      root.dataset.hdReady = '1';
      document.body.classList.add('hd-page');

      // The name flips to what the page does, and back again
      var box = root.querySelector('[data-hd-flaps]');
      if (box && !reduce.matches) {
        var a = box.dataset.a, b = box.dataset.b, showingA = true, busy = false, visible = true;
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (es) { visible = es[0].isIntersecting; }).observe(box);
        }
        setTimeout(function cycle() {
          if (!document.hidden && visible && !busy) {
            busy = true;
            flipTo(box, showingA ? b : a, function () { busy = false; showingA = !showingA; });
          }
          setTimeout(cycle, showingA ? 4200 : 3000);
        }, 2600);
      }

      // Search the answers
      var input = root.querySelector('[data-hd-search]');
      var none = root.querySelector('[data-hd-none]');
      if (input) input.addEventListener('input', function () {
        var q = input.value.trim().toLowerCase();
        var any = false;
        root.querySelectorAll('[data-hd-topic]').forEach(function (t) {
          var shown = 0;
          t.querySelectorAll('[data-hd-q]').forEach(function (d) {
            var hit = !q || d.textContent.toLowerCase().indexOf(q) > -1;
            d.hidden = !hit;
            if (hit) shown++;
            if (q && hit && !d.open) d.open = true;
            if (!q) d.open = false;
          });
          t.hidden = shown === 0;
          if (shown) any = true;
        });
        if (none) none.hidden = any;
      });

      // Open an answer linked from elsewhere (#…)
      if (location.hash) {
        try {
          var hit = root.querySelector(location.hash);
          if (hit && hit.tagName === 'DETAILS') hit.open = true;
        } catch (e) {}
      }
    }
    function all() { document.querySelectorAll('[data-hd]').forEach(boot); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
    document.addEventListener('shopify:section:load', function (e) { boot(e.target.querySelector('[data-hd]')); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["antaro-members"]) return;
  try {
    
  (function () {
    var KEY = 'antaro-qc-preview';
    function boot(root) {
      if (!root || root.dataset.qcReady) return;
      root.dataset.qcReady = '1';
      document.body.classList.add('qc-page');
      var bar = root.querySelector('[data-qc-preview]');
      if (!bar) return;
      var views = root.querySelectorAll('[data-qc-view]');
      var btns = bar.querySelectorAll('[data-qc-show]');
      var eye = bar.querySelector('[data-qc-customer]');
      function show(id) {
        var found = false;
        views.forEach(function (v) { var on = v.dataset.qcView === id; v.hidden = !on; if (on) found = true; });
        if (!found && views[0]) { views[0].hidden = false; id = views[0].dataset.qcView; }
        btns.forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.qcShow === id)); });
        try { sessionStorage.setItem(KEY, id); } catch (e) {}
      }
      var start = root.dataset.default;
      try { start = sessionStorage.getItem(KEY) || start; } catch (e) {}
      show(start);
      btns.forEach(function (b) { b.addEventListener('click', function () { show(b.dataset.qcShow); }); });
      if (eye) eye.addEventListener('change', function () { root.classList.toggle('is-customer-eye', eye.checked); });
    }
    function all() { document.querySelectorAll('[data-qc]').forEach(boot); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
    document.addEventListener('shopify:section:load', function (e) { boot(e.target.querySelector('[data-qc]')); });
  })();

  (function () {
    var KEY = 'qc-applied';
    function run() {
      // v59: accept the invitation. Instant, through the ANTARO helper.
      document.querySelectorAll('[data-qc-join]').forEach(function (box) {
        var go = box.querySelector('[data-qc-join-go]'), msg = box.querySelector('[data-qc-join-msg]'), up = box.querySelector('[data-qc-join-updates]'), no = box.querySelector('[data-qc-join-optout]');
        if (!go || go.dataset.wired) return; go.dataset.wired = '1';
        go.addEventListener('click', function () {
          if (go.disabled) return;
          go.disabled = true; if (msg) msg.textContent = 'One moment…';
          var url = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'apps/host/join';
          fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: !!(up && up.checked), optout: !!(no && no.checked) }) })
            .then(function (r) { return r.json().catch(function () { return {}; }).then(function (d) { return { ok: r.ok, d: d || {} }; }); })
            .then(function (res) {
              if (res.ok && res.d.ok) { try { sessionStorage.removeItem('antaro-qc-preview'); } catch (e) {} location.replace(location.pathname + location.search); return; }
              go.disabled = false; if (msg) msg.textContent = 'That didn\u2019t go through just now. Please try again in a moment.';
            })
            .catch(function () { go.disabled = false; if (msg) msg.textContent = 'That didn\u2019t go through just now. Please try again in a moment.'; });
        });
      });
      var w = document.querySelector('[data-qc-welcome]');
      if (!w) return;
      var no = w.getAttribute('data-no'), seen = null;
      try { seen = localStorage.getItem('qc-welcomed'); } catch (e) {}
      if (seen === no) return;
      document.body.appendChild(w);
      w.hidden = false;
      requestAnimationFrame(function () { requestAnimationFrame(function () { w.classList.add('is-in'); }); });
      var go = w.querySelector('[data-qc-welcome-go]');
      function close() { try { localStorage.setItem('qc-welcomed', no); } catch (e) {} w.classList.remove('is-in'); setTimeout(function () { w.hidden = true; }, 450); }
      go.addEventListener('click', close);
      w.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
      try { go.focus({ preventScroll: true }); } catch (e) {}
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  })();

  (function () {
    var ROOT = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'apps/host/prefs';
    function wire(form) {
      if (form.dataset.qcWired) return; form.dataset.qcWired = '1';
      var msg = form.querySelector('[data-qc-prefs-msg]'), btn = form.querySelector('button[type="submit"]');
      var selM = form.querySelector('select[name="month"]'), selD = form.querySelector('select[name="day"]');
      var DIM = { January: 31, February: 29, March: 31, April: 30, May: 31, June: 30, July: 31, August: 31, September: 30, October: 31, November: 30, December: 31 };
      function fitDays() {
        if (!selM || !selD) return;
        var max = DIM[selM.value] || 31;
        Array.prototype.forEach.call(selD.options, function (o) { if (o.value) o.disabled = Number(o.value) > max; });
        if (Number(selD.value) > max) selD.value = '';
      }
      if (selM) { selM.addEventListener('change', fitDays); fitDays(); }
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!btn || btn.disabled) return;
        var scents = Array.prototype.map.call(form.querySelectorAll('input[name="scents"]:checked'), function (i) { return i.value; });
        var month = (form.querySelector('select[name="month"]') || {}).value || '';
        var day = month ? ((form.querySelector('select[name="day"]') || {}).value || '') : '';
        btn.disabled = true; if (msg) msg.textContent = 'Saving…';
        fetch(ROOT, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ scents: scents, month: month, day: day }) })
          .then(function (r) { return r.json().catch(function () { return {}; }).then(function (d) { return { ok: r.ok, d: d || {} }; }); })
          .then(function (res) { if (msg) msg.textContent = res.ok && res.d.ok ? 'Saved.' : 'That could not be saved just now. Please try again later.'; })
          .catch(function () { if (msg) msg.textContent = 'That could not be saved just now. Please try again later.'; })
          .then(function () { btn.disabled = false; });
      });
    }
    function all() { document.querySelectorAll('[data-qc-prefs]').forEach(wire); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
    document.addEventListener('shopify:section:load', all);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["antaro-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // v44: Google rating, read live through the helper. Kept for a few hours per visitor
    // so normal browsing doesn't use up the helper's daily Google checks.
    var KEY = 'antaro-google-v1', OK_TTL = 6 * 36e5, OFF_TTL = 30 * 6e4;
    function show(root, d) {
      var r = Number(d.rating), n = Number(d.count);
      if (!(r > 0) || !(n > 0)) return;
      root.querySelector('[data-gr-num]').textContent = r.toFixed(1);
      root.querySelector('[data-gr-sr]').textContent = ' out of 5';
      root.querySelector('[data-gr-fill]').style.width = Math.max(0, Math.min(100, r / 5 * 100)) + '%';
      root.querySelector('[data-gr-count]').textContent = n + (n === 1 ? ' review' : ' reviews');
      var read = root.querySelector('[data-gr-read]');
      if (read && typeof d.maps === 'string' && /^https:\/\//.test(d.maps)) read.href = d.maps;
      root.querySelector('[data-gr-live]').hidden = false;
    }
    function boot(root) {
      if (!root || root.dataset.grReady) return;
      root.dataset.grReady = '1';
      var c = null;
      try { c = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) {}
      if (c && c.t && Date.now() - c.t < (c.d ? OK_TTL : OFF_TTL)) { if (c.d) show(root, c.d); return; }
      var src = root.getAttribute('data-src'); if (!src) return;
      fetch(src, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          var good = d && d.ok ? { rating: d.rating, count: d.count, maps: d.maps } : null;
          try { sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), d: good })); } catch (e) {}
          if (good) show(root, good);
        })
        .catch(function () {});
    }
    function all() { document.querySelectorAll('[data-apg-gr]').forEach(boot); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
    document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('[data-apg-gr]').forEach(boot); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["antaro-scent-finder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function boot() {
      document.querySelectorAll('[data-asf]').forEach(function (root) {
        if (root.dataset.asfReady) return;
        root.dataset.asfReady = '1';
        var s1 = root.querySelector('[data-asf-s1]'), s2 = root.querySelector('[data-asf-s2]'), s3 = root.querySelector('[data-asf-s3]');
        var stepLabel = root.querySelector('[data-asf-step]'), bar2 = root.querySelector('[data-asf-bar2]');
        var s2Title = root.querySelector('[data-asf-s2-title]'), s3Title = root.querySelector('[data-asf-s3-title]');
        function show(n) {
          s1.hidden = n !== 1; s2.hidden = n !== 2; s3.hidden = n !== 3;
          stepLabel.textContent = n === 1 ? 'Step 1 of 2' : (n === 2 ? 'Step 2 of 2' : 'Your scent');
          bar2.classList.toggle('on', n > 1);
        }
        root.querySelectorAll('[data-asf-who]').forEach(function (b) {
          b.addEventListener('click', function () {
            var gift = b.getAttribute('data-asf-who') === 'gift';
            s2Title.textContent = gift ? 'What do they love?' : 'When will you light it?';
            root.querySelectorAll('[data-asf-opts]').forEach(function (g) { g.hidden = g.getAttribute('data-asf-opts') !== (gift ? 'gift' : 'me'); });
            show(2); s2Title.focus();
          });
        });
        root.querySelectorAll('[data-asf-pick]').forEach(function (b) {
          b.addEventListener('click', function () {
            var k = b.getAttribute('data-asf-pick');
            root.querySelectorAll('[data-asf-result]').forEach(function (r) { r.hidden = r.getAttribute('data-asf-result') !== k; });
            show(3); s3Title.focus();
          });
        });
        root.querySelector('[data-asf-back]').addEventListener('click', function () { show(1); });
        root.querySelector('[data-asf-restart]').addEventListener('click', function () { show(1); });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["antaro-scents-worlds"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var GLYPHS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';

    function flap(el) {
      var target = el.getAttribute('data-sw-flap') || '';
      el.innerHTML = '';
      var cells = target.split('').map(function (ch) {
        var i = document.createElement('i');
        if (ch === ' ') { i.className = 'sp'; i.textContent = ' '; }
        else i.textContent = RM ? ch : GLYPHS[Math.floor(Math.random() * GLYPHS.length)];
        el.appendChild(i);
        return { el: i, ch: ch };
      });
      if (RM) return;
      cells.forEach(function (c, n) {
        if (c.ch === ' ') return;
        var turns = 6 + n * 2, k = 0;
        var t = setInterval(function () {
          k++;
          if (k >= turns) { c.el.textContent = c.ch; clearInterval(t); return; }
          c.el.textContent = GLYPHS[Math.floor(Math.random() * GLYPHS.length)];
        }, 45);
      });
    }

    function boot(root) {
      if (!root || root.dataset.swReady) return;
      root.dataset.swReady = '1';
      var track = root.querySelector('[data-sw-track]');
      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-sw-card]'));
      var layers = root.querySelectorAll('.sw-bg__layer');
      var words = root.querySelectorAll('.sw-word__item');
      var infos = root.querySelectorAll('[data-sw-info]');
      var ticks = root.querySelectorAll('[data-sw-go]');
      var count = root.querySelector('[data-sw-count]');
      var prev = root.querySelector('[data-sw-prev]');
      var next = root.querySelector('[data-sw-next]');
      var active = -1;
      var lockUntil = 0;
      var inEditor = window.Shopify && Shopify.designMode;
      var AUTO = +root.dataset.autoplay || 0, autoTimer = null, autoStopped = false, hovering = false;
      var sheetEl = root.querySelector('[data-sw-sheet]');
      var films = {};
      Array.prototype.forEach.call(root.querySelectorAll('[data-sw-film]'), function (d) { films[d.dataset.swFilm] = d; });
      function schedule() {
        clearTimeout(autoTimer);
        if (!AUTO || autoStopped || RM || inEditor || hovering || document.hidden || (sheetEl && sheetEl.open) || root.querySelector('.sw-film[open]')) return;
        autoTimer = setTimeout(function () { go(active + 1 >= cards.length ? 0 : active + 1); schedule(); }, AUTO);
      }
      function stopAuto() { autoStopped = true; clearTimeout(autoTimer); }

      document.body.classList.add('sw-page');

      function setActive(i, fromScroll) {
        if (i === active || i < 0 || i >= cards.length) return;
        active = i;
        var card = cards[i];
        var tone = card.dataset.tone || 'dark';
        root.dataset.tone = tone;
        root.style.setProperty('--sw-c', card.dataset.colour || '#15191e');
        document.body.classList.toggle('sw-dark', tone === 'dark');
        document.body.style.setProperty('--sw-head-bg', card.dataset.colour || 'transparent');
        cards.forEach(function (c, n) { c.classList.toggle('is-active', n === i); c.setAttribute('aria-current', n === i ? 'true' : 'false'); });
        [layers, words, ticks].forEach(function (list) { Array.prototype.forEach.call(list, function (el, n) { el.classList.toggle('is-on', n === i); }); });
        Array.prototype.forEach.call(infos, function (el, n) {
          if (n === i) { el.hidden = false; requestAnimationFrame(function () { el.classList.add('is-on'); }); }
          else { el.classList.remove('is-on'); el.hidden = true; }
        });
        if (count) count.textContent = ('0' + (i + 1)).slice(-2);
        if (prev) prev.disabled = i === 0;
        if (next) next.disabled = i === cards.length - 1;
        cards.forEach(function (c, n) {
          var v = c.querySelector('video');
          if (!v) return;
          if (n === i && !RM) { v.play().then(function () { c.classList.add('is-playing'); }).catch(function () {}); }
          else { v.pause(); c.classList.remove('is-playing'); }
        });
        var f = card.querySelector('[data-sw-flap]');
        if (f) flap(f);
        if (!inEditor && card.dataset.handle && history.replaceState) history.replaceState(null, '', '#' + card.dataset.handle);
      }

      function go(i, instant) {
        i = Math.max(0, Math.min(cards.length - 1, i));
        var c = cards[i];
        var left = c.offsetLeft - (track.clientWidth - c.offsetWidth) / 2;
        lockUntil = instant || RM ? 0 : Date.now() + 900;
        track.scrollTo({ left: left, behavior: instant || RM ? 'auto' : 'smooth' });
        setActive(i);
      }

      var ticking = false;
      function frame() {
        ticking = false;
        var mid = track.scrollLeft + track.clientWidth / 2;
        var best = 0, bestD = Infinity;
        cards.forEach(function (c, n) {
          var center = c.offsetLeft + c.offsetWidth / 2;
          var d = (center - mid) / (c.offsetWidth + 24);
          if (Math.abs(d) < bestD) { bestD = Math.abs(d); best = n; }
          if (RM) return;
          var a = Math.min(Math.abs(d), 1.6);
          c.style.transform = 'translateZ(' + (-a * 90) + 'px) rotateY(' + (Math.max(-1.6, Math.min(1.6, d)) * -16) + 'deg) scale(' + (1 - a * 0.1) + ')';
          c.style.opacity = String(1 - a * 0.42);
        });
        if (Date.now() >= lockUntil) setActive(best, true);
      }
      track.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }, { passive: true });
      window.addEventListener('resize', function () { go(active, true); frame(); });

      cards.forEach(function (c, n) {
        c.addEventListener('click', function (e) {
          if (n !== active) { e.preventDefault(); go(n); }
          else if (films[n]) { e.preventDefault(); openFilm(n); }
        });
        var inner = c.querySelector('.sw-card__inner');
        if (!RM && window.matchMedia('(hover: hover)').matches) {
          c.addEventListener('pointermove', function (e) {
            if (n !== active) return;
            var r = c.getBoundingClientRect();
            var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
            inner.style.setProperty('--ty', (x * 8).toFixed(2) + 'deg');
            inner.style.setProperty('--tx', (-y * 8).toFixed(2) + 'deg');
          });
          c.addEventListener('pointerleave', function () { inner.style.setProperty('--tx', '0deg'); inner.style.setProperty('--ty', '0deg'); });
        }
      });
      if (prev) prev.addEventListener('click', function () { stopAuto(); go(active - 1); });
      if (next) next.addEventListener('click', function () { stopAuto(); go(active + 1); });
      Array.prototype.forEach.call(ticks, function (t) { t.addEventListener('click', function () { stopAuto(); go(+t.dataset.swGo); }); });
      track.addEventListener('touchstart', stopAuto, { passive: true });
      track.addEventListener('wheel', function (e) { if (Math.abs(e.deltaX) > 2) stopAuto(); }, { passive: true });
      track.addEventListener('mouseenter', function () { hovering = true; clearTimeout(autoTimer); });
      track.addEventListener('mouseleave', function () { hovering = false; schedule(); });
      document.addEventListener('visibilitychange', schedule);
      root.addEventListener('click', function (e) { if (e.target.closest('[data-sw-board], .sw-btn, .sw-link, [data-sw-card]')) stopAuto(); });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') stopAuto();
        if (e.key === 'ArrowRight') { e.preventDefault(); go(active + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(active - 1); }
      });

      // mouse drag on desktop (touch already scrolls natively)
      var drag = null;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        drag = { x: e.clientX, left: track.scrollLeft, moved: false };
        stopAuto();
      });
      window.addEventListener('pointermove', function (e) {
        if (!drag) return;
        var dx = e.clientX - drag.x;
        if (!drag.moved && Math.abs(dx) > 5) { drag.moved = true; track.classList.add('is-dragging'); }
        if (drag.moved) track.scrollLeft = drag.left - dx;
      });
      window.addEventListener('pointerup', function () {
        if (!drag) return;
        var moved = drag.moved; drag = null;
        if (moved) { track.classList.remove('is-dragging'); frame(); go(active); }
      });

      // boarding pass sheet
      var sheet = root.querySelector('[data-sw-sheet]');
      var form = root.querySelector('[data-sw-form]');
      var boardSource = 'Scents page — Anywhere world';
      function openSheet() {
        if (sheet && sheet.showModal) { sheet.showModal(); var inp = sheet.querySelector('input'); if (inp) setTimeout(function () { inp.focus(); }, 300); }
      }
      root.querySelectorAll('[data-sw-board]').forEach(function (b) {
        b.addEventListener('click', function () { boardSource = 'Scents page — Anywhere world'; openSheet(); });
      });

      // films: play over the page with sound, sign-up button underneath
      function openFilm(i) {
        var d = films[i]; if (!d || !d.showModal) return;
        stopAuto(); d.classList.remove('is-ended'); d.showModal();
        var v = d.querySelector('video');
        if (v) { v.muted = false; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      }
      Object.keys(films).forEach(function (k) {
        var d = films[k], v = d.querySelector('video');
        if (v) { v.setAttribute('playsinline', ''); v.addEventListener('ended', function () { d.classList.add('is-ended'); }); }
        d.addEventListener('close', function () { if (v) v.pause(); });
        d.querySelector('[data-sw-film-close]').addEventListener('click', function () { d.close(); });
        d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
        var fb = d.querySelector('[data-sw-film-board]');
        if (fb) fb.addEventListener('click', function () { d.close(); boardSource = 'Scents page — Anywhere film'; openSheet(); });
      });
      root.querySelectorAll('[data-sw-film-open]').forEach(function (b) {
        b.addEventListener('click', function () { openFilm(b.dataset.swFilmOpen); });
      });
      if (sheet) {
        sheet.querySelector('[data-sw-close]').addEventListener('click', function () { sheet.close(); });
        sheet.addEventListener('click', function (e) { if (e.target === sheet) sheet.close(); });
      }
      // v19: a boarding pass already taken on this phone or browser (here or on the homepage) shows as held, not as a new sign-up.
      try {
        if (form && localStorage.getItem('antaro-boarding-pass') === '1') {
          var fw = root.querySelector('[data-sw-form-wrap]'), dn = root.querySelector('[data-sw-done]');
          if (fw && dn) { fw.hidden = true; dn.hidden = false; }
        }
      } catch (x) {}
      // v26: arriving from the phone menu's "Get your boarding pass" (?boarding=1) opens the pass straight away. The X closes it as normal.
      try {
        var bq = new URLSearchParams(window.location.search);
        if (bq.get('boarding') === '1' && sheet) {
          boardSource = 'Phone menu — Get your boarding pass';
          setTimeout(openSheet, 700);
          bq.delete('boarding');
          var bqs = bq.toString();
          history.replaceState(history.state, '', window.location.pathname + (bqs ? '?' + bqs : '') + window.location.hash);
        }
      } catch (x) {}
      if (form) form.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = form.email.value.trim(), first = form.first_name.value.trim();
        var err = form.querySelector('[data-sw-error]');
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { form.email.focus(); form.email.setCustomValidity('Please enter a valid email'); form.email.reportValidity(); form.email.setCustomValidity(''); return; }
        var company = root.dataset.company, list = root.dataset.list;
        var btn = form.querySelector('button[type=submit]'); btn.disabled = true; err.hidden = true;
        var headers = { 'Content-Type': 'application/vnd.api+json', 'revision': '2024-10-15' };
        var url = 'https://a.klaviyo.com/client/';
        var profile = { data: { type: 'profile', attributes: { email: email } } };
        if (first) profile.data.attributes.first_name = first;
        fetch(url + 'profiles/?company_id=' + company, { method: 'POST', headers: headers, body: JSON.stringify(profile) })
          .catch(function () {})
          .then(function () {
            return fetch(url + 'subscriptions/?company_id=' + company, { method: 'POST', headers: headers, body: JSON.stringify({ data: { type: 'subscription', attributes: {
              custom_source: boardSource,
              profile: { data: { type: 'profile', attributes: first ? { email: email, first_name: first } : { email: email } } } },
              relationships: { list: { data: { type: 'list', id: list } } } } }) });
          })
          .then(function (r) {
            if (!r || !r.ok) throw new Error('subscribe');
            root.querySelector('[data-sw-form-wrap]').hidden = true;
            root.querySelector('[data-sw-name]').textContent = first ? ', ' + first : '';
            root.querySelector('[data-sw-done]').hidden = false;
            try { localStorage.setItem('antaro-boarding-pass', '1'); } catch (x) {}
          })
          .catch(function () { err.hidden = false; btn.disabled = false; });
      });

      // start world: #hash, else the section setting
      var start = +root.dataset.start || 0;
      var h = location.hash.replace('#', '');
      cards.forEach(function (c, n) { if (h && c.dataset.handle === h) start = n; });
      requestAnimationFrame(function () { go(start, true); frame(); schedule(); });
    }

    function isTeam() { return window.ANTARO_TEAM === true; }
    function all() { var t = isTeam(); document.querySelectorAll('.sw').forEach(function (r) { if (t) r.classList.add('sw--team'); boot(r); }); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
    document.addEventListener('shopify:section:load', function (e) { boot(e.target.querySelector('.sw')); });
    document.addEventListener('shopify:block:select', function (e) {
      var root = e.target.closest('.sw'); if (!root) return;
      var n = +e.target.dataset.index; var c = e.target;
      root.querySelector('[data-sw-track]').scrollTo({ left: c.offsetLeft - (root.querySelector('[data-sw-track]').clientWidth - c.offsetWidth) / 2, behavior: 'smooth' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["antaro-store-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function boot(root) {
      if (!root || root.dataset.aspReady) return;
      root.dataset.aspReady = '1';
      var data = root.querySelector('[data-asp-product]');
      if (!data) return;
      var product = JSON.parse(data.textContent);
      var form = root.querySelector('[data-asp-form]');
      var idInput = root.querySelector('[data-asp-id]');
      var price = root.querySelector('[data-asp-price]');
      var compare = root.querySelector('[data-asp-compare]');
      var summary = root.querySelector('[data-asp-summary]');
      var add = root.querySelector('[data-asp-add]');
      var addLabel = root.querySelector('[data-asp-add-label]');
      var main = root.querySelector('[data-asp-main]');
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-asp-thumb]'));
      var addText = root.dataset.add || (addLabel ? addLabel.textContent : '');
      var soldText = root.dataset.sold || 'Sold out';
      var inText = root.dataset.in || 'In stock';
      var outText = root.dataset.out || 'Sold out';
      var cur = null;
      var money = function (cents) { return '£' + (cents / 100).toFixed(2); };

      function selected() {
        var out = [];
        var fss = root.querySelectorAll('[data-asp-option]');
        for (var k = 0; k < fss.length; k++) out.push(null);
        Array.prototype.forEach.call(fss, function (fs) {
          var c = fs.querySelector('input:checked'); out[+fs.dataset.aspOption] = c ? c.value : null;
        });
        return out;
      }
      var modelFs = root.querySelector('[data-asp-model]'), colourFs = root.querySelector('[data-asp-colour]');
      var modelIdx = modelFs ? +modelFs.dataset.aspOption : -1, colourIdx = colourFs ? +colourFs.dataset.aspOption : -1;
      var shotMode = !!root.dataset.shots, isTeam = !!root.dataset.team, asCustomer = false;
      var pickLabel = root.dataset.pickLabel || 'Choose your phone first';
      var ph = root.querySelector('[data-asp-ph]'), slotCap = root.querySelector('[data-asp-slotcap]');
      function find(opts) {
        return product.variants.filter(function (v) { return opts.every(function (o, i) { return o === null || v.options[i] === o; }); })[0];
      }
      var filmBox = root.querySelector('[data-asp-film]');
      var filmThumb = root.querySelector('[data-asp-film-thumb]');
      var stage = root.querySelector('.asp-stage');
      var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      root.querySelectorAll('.asp-film video, .asp-band__film video').forEach(function (v) {
        v.muted = true; v.setAttribute('muted', ''); v.removeAttribute('controls');
        if (calm) { v.removeAttribute('autoplay'); v.pause(); } else { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      });
      function showFilm() {
        if (!filmBox) return;
        stage.classList.remove('show-photo'); filmBox.hidden = false;
        thumbs.forEach(function (t) { t.classList.remove('is-on'); });
        if (filmThumb) filmThumb.classList.add('is-on');
        var fv = filmBox.querySelector('video'); if (fv && !calm) { var p = fv.play(); if (p && p.catch) p.catch(function () {}); }
      }
      if (filmThumb) filmThumb.addEventListener('click', showFilm);
      function showMedia(src, srcset, id) {
        if (!main || !src) return;
        if (filmBox) { filmBox.hidden = true; stage.classList.add('show-photo'); if (filmThumb) filmThumb.classList.remove('is-on'); var fv = filmBox.querySelector('video'); if (fv) fv.pause(); }
        if (main.getAttribute('src') !== src) {
          if (calm) { main.src = src; if (srcset) main.srcset = srcset; }
          else {
            main.classList.add('is-fading');
            setTimeout(function () {
              main.addEventListener('load', function done() { main.removeEventListener('load', done); main.classList.remove('is-fading'); });
              main.src = src; if (srcset) main.srcset = srcset;
              if (main.complete) main.classList.remove('is-fading');
            }, 140);
          }
        }
        thumbs.forEach(function (t) { t.classList.toggle('is-on', String(t.dataset.mediaId) === String(id)); });
        if (typeof syncDots === 'function') syncDots();
      }
      // v69: with the store photo order, the colour buttons show only that colour's photos.
      var cfAll = colourFs ? Array.prototype.map.call(colourFs.querySelectorAll('[data-asp-value]'), function (i) { return String(i.value).toLowerCase(); }) : [];
      function cfApply(col, push) {
        var key = String(col || '').toLowerCase(), vis = [];
        thumbs.forEach(function (t) {
          var a = t.dataset.alt || '';
          var ok = !key || a.indexOf(key) > -1 || (cfAll.length > 1 && cfAll.every(function (c) { return a.indexOf(c) > -1; }));
          t.hidden = !ok; if (ok) vis.push(t);
        });
        if (!vis.length) { thumbs.forEach(function (t) { t.hidden = false; }); vis = thumbs.slice(); }
        if (typeof buildNav === 'function') buildNav();
        if (typeof lbCollect === 'function') lbList = lbCollect();
        var onT = vis.filter(function (t) { return t.classList.contains('is-on'); })[0];
        var filmOn = filmThumb && filmThumb.classList.contains('is-on');
        if (vis[0] && (push === true || (!onT && !filmOn))) showMedia(vis[0].dataset.src, vis[0].dataset.srcset, vis[0].dataset.mediaId);
      }
      function update(pushImage) {
        var opts = selected();
        // v83: not every colour is made for every phone. Grey out the others and keep the colour on one that exists.
        if (modelIdx > -1 && colourIdx > -1 && colourFs) {
          var okCols = opts[modelIdx] ? product.variants.filter(function (x) { return x.options[modelIdx] === opts[modelIdx]; }).map(function (x) { return x.options[colourIdx]; }) : null;
          colourFs.querySelectorAll('[data-asp-value]').forEach(function (inp) {
            var na = !!okCols && okCols.indexOf(inp.value) < 0;
            inp.disabled = na; var lab = inp.closest('label'); if (lab) lab.classList.toggle('is-na', na);
          });
          if (okCols && okCols.length && okCols.indexOf(opts[colourIdx]) < 0) {
            var avl = product.variants.filter(function (x) { return x.options[modelIdx] === opts[modelIdx] && x.available; })[0];
            var pickC = avl ? avl.options[colourIdx] : okCols[0];
            var ci = Array.prototype.filter.call(colourFs.querySelectorAll('[data-asp-value]'), function (x) { return x.value === pickC; })[0];
            if (ci) { ci.checked = true; opts = selected(); pushImage = pushImage || true; }
          }
        }
        var v = find(opts);
        root.querySelectorAll('[data-asp-option]').forEach(function (fs) {
          var i = +fs.dataset.aspOption;
          var chosen = fs.querySelector('[data-asp-chosen]'); if (chosen) chosen.textContent = opts[i] || '';
          fs.querySelectorAll('[data-asp-status]').forEach(function (st) {
            var test = opts.slice(); test[i] = st.dataset.aspStatus;
            var match = find(test); var ok = !!(match && match.available);
            if (!ok && i === modelIdx && colourIdx > -1) ok = product.variants.some(function (x) { return x.options[modelIdx] === test[modelIdx] && x.available; });
            st.classList.toggle('is-out', !ok);
            var label = st.querySelector('span'); if (label) label.textContent = ok ? inText : outText;
          });
        });
        cur = v || null;
        var ready = modelIdx < 0 || !!opts[modelIdx];
        root.classList.toggle('asp--pick', !ready);
        if (shotMode) applyShots(pushImage);
        if (!ready) {
          if (add) { add.disabled = true; addLabel.textContent = pickLabel; }
          if (stAdd) { stAdd.disabled = true; stAdd.textContent = pickLabel; }
          if (tagEl) tagEl.hidden = true;
          return;
        }
        if (!v) { if (add) { add.disabled = true; addLabel.textContent = soldText; } return; }
        idInput.value = v.id;
        if (price) price.textContent = money(v.price);
        if (compare) compare.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : '';
        if (summary) summary.textContent = v.title;
        if (typeof aspAfterVariant === 'function') aspAfterVariant(v);
        if (add) { add.disabled = !v.available; addLabel.textContent = v.available ? addText : soldText; }
        if (tagEl) {
          var cName = colourIdx > -1 ? opts[colourIdx] : '', mName = modelIdx > -1 ? opts[modelIdx] : '';
          tagV.textContent = [cName, mName].filter(Boolean).join(' · ') || v.title;
          tagS.textContent = (mName ? 'Made for ' + mName + ' · ' : '') + (v.available ? inText : outText);
          var was = tagEl.hidden; tagEl.hidden = false;
          if (pushImage || was) { tagEl.classList.remove('is-swing'); void tagEl.offsetWidth; tagEl.classList.add('is-swing'); }
        }
        if (root.dataset.cf) {
          cfApply(colourIdx > -1 ? opts[colourIdx] : '', pushImage);
        } else if (shotMode) {
          // v29: the photo plan already chose the photos for this colour and phone.
        } else if (pushImage && root.dataset.preview) {
          // Team preview: launch photos aren't linked to colours yet, so match the colour name in the photo's description.
          var key = String(v.title || '').toLowerCase();
          var tp = thumbs.filter(function (x) { return key && (x.dataset.alt || '').indexOf(key) > -1; })[0];
          if (tp) showMedia(tp.dataset.src, tp.dataset.srcset, tp.dataset.mediaId);
        } else if (pushImage && root.dataset.soon && colourFs) {
          // v80: coming soon. The colour shows its own coming-soon photo, when it has one.
          var sIn = colourFs.querySelector('input:checked');
          if (sIn && sIn.dataset.soonSrc) { showMedia(sIn.dataset.soonSrc, sIn.dataset.soonSrcset, null); if (main && sIn.dataset.soonAlt) main.alt = sIn.dataset.soonAlt; }
        } else if (pushImage && v.featured_media && !root.dataset.soon) {
          var t = thumbs.filter(function (x) { return String(x.dataset.mediaId) === String(v.featured_media.id); })[0];
          if (t) showMedia(t.dataset.src, t.dataset.srcset, t.dataset.mediaId);
        }
        if (history.replaceState && !(window.Shopify && window.Shopify.designMode) && pushImage !== 'init') {
          var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString());
        }
      }
      root.querySelectorAll('[data-asp-value]').forEach(function (inp) { inp.addEventListener('change', function () { update(true); }); });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { showSlot(t); }); });

      // v29: the photo plan (Shot blocks). One photo per planned shot, for the chosen colour and phone.
      var tagEl = root.querySelector('[data-asp-tag]'), tagV = root.querySelector('[data-asp-tag-v]'), tagS = root.querySelector('[data-asp-tag-s]');
      function lc(x) { return String(x || '').toLowerCase(); }
      function fitsModel(t, model) {
        if (!model || t.dataset.any) return true;
        var a = lc(t.dataset.alt), m = lc(model).replace(/^iphone\s+/, '');
        if (a.indexOf(m) < 0) return false;
        if (m.indexOf('max') < 0 && a.indexOf(m + ' max') > -1) return false;
        return true;
      }
      function showPh(t) {
        if (!ph) return;
        if (filmBox) { filmBox.hidden = true; stage.classList.add('show-photo'); }
        ph.hidden = false; stage.classList.add('show-ph');
        var model = modelIdx > -1 ? selected()[modelIdx] : '';
        root.querySelector('[data-asp-ph-t]').textContent = (t.dataset.n || t.dataset.slot) + ' · ' + t.dataset.slotLabel;
        root.querySelector('[data-asp-ph-b]').textContent = t.dataset.brief || '';
        root.querySelector('[data-asp-ph-m]').textContent = (t.dataset.colour === 'all' ? 'All colours' : t.dataset.colour.charAt(0).toUpperCase() + t.dataset.colour.slice(1)) + (t.dataset.any ? '' : (model ? ' · ' + model : ''));
        thumbs.forEach(function (x) { x.classList.toggle('is-on', x === t); });
        caption(t);
        if (typeof syncDots === 'function') syncDots();
      }
      function caption(t) {
        if (!slotCap) return;
        if (!t || asCustomer) { slotCap.textContent = ''; return; }
        slotCap.textContent = '';
        var bEl = document.createElement('b'); bEl.textContent = 'Shot ' + (t.dataset.n || t.dataset.slot) + ' · ' + t.dataset.slotLabel;
        slotCap.appendChild(bEl);
        slotCap.appendChild(document.createTextNode(t.dataset.ph ? ' · Needed' : (t.dataset.final ? ' · ✓ Final photo' : ' · ✓ Using for now (stand-in)')));
      }
      function showSlot(t) {
        if (!t) return;
        if (t.dataset.ph) { showPh(t); return; }
        if (ph) { ph.hidden = true; stage.classList.remove('show-ph'); }
        showMedia(t.dataset.src, t.dataset.srcset, t.dataset.mediaId);
        caption(t);
      }
      function applyShots(push) {
        var o = selected();
        var colour = colourIdx > -1 ? lc(o[colourIdx]) : '', model = modelIdx > -1 ? o[modelIdx] : null;
        var team = isTeam && !asCustomer;
        var slots = {}, order = [];
        thumbs.forEach(function (t) {
          if (!t.dataset.slot) return;
          var n = t.dataset.slot;
          if (!slots[n]) { slots[n] = { real: null, ph: null }; order.push(n); }
          var cOk = t.dataset.colour === 'all' || !colour || t.dataset.colour === colour;
          t.hidden = true;
          if (!cOk) return;
          if (t.dataset.ph) { slots[n].ph = t; return; }
          if (!slots[n].real && fitsModel(t, model)) slots[n].real = t;
          if (!slots[n].alt) slots[n].alt = t;
        });
        // v84: no photos for this phone yet, so show this colour's finished photos from another phone rather than nothing.
        if (model && !order.some(function (n) { return slots[n].real && slots[n].real.dataset.colour !== 'all'; })) {
          var fin = order.filter(function (n) { return slots[n].alt && slots[n].alt.dataset.final; });
          (fin.length ? fin : order).forEach(function (n) { if (!slots[n].real && slots[n].alt) slots[n].real = slots[n].alt; });
        }
        var filled = 0, total = 0;
        order.forEach(function (n) {
          var sl = slots[n];
          if (sl.real) { sl.real.hidden = false; filled++; total++; }
          else if (sl.ph) { total++; if (team) sl.ph.hidden = false; }
        });
        var plan = root.querySelector('[data-asp-plan]');
        if (plan) plan.textContent = filled + ' of ' + total + ' photos in for ' + (colour ? colour.charAt(0).toUpperCase() + colour.slice(1) : 'this colour') + (model ? ' · ' + model : '');
        var nn = 0; thumbs.forEach(function (t) { if (!t.hidden) { nn++; t.dataset.n = nn; } });
        buildNav();
        var on = thumbs.filter(function (t) { return !t.hidden && t.classList.contains('is-on'); })[0];
        if (push || !on) {
          var first = thumbs.filter(function (t) { return !t.hidden; })[0];
          if (first && !(filmBox && !filmBox.hidden && push === 'init')) showSlot(first);
        }
      }

      // v24: low stock note, sticky bar on phones, delivery estimate.
      var lowEl = root.querySelector('[data-asp-low]'), lowMap = {};
      try { var lm = root.querySelector('[data-asp-low-map]'); if (lm) lowMap = JSON.parse(lm.textContent || '{}'); } catch (x) {}
      var sticky = root.querySelector('[data-asp-sticky]');
      var stV = root.querySelector('[data-asp-sticky-v]'), stP = root.querySelector('[data-asp-sticky-p]'), stAdd = root.querySelector('[data-asp-sticky-add]');
      function aspAfterVariant(v) {
        if (lowEl) {
          var q = v && lowMap[String(v.id)];
          if (q && v.available) { lowEl.textContent = 'Only ' + q + ' left' + (v.title && v.title !== 'Default Title' ? ' in ' + v.title : ''); lowEl.hidden = false; } else { lowEl.hidden = true; }
        }
        if (sticky && v) {
          if (stV && v.title !== 'Default Title') stV.textContent = v.title;
          if (stP) stP.textContent = money(v.price);
          if (stAdd) { stAdd.disabled = !v.available; stAdd.textContent = v.available ? addText : soldText; }
        }
      }
      if (sticky && add && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          var hide = es[0].isIntersecting || es[0].boundingClientRect.top > 0;
          sticky.classList.toggle('is-on', !hide);
          if (hide) { sticky.setAttribute('aria-hidden', 'true'); sticky.setAttribute('inert', ''); } else { sticky.removeAttribute('aria-hidden'); sticky.removeAttribute('inert'); }
        }).observe(add);
        if (stAdd) stAdd.addEventListener('click', function () {
          if (root.classList.contains('asp--pick') && modelFs) { modelFs.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
          if (!add.disabled) add.click();
        });
      }
      // v37: one delivery estimate for the whole store (snippets/antaro-live), set from The Desk.
      var eta = root.querySelector('[data-asp-eta]');
      if (eta && window.antaroEta && product.available) {
        var r = window.antaroEta();
        if (r) { eta.innerHTML = ''; eta.appendChild(document.createTextNode('Order today, arrives ')); var bb = document.createElement('b'); bb.textContent = r.label; eta.appendChild(bb); eta.hidden = false; }
      }

      // v23: one list of everything in the photo window (film first, then photos) for dots, swiping and full screen.
      var navItems = [];
      function buildNav() {
        navItems = [];
        if (filmThumb) navItems.push({ film: true, el: filmThumb });
        thumbs.forEach(function (t) { if (!t.hidden) navItems.push({ el: t }); });
        if (!dotsBox) return;
        dotsBox.innerHTML = '';
        if (navItems.length < 2) return;
        var pn = 0;
        navItems.forEach(function (it, k) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'asp-dot' + (it.el.dataset.ph ? ' asp-dot--ph' : '');
          if (!it.film) pn++;
          b.setAttribute('aria-label', it.film ? 'Film' : 'Photo ' + pn);
          b.addEventListener('click', function () { go(k); });
          dotsBox.appendChild(b);
        });
        syncDots();
      }
      function curIndex() { for (var k = 0; k < navItems.length; k++) { if (navItems[k].el.classList.contains('is-on')) return k; } return 0; }
      function go(k) {
        if (navItems.length < 2) return;
        k = (k + navItems.length) % navItems.length;
        var it = navItems[k];
        if (it.film) { if (ph) { ph.hidden = true; stage.classList.remove('show-ph'); } showFilm(); syncDots(); caption(null); } else { showSlot(it.el); }
      }
      var dotsBox = root.querySelector('[data-asp-dots]');
      function syncDots() {
        if (!dotsBox) return;
        var c = curIndex();
        Array.prototype.forEach.call(dotsBox.children, function (d, k) { d.classList.toggle('is-on', k === c); d.setAttribute('aria-current', k === c ? 'true' : 'false'); });
      }
      buildNav();
      if (filmThumb) filmThumb.addEventListener('click', function () { if (ph) { ph.hidden = true; stage.classList.remove('show-ph'); } caption(null); syncDots(); });
      var swiped = false, tx = null, ty = null;
      if (stage) {
        stage.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; ty = e.touches[0].clientY; }, { passive: true });
        stage.addEventListener('touchend', function (e) {
          if (tx === null) return;
          var dx = e.changedTouches[0].clientX - tx, dy = e.changedTouches[0].clientY - ty; tx = null;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.3) { swiped = true; go(curIndex() + (dx < 0 ? 1 : -1)); setTimeout(function () { swiped = false; }, 400); }
        });
      }

      // v23: full screen. Tap the photo to see it large and uncropped; arrows, swipe or keys to move; Esc or the cross to close.
      function lbCollect() {
        var vis = thumbs.filter(function (t) { return !t.hidden && !t.dataset.ph; });
        return vis.length ? vis.map(function (t) { return { src: t.dataset.src, srcset: t.dataset.srcset, id: t.dataset.mediaId }; }) : (main ? [{ src: main.getAttribute('src'), srcset: main.getAttribute('srcset') || '', id: '' }] : []);
      }
      var lbList = lbCollect();
      var lb = null, lbImg = null, lbCount = null, lbAt = 0, lbBack = null;
      function lbShow(k) {
        lbAt = (k + lbList.length) % lbList.length;
        var it = lbList[lbAt];
        lbImg.classList.add('is-fading');
        setTimeout(function () { lbImg.srcset = it.srcset || ''; lbImg.src = it.src; lbImg.onload = function () { lbImg.classList.remove('is-fading'); }; if (lbImg.complete) lbImg.classList.remove('is-fading'); }, calm ? 0 : 120);
        lbImg.alt = main ? main.alt : '';
        lbCount.textContent = (lbAt + 1) + ' / ' + lbList.length;
      }
      function lbKey(e) {
        if (e.key === 'Escape') lbClose();
        else if (e.key === 'ArrowRight') lbShow(lbAt + 1);
        else if (e.key === 'ArrowLeft') lbShow(lbAt - 1);
      }
      function lbClose() {
        if (!lb) return;
        lb.classList.remove('is-open');
        document.removeEventListener('keydown', lbKey);
        document.documentElement.style.overflow = '';
        setTimeout(function () { lb.hidden = true; }, calm ? 0 : 220);
        if (lbBack) lbBack.focus();
        // keep the page in step with the photo last seen
        var it = lbList[lbAt]; if (it && it.id) showMedia(it.src, it.srcset, it.id);
      }
      function lbOpen() {
        lbList = lbCollect();
        if (!lbList.length) return;
        if (!lb) {
          lb = document.createElement('div');
          lb.className = 'asp-lb'; lb.hidden = true;
          lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true'); lb.setAttribute('aria-label', 'Photos, full screen');
          lb.innerHTML = '<img class="asp-lb__img" alt="">' +
            '<button type="button" class="asp-lb__close" aria-label="Close"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"></path></svg></button>' +
            ('<button type="button" class="asp-lb__prev" aria-label="Previous photo"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M15 6l-6 6 6 6"></path></svg></button><button type="button" class="asp-lb__next" aria-label="Next photo"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M9 6l6 6-6 6"></path></svg></button>') +
            '<p class="asp-lb__count"></p>';
          document.body.appendChild(lb);
          lbImg = lb.querySelector('.asp-lb__img'); lbCount = lb.querySelector('.asp-lb__count');
          lb.querySelector('.asp-lb__close').addEventListener('click', lbClose);
          var pv = lb.querySelector('.asp-lb__prev'), nx = lb.querySelector('.asp-lb__next');
          if (pv) pv.addEventListener('click', function () { lbShow(lbAt - 1); });
          if (nx) nx.addEventListener('click', function () { lbShow(lbAt + 1); });
          lb.addEventListener('click', function (e) { if (e.target === lb) lbClose(); });
          var lx = null;
          lb.addEventListener('touchstart', function (e) { lx = e.touches[0].clientX; }, { passive: true });
          lb.addEventListener('touchend', function (e) { if (lx === null) return; var dx = e.changedTouches[0].clientX - lx; lx = null; if (Math.abs(dx) > 40 && lbList.length > 1) lbShow(lbAt + (dx < 0 ? 1 : -1)); });
        }
        var start = 0;
        var onT = thumbs.filter(function (t) { return t.classList.contains('is-on'); })[0];
        for (var k = 0; k < lbList.length; k++) { if (onT && String(lbList[k].id) === String(onT.dataset.mediaId)) start = k; }
        var pvb = lb.querySelector('.asp-lb__prev'), nxb = lb.querySelector('.asp-lb__next');
        if (pvb) pvb.hidden = lbList.length < 2; if (nxb) nxb.hidden = lbList.length < 2;
        lbBack = document.activeElement;
        lb.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        lbShow(start);
        requestAnimationFrame(function () { lb.classList.add('is-open'); });
        document.addEventListener('keydown', lbKey);
        lb.querySelector('.asp-lb__close').focus();
      }
      if (stage && main && !root.dataset.soon) {
        stage.classList.add('can-zoom');
        stage.addEventListener('click', function () {
          if (swiped) return;
          if (filmBox && !filmBox.hidden) return;
          if (ph && !ph.hidden) return;
          lbOpen();
        });
      }
      var rev = root.querySelector('[data-asp-reviews]');
      if (rev) rev.addEventListener('click', function (e) {
        var target = document.querySelector('[data-arv]') || document.querySelector('[id$="__reviews"]');
        if (!target) return; e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      // v69: the store photo layout: colour-led, a 1 / N count on phones, and its own full-screen view.
      var asg = root.querySelector('[data-asg]');
      if (asg) {
        var asgTrack = asg.querySelector('[data-asg-track]'), asgCount = asg.querySelector('[data-asg-count]');
        var asgItems = Array.prototype.slice.call(asg.querySelectorAll('[data-asg-item]'));
        var asgAll = colourFs ? Array.prototype.map.call(colourFs.querySelectorAll('[data-asp-value]'), function (i) { return String(i.value).toLowerCase(); }) : [];
        var asgVis = function () { return asgItems.filter(function (it) { return !it.hidden; }); };
        var asgSync = function () {
          var n = asgVis().length, w = asgTrack.clientWidth || 1, k = Math.min(n - 1, Math.round(asgTrack.scrollLeft / w));
          if (asgCount) asgCount.textContent = n > 1 ? (k + 1) + ' / ' + n : '';
        };
        var asgColour = function (col) {
          var key = String(col || '').toLowerCase();
          asgItems.forEach(function (it) {
            var a = it.dataset.alt;
            if (a === undefined) { it.hidden = false; return; }
            it.hidden = !(!key || a.indexOf(key) > -1 || (asgAll.length > 1 && asgAll.every(function (c) { return a.indexOf(c) > -1; })));
          });
          if (!asgVis().length) asgItems.forEach(function (it) { it.hidden = false; });
          asgItems.forEach(function (it) { it.classList.remove('is-lead'); });
          var lead = asgVis()[0]; if (lead) lead.classList.add('is-lead');
          var vAll = asgVis(); asgItems.forEach(function (it) { it.classList.remove('is-wide'); });
          if (vAll.length > 2 && (vAll.length - 1) % 2 === 1) vAll[vAll.length - 1].classList.add('is-wide');
          asgTrack.scrollLeft = 0; asgSync();
        };
        asgTrack.addEventListener('scroll', function () { window.requestAnimationFrame(asgSync); }, { passive: true });
        if (colourFs) colourFs.addEventListener('change', function (e) { if (e.target && e.target.value) asgColour(e.target.value); });
        var asgFirst = colourFs && colourFs.querySelector('input:checked');
        asgColour(asgFirst ? asgFirst.value : '');
        var asgLb = null, asgAt = 0, asgList = [];
        var asgShow = function (k) {
          asgAt = (k + asgList.length) % asgList.length;
          var im = asgList[asgAt], big = asgLb.querySelector('img');
          big.removeAttribute('srcset'); big.src = im.currentSrc || im.src; big.srcset = im.getAttribute('srcset') || ''; big.sizes = '100vw'; big.alt = im.alt;
          asgLb.querySelector('.asg-lb__c').textContent = (asgAt + 1) + ' / ' + asgList.length;
        };
        var asgClose = function () { asgLb.hidden = true; document.documentElement.style.overflow = ''; document.removeEventListener('keydown', asgKey); };
        var asgKey = function (e) { if (e.key === 'Escape') asgClose(); else if (e.key === 'ArrowRight') asgShow(asgAt + 1); else if (e.key === 'ArrowLeft') asgShow(asgAt - 1); };
        asg.addEventListener('click', function (e) {
          var z = e.target.closest('[data-asg-zoom]'); if (!z) return;
          asgList = asgVis().map(function (it) { return it.querySelector('[data-asg-zoom] img'); }).filter(Boolean);
          if (!asgList.length) return;
          if (!asgLb) {
            asgLb = document.createElement('div'); asgLb.className = 'asg-lb'; asgLb.hidden = true;
            asgLb.setAttribute('role', 'dialog'); asgLb.setAttribute('aria-modal', 'true'); asgLb.setAttribute('aria-label', 'Photos');
            asgLb.innerHTML = '<img alt=""><button type="button" class="asg-lb__x">Close</button><button type="button" class="asg-lb__p" aria-label="Previous photo">&#8592;</button><button type="button" class="asg-lb__n" aria-label="Next photo">&#8594;</button><p class="asg-lb__c"></p>';
            document.body.appendChild(asgLb);
            asgLb.querySelector('.asg-lb__x').addEventListener('click', asgClose);
            asgLb.querySelector('.asg-lb__p').addEventListener('click', function () { asgShow(asgAt - 1); });
            asgLb.querySelector('.asg-lb__n').addEventListener('click', function () { asgShow(asgAt + 1); });
            var lx = null;
            asgLb.addEventListener('touchstart', function (ev) { lx = ev.touches[0].clientX; }, { passive: true });
            asgLb.addEventListener('touchend', function (ev) { if (lx === null) return; var dx = ev.changedTouches[0].clientX - lx; lx = null; if (Math.abs(dx) > 40) asgShow(asgAt + (dx < 0 ? 1 : -1)); });
          }
          var one = asgList.length < 2;
          asgLb.querySelector('.asg-lb__p').hidden = one; asgLb.querySelector('.asg-lb__n').hidden = one;
          asgLb.hidden = false; document.documentElement.style.overflow = 'hidden';
          asgShow(Math.max(0, asgList.indexOf(z.querySelector('img'))));
          document.addEventListener('keydown', asgKey);
          asgLb.querySelector('.asg-lb__x').focus();
        });
      }
      // v75: the quiet add to cart under the story uses the main button, and follows its price.
      var sAdd = root.querySelector('[data-asp-story-add]');
      if (sAdd && add) {
        sAdd.addEventListener('click', function () { if (!add.disabled) add.click(); else add.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
        var sP = sAdd.querySelector('[data-asp-story-p]');
        if (price && sP && 'MutationObserver' in window) new MutationObserver(function () { sP.textContent = price.textContent; }).observe(price, { childList: true, characterData: true, subtree: true });
      }
      // v69: tap to explore (numbered features and the dots on the close-up) and gentle reveals.
      var ex = root.querySelector('[data-asp-explore]');
      if (ex) {
        var exPick = function (i) {
          ex.querySelectorAll('[data-asp-spot]').forEach(function (sp) { var on = sp.dataset.aspSpot === String(i); sp.classList.toggle('is-on', on); sp.setAttribute('aria-pressed', on ? 'true' : 'false'); });
          ex.querySelectorAll('[data-asp-feat]').forEach(function (l) { l.classList.toggle('is-on', l.dataset.aspFeat === String(i)); });
        };
        ex.addEventListener('click', function (e) { var t = e.target.closest('[data-asp-spot],[data-asp-feat]'); if (t) exPick(t.dataset.aspSpot || t.dataset.aspFeat); });
        exPick(0);
      }
      var revs = root.querySelectorAll('[data-asp-reveal]');
      if (revs.length && 'IntersectionObserver' in window && !calm) {
        root.classList.add('js-reveal');
        var rio = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); rio.unobserve(en.target); } }); }, { threshold: 0.12 });
        revs.forEach(function (el) { rio.observe(el); });
      }
      update(shotMode ? 'init' : (!!root.dataset.preview && !filmBox));

      // v29: hold it to the light. A soft light follows the pointer (or, after a tap on phones, the tilt of the phone).
      var light = root.querySelector('[data-asp-light]');
      if (light && stage) {
        var setLight = function (x, y) { light.style.setProperty('--lx', x.toFixed(1) + '%'); light.style.setProperty('--ly', y.toFixed(1) + '%'); light.classList.add('is-live'); };
        stage.addEventListener('pointermove', function (e) {
          var r = stage.getBoundingClientRect(); setLight((e.clientX - r.left) / r.width * 100, (e.clientY - r.top) / r.height * 100);
        });
        stage.addEventListener('pointerleave', function () { light.classList.remove('is-live'); });
        if (!calm) light.classList.add('is-sweep');
        var tiltBtn = root.querySelector('[data-asp-tilt]');
        var coarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
        if (tiltBtn && coarse && 'DeviceOrientationEvent' in window && !calm) {
          tiltBtn.hidden = false;
          var startTilt = function () {
            window.addEventListener('deviceorientation', function (ev) {
              var g = ev.gamma || 0, b = ev.beta || 45;
              setLight(Math.max(0, Math.min(100, 50 + g * 1.6)), Math.max(0, Math.min(100, (b - 20) * 1.3)));
            });
            tiltBtn.classList.add('is-on'); tiltBtn.setAttribute('aria-pressed', 'true');
            var tl = tiltBtn.querySelector('[data-asp-tilt-label]'); if (tl) tl.textContent = 'Tilt your phone to catch the light';
          };
          tiltBtn.addEventListener('click', function () {
            if (tiltBtn.classList.contains('is-on')) return;
            try {
              if (typeof DeviceOrientationEvent.requestPermission === 'function') {
                DeviceOrientationEvent.requestPermission().then(function (r) { if (r === 'granted') startTilt(); }).catch(function () {});
              } else { startTilt(); }
            } catch (x) {}
          });
        }
      }

      // v29: team view: see the page exactly as a customer would.
      var asBtn = root.querySelector('[data-asp-as-customer]');
      if (asBtn) asBtn.addEventListener('click', function () {
        asCustomer = !asCustomer;
        root.classList.toggle('asp--as-customer', asCustomer);
        asBtn.setAttribute('aria-pressed', asCustomer ? 'true' : 'false');
        asBtn.textContent = asCustomer ? 'Back to team view' : 'See as customer';
        applyShots(true);
      });

      // v29: compare colours side by side, at the same angle, for the chosen phone.
      var cmpBtn = root.querySelector('[data-asp-cmp-open]'), cmpBox = root.querySelector('[data-asp-cmpc]');
      if (cmpBtn && cmpBox && colourFs) {
        var fillCmp = function () {
          var model = modelIdx > -1 ? selected()[modelIdx] : null;
          cmpBox.innerHTML = '';
          var inps = Array.prototype.slice.call(colourFs.querySelectorAll('[data-asp-value]'));
          var real = thumbs.filter(function (t) { return !t.dataset.ph && t.dataset.colour !== 'all'; });
          var labels = []; real.forEach(function (t) { if (labels.indexOf(t.dataset.slotLabel) < 0) labels.push(t.dataset.slotLabel); });
          // the same shot for every colour, for this phone if possible, so the colours are compared like for like
          var common = labels.filter(function (l) { return inps.every(function (i) { return real.some(function (t) { return t.dataset.slotLabel === l && t.dataset.colour === lc(i.value) && fitsModel(t, model); }); }); })[0]
            || labels.filter(function (l) { return inps.every(function (i) { return real.some(function (t) { return t.dataset.slotLabel === l && t.dataset.colour === lc(i.value); }); }); })[0];
          inps.forEach(function (inp) {
            var c = lc(inp.value);
            var cand = real.filter(function (t) { return t.dataset.colour === c && (!common || t.dataset.slotLabel === common); });
            var pick = cand.filter(function (t) { return fitsModel(t, model); })[0] || cand[0];
            if (!pick) return;
            var b = document.createElement('button');
            b.type = 'button'; b.className = 'asp-cmpc__item' + (inp.checked ? ' is-on' : '');
            b.innerHTML = '<img src="' + pick.dataset.src + '" alt="" loading="lazy"><span></span>';
            b.querySelector('span').textContent = inp.value;
            b.addEventListener('click', function () { inp.checked = true; inp.dispatchEvent(new Event('change', { bubbles: true })); fillCmp(); });
            cmpBox.appendChild(b);
          });
        };
        cmpBtn.addEventListener('click', function () {
          var open = cmpBox.hidden; cmpBox.hidden = !open; cmpBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (open) fillCmp();
        });
        root.querySelectorAll('[data-asp-value]').forEach(function (inp) { inp.addEventListener('change', function () { if (!cmpBox.hidden) fillCmp(); }); });
      }

      // v29: models coming soon: tap one to be told when the case for it lands (Klaviyo list in the settings).
      var sa = root.querySelector('[data-asp-soonask]');
      if (sa) {
        var saModel = sa.querySelector('[data-asp-soonask-model]'), saFields = sa.querySelector('[data-asp-soonask-fields]');
        var saDone = sa.querySelector('[data-asp-soonask-done]'), saNote = sa.querySelector('[data-asp-soonask-note]');
        var saEmail = sa.querySelector('[data-asp-soonask-email]'), saFirst = sa.querySelector('[data-asp-soonask-first]'), saGo = sa.querySelector('[data-asp-soonask-go]');
        var saConsent = saNote.textContent, saWant = '';
        root.querySelectorAll('[data-asp-soon-ask]').forEach(function (row) {
          row.addEventListener('click', function () {
            saWant = row.dataset.aspSoonAsk; saModel.textContent = saWant;
            root.querySelectorAll('[data-asp-soon-ask]').forEach(function (r) { r.setAttribute('aria-expanded', r === row ? 'true' : 'false'); r.classList.toggle('is-asked', r === row); });
            sa.hidden = false;
            var held = false; try { held = localStorage.getItem('antaro-next-' + saWant) === '1'; } catch (x) {}
            saFields.hidden = held; saDone.hidden = !held;
            if (!held) setTimeout(function () { saEmail.focus(); }, 60);
          });
        });
        var saPost = function (url, body) { return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' }, body: JSON.stringify(body) }); };
        var saSend = function () {
          var email = saEmail.value.trim(), first = saFirst.value.trim();
          saNote.textContent = saConsent; saNote.removeAttribute('data-error'); saEmail.removeAttribute('aria-invalid');
          if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { saEmail.setAttribute('aria-invalid', 'true'); saNote.textContent = 'Please enter a valid email address.'; saNote.setAttribute('data-error', ''); saEmail.focus(); return; }
          saGo.disabled = true;
          var q = '?company_id=' + encodeURIComponent(sa.dataset.company), kb = 'https://a.klaviyo.com/client/';
          var colour = colourIdx > -1 ? (selected()[colourIdx] || '') : '';
          var prof = { data: { type: 'profile', attributes: { email: email, properties: { 'Next iPhone interest': saWant, 'Core Case colour': colour } } } };
          if (first) prof.data.attributes.first_name = first;
          saPost(kb + 'profiles/' + q, prof).catch(function () {}).then(function () {
            return saPost(kb + 'subscriptions/' + q, { data: { type: 'subscription', attributes: { custom_source: sa.dataset.source,
              profile: { data: { type: 'profile', attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } },
              relationships: { list: { data: { type: 'list', id: sa.dataset.list } } } } });
          }).then(function (res) {
            if (!res || !res.ok) throw new Error('subscribe');
            try { localStorage.setItem('antaro-next-' + saWant, '1'); } catch (x) {}
            saFields.hidden = true; saDone.hidden = false;
          }).catch(function () {
            saNote.textContent = 'Something went wrong. Please try again.'; saNote.setAttribute('data-error', '');
          }).then(function () { saGo.disabled = false; });
        };
        saGo.addEventListener('click', saSend);
        saEmail.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); saSend(); } });
      }

      // v20: coming-soon products: "Tell me when it lands" adds the person to a Klaviyo list,
      // with the product and the colour they were looking at. Remembered on this browser.
      var nform = root.querySelector('[data-asp-notify]');
      if (nform) {
        var ndone = root.querySelector('[data-asp-notify-done]');
        var nnote = nform.querySelector('[data-asp-notify-note]');
        var nlabel = nform.querySelector('[data-asp-notify-label]');
        var nbtn = nform.querySelector('button');
        var nkey = 'antaro-notify-' + nform.dataset.handle;
        var nbase = nlabel.textContent, nconsent = nnote.textContent, ndefault = nbase;
        // v80: the button names the colour being looked at ("Tell me when it lands in Cream").
        var nsync = function () {
          var ci = colourFs && colourFs.querySelector('input:checked');
          ndefault = ci ? nbase + ' in ' + ci.value : nbase;
          if (!nbtn.disabled) nlabel.textContent = ndefault;
        };
        if (colourFs) colourFs.querySelectorAll('[data-asp-value]').forEach(function (i) { i.addEventListener('change', nsync); });
        nsync();
        try { if (localStorage.getItem(nkey) === '1') { nform.hidden = true; ndone.hidden = false; } } catch (x) {}
        var npost = function (url, body) { return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' }, body: JSON.stringify(body) }); };
        nform.addEventListener('submit', function (e) {
          e.preventDefault();
          var email = nform.email.value.trim(), first = nform.first_name.value.trim();
          nform.email.removeAttribute('aria-invalid'); nnote.removeAttribute('data-error'); nnote.textContent = nconsent;
          if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
            nform.email.setAttribute('aria-invalid', 'true'); nnote.textContent = 'Please enter a valid email address.'; nnote.setAttribute('data-error', ''); nform.email.focus(); return;
          }
          nbtn.disabled = true; nlabel.textContent = 'Adding you to the list…';
          var q = '?company_id=' + encodeURIComponent(nform.dataset.company), kbase = 'https://a.klaviyo.com/client/';
          var colour = (cur && cur.title) || '';
          var prof = { data: { type: 'profile', attributes: { email: email, properties: { 'Coming soon interest': nform.dataset.handle, 'Coming soon colour': colour } } } };
          if (first) prof.data.attributes.first_name = first;
          npost(kbase + 'profiles/' + q, prof).catch(function () {}).then(function () {
            return npost(kbase + 'subscriptions/' + q, { data: { type: 'subscription', attributes: { custom_source: nform.dataset.source,
              profile: { data: { type: 'profile', attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } },
              relationships: { list: { data: { type: 'list', id: nform.dataset.list } } } } });
          }).then(function (res) {
            if (!res || !res.ok) throw new Error('subscribe');
            nform.hidden = true; ndone.hidden = false; ndone.focus();
            try { localStorage.setItem(nkey, '1'); } catch (x) {}
          }).catch(function () {
            nbtn.disabled = false; nlabel.textContent = ndefault;
            nnote.textContent = 'Something went wrong. Please try again in a moment.'; nnote.setAttribute('data-error', '');
          });
        });
      }

      var routeEl = root.querySelector('[data-asp-route]');
      var route = routeEl ? JSON.parse(routeEl.textContent) : { items: [] };
      var done = root.querySelector('[data-asp-done]');
      var nextLink = root.querySelector('[data-asp-next]');
      var nextText = root.querySelector('[data-asp-next-text]');
      var count = root.querySelector('[data-asp-count]');
      var err = root.querySelector('[data-asp-err]');
      var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var busy = false;

      function showDone(cart, justAdded) {
        if (!done) return;
        if (count && cart) count.textContent = cart.item_count;
        if (justAdded && nextLink && cart) {
          var inCart = cart.items.map(function (i) { return String(i.product_id); });
          var n = route.items.filter(function (p) { return inCart.indexOf(String(p.id)) === -1; })[0];
          if (n) { nextLink.href = n.url; nextText.textContent = route.next + ': ' + n.name; }
          else { nextLink.href = route.backUrl; nextText.textContent = route.back; }
          nextLink.hidden = false;
        }
        done.hidden = false;
      }
      if (form && add) form.addEventListener('submit', function (e) {
        if (!window.fetch) return;
        e.preventDefault();
        if (busy || add.disabled) return;
        busy = true; add.disabled = true;
        var sent = false;
        if (err) err.hidden = true;
        fetch(base + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: +idInput.value, quantity: 1 }] })
        }).then(function (r) {
          sent = true;
          return r.json().then(function (j) { if (!r.ok) { var x = new Error('add'); x.msg = j && (j.description || j.message); throw x; } return fetch(base + 'cart.js'); });
        }).then(function (r) { return r.json(); })
          .then(function (cart) {
            document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: root.id, data: { itemCount: cart.item_count } } }));
            showDone(cart, true);
            addLabel.textContent = route.added || addText;
            setTimeout(function () { busy = false; add.disabled = !(cur && cur.available); addLabel.textContent = cur && cur.available ? addText : soldText; }, 2400);
          })
          .catch(function (x) {
            busy = false; add.disabled = !(cur && cur.available);
            if (x && x.msg && err) { err.textContent = x.msg; err.hidden = false; return; }
            if (!sent) form.submit(); else location.href = base + 'cart';
          });
      });
      window.addEventListener('pageshow', function (e) {
        if (!e.persisted || !done) return;
        fetch(base + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          var here = cart.items.some(function (i) { return i.product_id === product.id; });
          if (here) showDone(cart, false); else { done.hidden = true; if (nextLink) nextLink.hidden = true; }
        }).catch(function () {});
      });
    }
    function all() { document.querySelectorAll('[data-asp]').forEach(boot); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
    document.addEventListener('shopify:section:load', function (e) { boot(e.target.querySelector('[data-asp]')); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["antaro-store"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // London sunrise and sunset by month (approximate, local time) for the sign's after-dark look.
    var SUN = [[8,16.5],[7.5,17.3],[6.5,18.2],[6.3,19.9],[5.4,20.7],[4.8,21.3],[5.1,21.2],[5.8,20.4],[6.6,19.3],[7.3,18.2],[7.2,16.4],[8,15.9]];
    function londonNow() {
      var p = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', month: 'numeric', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' }).formatToParts(new Date());
      var g = function (t) { for (var i = 0; i < p.length; i++) if (p[i].type === t) return +p[i].value; return 0; };
      return { m: g('month') - 1, h: g('hour') + g('minute') / 60 };
    }
    function evening(root) {
      // v52 · Evening light: after sunset in London the shelves warm up (?evening=1 / ?evening=0 to preview).
      var n = londonNow(), night = n.h < SUN[n.m][0] || n.h >= SUN[n.m][1];
      var q = /[?&]evening=(1|0)/.exec(location.search); if (q) night = q[1] === '1';
      root.classList.toggle('is-evening', night);
    }
    function clock(d) { try { return new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', hour: 'numeric', minute: '2-digit', hour12: true }).format(d).replace(' ', '').toLowerCase(); } catch (e) { return ''; } }
    function membersHour(root) {
      // v52 · Members' hour: shown only between start and end; the piece's buy panel only for listed standings.
      var b = root.querySelector('[data-ast-mh]'), cards = root.querySelectorAll('[data-ast-mhc]');
      if (!b && !cards.length) return;
      var st = Date.parse((b || cards[0]).dataset.start), en = Date.parse((b || cards[0]).dataset.end), now = Date.now();
      var live = !isNaN(st) && !isNaN(en) && now >= st && now < en;
      if (b) {
        b.hidden = !live;
        var left = b.querySelector('[data-ast-mh-left]');
        if (left && live) { var m = Math.max(1, Math.round((en - now) / 60000)); left.textContent = b.classList.contains('is-yours') ? (m >= 60 ? Math.floor(m / 60) + ' hr ' + (m % 60) + ' min left' : m + ' min left') : 'Opens to all at ' + clock(new Date(en)); }
      }
      cards.forEach(function (c) { c.hidden = !live; var w = c.querySelector('[data-ast-mhc-when]'); if (w) w.textContent = 'Opens to all at ' + clock(new Date(en)); });
    }
    function sign(root) {
      evening(root); membersHour(root);
      var s = root.querySelector('[data-ast-sign]'); if (!s) return;
      var n = londonNow(), night = n.h < SUN[n.m][0] || n.h >= SUN[n.m][1];
      s.classList.toggle('is-night', night);
      var sub = s.querySelector('[data-ast-sign-sub]'); if (sub) sub.textContent = night ? s.dataset.night : s.dataset.day;
    }
    function flips(root) {
      root.querySelectorAll('[data-ast-flip]').forEach(function (b) {
        if (b.dataset.astReady) return; b.dataset.astReady = '1';
        b.addEventListener('click', function () { b.setAttribute('aria-pressed', String(b.getAttribute('aria-pressed') !== 'true')); });
      });
    }
    function live(root) {
      var els = root.querySelectorAll('[data-ast-live]'); if (!els.length || !window.fetch) return;
      var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      function refresh() {
        if (document.hidden) return;
        els.forEach(function (el) {
          fetch(base + 'products/' + el.dataset.astLive + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
            if (!p) return;
            var out = !p.available, txt = el.querySelector('span');
            el.classList.toggle('is-out', out);
            if (out) { el.classList.remove('is-low'); if (txt) txt.textContent = el.dataset.out; }
            else if (!el.classList.contains('is-low') && txt) txt.textContent = el.dataset.in;
          }).catch(function () {});
        });
      }
      setInterval(refresh, 60000);
      document.addEventListener('visibilitychange', function () { if (!document.hidden) refresh(); });
    }
    function boot(root) { if (!root) return; sign(root); flips(root); if (!root.dataset.astLiveOn) { root.dataset.astLiveOn = '1'; live(root); setInterval(function () { sign(root); }, 300000); setInterval(function () { membersHour(root); }, 30000); } }
    function all() { document.querySelectorAll('[data-ast]').forEach(boot); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
    document.addEventListener('shopify:section:load', function (e) { boot(e.target.querySelector('[data-ast]')); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["antaro-weekend-story"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function boot(root) {
      if (!root || root.dataset.wtsReady) return; root.dataset.wtsReady = '1';
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var hero = root.querySelector('[data-wts-hero]'), heroImg = hero && hero.querySelector('.wts-hero__img'), heroCopy = hero && hero.querySelector('.wts-hero__copy');
      var walk = root.querySelector('[data-wts-walk]'), lis = walk ? walk.querySelectorAll('li') : [];
      var detail = root.querySelector('[data-wts-detail]'), dImgs = detail ? detail.querySelectorAll('.wts-detail__frames img') : [], dLis = detail ? detail.querySelectorAll('li') : [];
      var fin = root.querySelector('[data-wts-finish]'), black = fin && fin.querySelector('.wts-finish__black'), seam = fin && fin.querySelector('.wts-finish__seam');
      var swC = fin && fin.querySelector('[data-wts-sw="cream"]'), swB = fin && fin.querySelector('[data-wts-sw="black"]');
      var legs = root.querySelectorAll('.wts-leg__ph img'), manual = null;

      // On foot: the burst frames, drawn on a canvas and scrubbed by scroll, settling quickly onto each frame.
      var cv = root.querySelector('[data-wts-canvas]'), ctx = cv && cv.getContext('2d'), frames = [], target = 0, current = 0, running = false, last = -1;
      try { JSON.parse(root.querySelector('[data-wts-frames]').textContent).forEach(function (u) { if (!u) return; var im = new Image(); im.decoding = 'async'; im.src = u; im.onload = function () { draw(current, true); }; frames.push(im); }); } catch (e) {}
      var N = frames.length;
      function size() { if (!cv) return; var r = cv.getBoundingClientRect(), d = Math.min(2, window.devicePixelRatio || 1); cv.width = Math.round(r.width * d); cv.height = Math.round(r.height * d); }
      function ok(im) { return im && im.complete && im.naturalWidth; }
      function draw(pos, force) {
        if (!ctx || !N) return; var i = Math.min(N - 1, Math.max(0, Math.round(pos)));
        if (!force && i === last) return; var im = ok(frames[i]) ? frames[i] : null;
        if (!im) { for (var k = 0; k < N; k++) if (ok(frames[k])) { im = frames[k]; break; } if (!im) return; }
        last = i; var cw = cv.width, ch = cv.height, s = Math.max(cw / im.naturalWidth, ch / im.naturalHeight), w = im.naturalWidth * s, h = im.naturalHeight * s;
        ctx.fillStyle = '#000'; ctx.fillRect(0, 0, cw, ch); ctx.drawImage(im, (cw - w) * (cw > ch ? .62 : .5), (ch - h) / 2, w, h);
      }
      function step() { current += (target - current) * .25; if (Math.abs(target - current) < .01) { current = target; running = false; draw(current); return; } draw(current); requestAnimationFrame(step); }
      function kick() { if (!running) { running = true; requestAnimationFrame(step); } }

      function prog(el) { if (!el) return 0; var r = el.getBoundingClientRect(), span = el.offsetHeight - window.innerHeight; return span > 0 ? Math.min(1, Math.max(0, -r.top / span)) : 0; }
      function setWipe(p) {
        if (!black) return; black.style.setProperty('--wipe', p.toFixed(2) + '%'); seam.style.left = p.toFixed(2) + '%'; seam.style.opacity = (p > .5 && p < 99.5) ? .7 : 0;
        var isB = p < 50; swB.classList.toggle('is-on', isB); swC.classList.toggle('is-on', !isB); swB.setAttribute('aria-pressed', String(isB)); swC.setAttribute('aria-pressed', String(!isB));
      }
      if (swC) swC.addEventListener('click', function () { manual = 100; fin.classList.add('is-manual'); setWipe(100); });
      if (swB) swB.addEventListener('click', function () { manual = 0; fin.classList.add('is-manual'); setWipe(0); });

      var ticking = false;
      function frame() {
        ticking = false;
        var p = prog(hero);
        if (!reduce && heroImg) {
          // The opening: close-up of the wordmark and handle, a dip to dark, the bag, then a slow pull-back to the setting.
          var cl = function (v) { return Math.min(1, Math.max(0, v)); }, ease = function (v) { return v < .5 ? 2 * v * v : 1 - Math.pow(-2 * v + 2, 2) / 2; };
          var hasClose = !!hero.querySelector('.wts-hero__close');
          var out = cl((p - .2) / .08), fade = hasClose ? cl((p - .27) / .09) : 1, pull = cl((p - (hasClose ? .36 : 0)) / (hasClose ? .54 : .9));
          hero.style.setProperty('--zd', (1.08 - .06 * cl(p / .3)).toFixed(4)); hero.style.setProperty('--od', (1 - out).toFixed(3));
          hero.style.setProperty('--ow', fade.toFixed(3)); hero.style.setProperty('--zw', (1.9 - .9 * ease(pull)).toFixed(4));
          hero.style.setProperty('--b', (.8 + .06 * pull).toFixed(3)); hero.style.setProperty('--oc', cl((p - .8) / .12).toFixed(3));
          heroCopy.style.setProperty('--ty', (-cl(p / .3) * 6) + 'vh'); heroCopy.style.opacity = (1 - cl((p - .1) / .1)).toFixed(3);
          legs.forEach(function (img) { var r = img.parentNode.getBoundingClientRect(); var c = (r.top + r.height / 2 - window.innerHeight / 2) / window.innerHeight; img.style.setProperty('--py', (-6 - c * 8).toFixed(2) + '%'); });
        }
        var w = prog(walk); target = reduce ? Math.floor(N / 2) : w * (N - 1); kick();
        var ws = w < .34 ? 0 : w < .67 ? 1 : 2; lis.forEach(function (li, i) { li.classList.toggle('is-on', i === ws); });
        var d = prog(detail), di = d < .34 ? 0 : d < .67 ? 1 : 2;
        dImgs.forEach(function (im, i) { im.classList.toggle('is-on', i === di); }); dLis.forEach(function (li, i) { li.classList.toggle('is-on', i === di); });
        if (fin) {
          var fr = fin.getBoundingClientRect(); if (fr.bottom < 0 || fr.top > window.innerHeight) { manual = null; fin.classList.remove('is-manual'); }
          if (manual === null) setWipe(100 - Math.min(1, Math.max(0, (prog(fin) - .2) / .55)) * 100);
        }
      }
      function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', function () { size(); draw(current, true); onScroll(); });
      size(); frame();

      // The sign-up: the same Weekend Tote list as the product page, remembered on this browser.
      var form = root.querySelector('[data-wts-notify]');
      if (form) {
        var done = root.querySelector('[data-wts-done]'), note = root.querySelector('[data-wts-note]'), label = form.querySelector('[data-wts-label]'), btn = form.querySelector('button');
        var key = 'antaro-notify-' + form.dataset.handle, consent = note.textContent;
        try { if (localStorage.getItem(key) === '1') { form.hidden = true; note.hidden = true; done.hidden = false; } } catch (x) {}
        var post = function (url, body) { return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' }, body: JSON.stringify(body) }); };
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var email = form.email.value.trim(); form.email.removeAttribute('aria-invalid'); note.removeAttribute('data-error'); note.textContent = consent;
          if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { form.email.setAttribute('aria-invalid', 'true'); note.textContent = 'Please enter a valid email address.'; note.setAttribute('data-error', ''); form.email.focus(); return; }
          btn.disabled = true; label.textContent = 'Adding you…';
          var q = '?company_id=' + encodeURIComponent(form.dataset.company), base = 'https://a.klaviyo.com/client/';
          post(base + 'profiles/' + q, { data: { type: 'profile', attributes: { email: email, properties: { 'Coming soon interest': form.dataset.handle } } } }).catch(function () {}).then(function () {
            return post(base + 'subscriptions/' + q, { data: { type: 'subscription', attributes: { custom_source: 'The Weekend Tote story · Tell me',
              profile: { data: { type: 'profile', attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } },
              relationships: { list: { data: { type: 'list', id: form.dataset.list } } } } });
          }).then(function (res) {
            if (!res || !res.ok) throw new Error('subscribe');
            form.hidden = true; note.hidden = true; done.hidden = false; done.focus(); try { localStorage.setItem(key, '1'); } catch (x) {}
          }).catch(function () { btn.disabled = false; label.textContent = 'Tell me'; note.textContent = 'Something went wrong. Please try again in a moment.'; note.setAttribute('data-error', ''); });
        });
      }
    }
    function all() { document.querySelectorAll('[data-wts]').forEach(boot); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
    document.addEventListener('shopify:section:load', function (e) { boot(e.target.querySelector('[data-wts]')); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
